// Tabela AUTO-GERADA de tipos-base de atributos IFC por esquema.
// NÃO editar à mão. Regenerar com:
//   node scripts/regen-ifc-attr-types.mjs
//
// Fonte: node_modules/web-ifc/ifc-schema.d.ts (web-ifc, ThatOpen,
// MPL-2.0) para estrutura entidade/atributo/herança; classificação
// INTEGER/BOOLEAN/LOGICAL dos tipos-definidos extraída dos esquemas
// EXPRESS oficiais da especificação IFC (buildingSMART). Ver o
// script gerador e o README para atribuição e licenças.
//
// Cada entrada: ENTIDADE(MAIÚSCULAS) -> { p: parent|null, a: { Atributo:
// categoria } }. Só atributos PRÓPRIOS de tipo primitivo; os herdados
// resolvem-se seguindo `p`. categoria = integer|real|string|boolean|
// logical|enum.

export type IfcAttrSchema = 'IFC2X3' | 'IFC4' | 'IFC4X1' | 'IFC4X2' | 'IFC4X3'

export type AttrBaseType = 'integer' | 'real' | 'string' | 'boolean' | 'logical' | 'enum'

export interface EntityAttrs {
  /** Superclasse (MAIÚSCULAS) para resolver atributos herdados; null na raiz. */
  p: string | null
  /** Atributos próprios de tipo primitivo: nome -> categoria. */
  a: Record<string, AttrBaseType>
}

type Table = Record<string, EntityAttrs>

const T2X3: Table = {
  IFC2DCOMPOSITECURVE:{p:'IFCCOMPOSITECURVE',a:{}},
  IFCACTIONREQUEST:{p:'IFCCONTROL',a:{RequestID:'string'}},
  IFCACTOR:{p:'IFCOBJECT',a:{}},
  IFCACTORROLE:{p:null,a:{Description:'string',Role:'enum',UserDefinedRole:'string'}},
  IFCACTUATORTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCADDRESS:{p:null,a:{Description:'string',Purpose:'enum',UserDefinedPurpose:'string'}},
  IFCAIRTERMINALBOXTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCAIRTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCAIRTOAIRHEATRECOVERYTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCALARMTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCANGULARDIMENSION:{p:'IFCDIMENSIONCURVEDIRECTEDCALLOUT',a:{}},
  IFCANNOTATION:{p:'IFCPRODUCT',a:{}},
  IFCANNOTATIONCURVEOCCURRENCE:{p:'IFCANNOTATIONOCCURRENCE',a:{}},
  IFCANNOTATIONFILLAREA:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCANNOTATIONFILLAREAOCCURRENCE:{p:'IFCANNOTATIONOCCURRENCE',a:{GlobalOrLocal:'enum'}},
  IFCANNOTATIONOCCURRENCE:{p:'IFCSTYLEDITEM',a:{}},
  IFCANNOTATIONSURFACE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCANNOTATIONSURFACEOCCURRENCE:{p:'IFCANNOTATIONOCCURRENCE',a:{}},
  IFCANNOTATIONSYMBOLOCCURRENCE:{p:'IFCANNOTATIONOCCURRENCE',a:{}},
  IFCANNOTATIONTEXTOCCURRENCE:{p:'IFCANNOTATIONOCCURRENCE',a:{}},
  IFCAPPLICATION:{p:null,a:{ApplicationFullName:'string',ApplicationIdentifier:'string',Version:'string'}},
  IFCAPPLIEDVALUE:{p:null,a:{Description:'string',Name:'string'}},
  IFCAPPLIEDVALUERELATIONSHIP:{p:null,a:{ArithmeticOperator:'enum',Description:'string',Name:'string'}},
  IFCAPPROVAL:{p:null,a:{ApprovalLevel:'string',ApprovalQualifier:'string',ApprovalStatus:'string',Description:'string',Identifier:'string',Name:'string'}},
  IFCAPPROVALRELATIONSHIP:{p:null,a:{Description:'string',Name:'string'}},
  IFCARBITRARYCLOSEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCARBITRARYOPENPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCARBITRARYPROFILEDEFWITHVOIDS:{p:'IFCARBITRARYCLOSEDPROFILEDEF',a:{}},
  IFCASSET:{p:'IFCGROUP',a:{AssetID:'string'}},
  IFCASYMMETRICISHAPEPROFILEDEF:{p:'IFCISHAPEPROFILEDEF',a:{CentreOfGravityInY:'real',TopFlangeFilletRadius:'real',TopFlangeThickness:'real',TopFlangeWidth:'real'}},
  IFCAXIS1PLACEMENT:{p:'IFCPLACEMENT',a:{}},
  IFCAXIS2PLACEMENT2D:{p:'IFCPLACEMENT',a:{}},
  IFCAXIS2PLACEMENT3D:{p:'IFCPLACEMENT',a:{}},
  IFCBSPLINECURVE:{p:'IFCBOUNDEDCURVE',a:{CurveForm:'enum'}},
  IFCBEAM:{p:'IFCBUILDINGELEMENT',a:{}},
  IFCBEAMTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCBEZIERCURVE:{p:'IFCBSPLINECURVE',a:{}},
  IFCBLOBTEXTURE:{p:'IFCSURFACETEXTURE',a:{RasterFormat:'string'}},
  IFCBLOCK:{p:'IFCCSGPRIMITIVE3D',a:{XLength:'real',YLength:'real',ZLength:'real'}},
  IFCBOILERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCBOOLEANCLIPPINGRESULT:{p:'IFCBOOLEANRESULT',a:{}},
  IFCBOOLEANRESULT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Operator:'enum'}},
  IFCBOUNDARYCONDITION:{p:null,a:{Name:'string'}},
  IFCBOUNDARYEDGECONDITION:{p:'IFCBOUNDARYCONDITION',a:{LinearStiffnessByLengthX:'real',LinearStiffnessByLengthY:'real',LinearStiffnessByLengthZ:'real',RotationalStiffnessByLengthX:'real',RotationalStiffnessByLengthY:'real',RotationalStiffnessByLengthZ:'real'}},
  IFCBOUNDARYFACECONDITION:{p:'IFCBOUNDARYCONDITION',a:{LinearStiffnessByAreaX:'real',LinearStiffnessByAreaY:'real',LinearStiffnessByAreaZ:'real'}},
  IFCBOUNDARYNODECONDITION:{p:'IFCBOUNDARYCONDITION',a:{LinearStiffnessX:'real',LinearStiffnessY:'real',LinearStiffnessZ:'real',RotationalStiffnessX:'real',RotationalStiffnessY:'real',RotationalStiffnessZ:'real'}},
  IFCBOUNDARYNODECONDITIONWARPING:{p:'IFCBOUNDARYNODECONDITION',a:{WarpingStiffness:'real'}},
  IFCBOUNDEDCURVE:{p:'IFCCURVE',a:{}},
  IFCBOUNDEDSURFACE:{p:'IFCSURFACE',a:{}},
  IFCBOUNDINGBOX:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{XDim:'real',YDim:'real',ZDim:'real'}},
  IFCBOXEDHALFSPACE:{p:'IFCHALFSPACESOLID',a:{}},
  IFCBUILDING:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{ElevationOfRefHeight:'real',ElevationOfTerrain:'real'}},
  IFCBUILDINGELEMENT:{p:'IFCELEMENT',a:{}},
  IFCBUILDINGELEMENTCOMPONENT:{p:'IFCBUILDINGELEMENT',a:{}},
  IFCBUILDINGELEMENTPART:{p:'IFCBUILDINGELEMENTCOMPONENT',a:{}},
  IFCBUILDINGELEMENTPROXY:{p:'IFCBUILDINGELEMENT',a:{CompositionType:'enum'}},
  IFCBUILDINGELEMENTPROXYTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCBUILDINGELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCBUILDINGSTOREY:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{Elevation:'real'}},
  IFCCSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{CentreOfGravityInX:'real',Depth:'real',Girth:'real',InternalFilletRadius:'real',WallThickness:'real',Width:'real'}},
  IFCCABLECARRIERFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCCABLECARRIERSEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCABLESEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCALENDARDATE:{p:null,a:{DayComponent:'integer',MonthComponent:'integer',YearComponent:'integer'}},
  IFCCARTESIANPOINT:{p:'IFCPOINT',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR2D:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR2D',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR3D:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR3D',a:{}},
  IFCCENTERLINEPROFILEDEF:{p:'IFCARBITRARYOPENPROFILEDEF',a:{Thickness:'real'}},
  IFCCHAMFEREDGEFEATURE:{p:'IFCEDGEFEATURE',a:{Height:'real',Width:'real'}},
  IFCCHILLERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCIRCLE:{p:'IFCCONIC',a:{Radius:'real'}},
  IFCCIRCLEHOLLOWPROFILEDEF:{p:'IFCCIRCLEPROFILEDEF',a:{WallThickness:'real'}},
  IFCCIRCLEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Radius:'real'}},
  IFCCLASSIFICATION:{p:null,a:{Edition:'string',Name:'string',Source:'string'}},
  IFCCLASSIFICATIONITEM:{p:null,a:{Title:'string'}},
  IFCCLASSIFICATIONNOTATIONFACET:{p:null,a:{NotationValue:'string'}},
  IFCCLASSIFICATIONREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCCLOSEDSHELL:{p:'IFCCONNECTEDFACESET',a:{}},
  IFCCOILTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOLOURRGB:{p:'IFCCOLOURSPECIFICATION',a:{Blue:'real',Green:'real',Red:'real'}},
  IFCCOLOURSPECIFICATION:{p:null,a:{Name:'string'}},
  IFCCOLUMN:{p:'IFCBUILDINGELEMENT',a:{}},
  IFCCOLUMNTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCOMPLEXPROPERTY:{p:'IFCPROPERTY',a:{UsageName:'string'}},
  IFCCOMPOSITECURVE:{p:'IFCBOUNDEDCURVE',a:{}},
  IFCCOMPOSITECURVESEGMENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Transition:'enum'}},
  IFCCOMPOSITEPROFILEDEF:{p:'IFCPROFILEDEF',a:{Label:'string'}},
  IFCCOMPRESSORTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCONDENSERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCONDITION:{p:'IFCGROUP',a:{}},
  IFCCONDITIONCRITERION:{p:'IFCCONTROL',a:{}},
  IFCCONIC:{p:'IFCCURVE',a:{}},
  IFCCONNECTEDFACESET:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCCONNECTIONCURVEGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONPOINTECCENTRICITY:{p:'IFCCONNECTIONPOINTGEOMETRY',a:{EccentricityInX:'real',EccentricityInY:'real',EccentricityInZ:'real'}},
  IFCCONNECTIONPOINTGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONPORTGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONSURFACEGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONSTRAINT:{p:null,a:{ConstraintGrade:'enum',ConstraintSource:'string',Description:'string',Name:'string',UserDefinedGrade:'string'}},
  IFCCONSTRAINTAGGREGATIONRELATIONSHIP:{p:null,a:{Description:'string',LogicalAggregator:'enum',Name:'string'}},
  IFCCONSTRAINTRELATIONSHIP:{p:null,a:{Description:'string',Name:'string'}},
  IFCCONSTRUCTIONEQUIPMENTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{}},
  IFCCONSTRUCTIONMATERIALRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{UsageRatio:'real'}},
  IFCCONSTRUCTIONPRODUCTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{}},
  IFCCONSTRUCTIONRESOURCE:{p:'IFCRESOURCE',a:{ResourceConsumption:'enum',ResourceGroup:'string',ResourceIdentifier:'string'}},
  IFCCONTEXTDEPENDENTUNIT:{p:'IFCNAMEDUNIT',a:{Name:'string'}},
  IFCCONTROL:{p:'IFCOBJECT',a:{}},
  IFCCONTROLLERTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCONVERSIONBASEDUNIT:{p:'IFCNAMEDUNIT',a:{Name:'string'}},
  IFCCOOLEDBEAMTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOOLINGTOWERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOORDINATEDUNIVERSALTIMEOFFSET:{p:null,a:{HourOffset:'integer',MinuteOffset:'integer',Sense:'enum'}},
  IFCCOSTITEM:{p:'IFCCONTROL',a:{}},
  IFCCOSTSCHEDULE:{p:'IFCCONTROL',a:{ID:'string',PredefinedType:'enum',Status:'string'}},
  IFCCOSTVALUE:{p:'IFCAPPLIEDVALUE',a:{Condition:'string',CostType:'string'}},
  IFCCOVERING:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCCOVERINGTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCRANERAILASHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{BaseDepth1:'real',BaseDepth2:'real',BaseDepth3:'real',BaseWidth2:'real',BaseWidth4:'real',CentreOfGravityInY:'real',HeadDepth2:'real',HeadDepth3:'real',HeadWidth:'real',OverallHeight:'real',Radius:'real',WebThickness:'real'}},
  IFCCRANERAILFSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{BaseDepth1:'real',BaseDepth2:'real',CentreOfGravityInY:'real',HeadDepth2:'real',HeadDepth3:'real',HeadWidth:'real',OverallHeight:'real',Radius:'real',WebThickness:'real'}},
  IFCCREWRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{}},
  IFCCSGPRIMITIVE3D:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCSGSOLID:{p:'IFCSOLIDMODEL',a:{}},
  IFCCURRENCYRELATIONSHIP:{p:null,a:{ExchangeRate:'real'}},
  IFCCURTAINWALL:{p:'IFCBUILDINGELEMENT',a:{}},
  IFCCURTAINWALLTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCURVE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCURVEBOUNDEDPLANE:{p:'IFCBOUNDEDSURFACE',a:{}},
  IFCCURVESTYLE:{p:'IFCPRESENTATIONSTYLE',a:{}},
  IFCCURVESTYLEFONT:{p:null,a:{Name:'string'}},
  IFCCURVESTYLEFONTANDSCALING:{p:null,a:{CurveFontScaling:'real',Name:'string'}},
  IFCCURVESTYLEFONTPATTERN:{p:null,a:{InvisibleSegmentLength:'real',VisibleSegmentLength:'real'}},
  IFCDAMPERTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCDEFINEDSYMBOL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCDERIVEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{Label:'string'}},
  IFCDERIVEDUNIT:{p:null,a:{UnitType:'enum',UserDefinedType:'string'}},
  IFCDIAMETERDIMENSION:{p:'IFCDIMENSIONCURVEDIRECTEDCALLOUT',a:{}},
  IFCDIMENSIONCALLOUTRELATIONSHIP:{p:'IFCDRAUGHTINGCALLOUTRELATIONSHIP',a:{}},
  IFCDIMENSIONCURVE:{p:'IFCANNOTATIONCURVEOCCURRENCE',a:{}},
  IFCDIMENSIONCURVEDIRECTEDCALLOUT:{p:'IFCDRAUGHTINGCALLOUT',a:{}},
  IFCDIMENSIONCURVETERMINATOR:{p:'IFCTERMINATORSYMBOL',a:{Role:'enum'}},
  IFCDIMENSIONPAIR:{p:'IFCDRAUGHTINGCALLOUTRELATIONSHIP',a:{}},
  IFCDIRECTION:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCDISCRETEACCESSORY:{p:'IFCELEMENTCOMPONENT',a:{}},
  IFCDISCRETEACCESSORYTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{}},
  IFCDISTRIBUTIONCHAMBERELEMENT:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCDISTRIBUTIONCHAMBERELEMENTTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONCONTROLELEMENT:{p:'IFCDISTRIBUTIONELEMENT',a:{ControlElementId:'string'}},
  IFCDISTRIBUTIONCONTROLELEMENTTYPE:{p:'IFCDISTRIBUTIONELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONELEMENT:{p:'IFCELEMENT',a:{}},
  IFCDISTRIBUTIONELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONFLOWELEMENT:{p:'IFCDISTRIBUTIONELEMENT',a:{}},
  IFCDISTRIBUTIONFLOWELEMENTTYPE:{p:'IFCDISTRIBUTIONELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONPORT:{p:'IFCPORT',a:{FlowDirection:'enum'}},
  IFCDOCUMENTELECTRONICFORMAT:{p:null,a:{FileExtension:'string',MimeContentType:'string',MimeSubtype:'string'}},
  IFCDOCUMENTINFORMATION:{p:null,a:{Confidentiality:'enum',Description:'string',DocumentId:'string',IntendedUse:'string',Name:'string',Purpose:'string',Revision:'string',Scope:'string',Status:'enum'}},
  IFCDOCUMENTINFORMATIONRELATIONSHIP:{p:null,a:{RelationshipType:'string'}},
  IFCDOCUMENTREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCDOOR:{p:'IFCBUILDINGELEMENT',a:{OverallHeight:'real',OverallWidth:'real'}},
  IFCDOORLININGPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{CasingDepth:'real',CasingThickness:'real',LiningDepth:'real',LiningOffset:'real',LiningThickness:'real',ThresholdDepth:'real',ThresholdOffset:'real',ThresholdThickness:'real',TransomOffset:'real',TransomThickness:'real'}},
  IFCDOORPANELPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{PanelDepth:'real',PanelOperation:'enum',PanelPosition:'enum',PanelWidth:'real'}},
  IFCDOORSTYLE:{p:'IFCTYPEPRODUCT',a:{ConstructionType:'enum',OperationType:'enum'}},
  IFCDRAUGHTINGCALLOUT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCDRAUGHTINGCALLOUTRELATIONSHIP:{p:null,a:{Description:'string',Name:'string'}},
  IFCDRAUGHTINGPREDEFINEDCOLOUR:{p:'IFCPREDEFINEDCOLOUR',a:{}},
  IFCDRAUGHTINGPREDEFINEDCURVEFONT:{p:'IFCPREDEFINEDCURVEFONT',a:{}},
  IFCDRAUGHTINGPREDEFINEDTEXTFONT:{p:'IFCPREDEFINEDTEXTFONT',a:{}},
  IFCDUCTFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCDUCTSEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCDUCTSILENCERTYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEDGE:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCEDGECURVE:{p:'IFCEDGE',a:{}},
  IFCEDGEFEATURE:{p:'IFCFEATUREELEMENTSUBTRACTION',a:{FeatureLength:'real'}},
  IFCEDGELOOP:{p:'IFCLOOP',a:{}},
  IFCELECTRICAPPLIANCETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICDISTRIBUTIONPOINT:{p:'IFCFLOWCONTROLLER',a:{DistributionPointFunction:'enum',UserDefinedFunction:'string'}},
  IFCELECTRICFLOWSTORAGEDEVICETYPE:{p:'IFCFLOWSTORAGEDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICGENERATORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICHEATERTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICMOTORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICTIMECONTROLTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICALBASEPROPERTIES:{p:'IFCENERGYPROPERTIES',a:{ElectricCurrentType:'enum',FullLoadCurrent:'real',InputFrequency:'real',InputVoltage:'real',MaximumPowerInput:'real',MinimumCircuitCurrent:'real',RatedPowerInput:'real'}},
  IFCELECTRICALCIRCUIT:{p:'IFCSYSTEM',a:{}},
  IFCELECTRICALELEMENT:{p:'IFCELEMENT',a:{}},
  IFCELEMENT:{p:'IFCPRODUCT',a:{Tag:'string'}},
  IFCELEMENTASSEMBLY:{p:'IFCELEMENT',a:{AssemblyPlace:'enum',PredefinedType:'enum'}},
  IFCELEMENTCOMPONENT:{p:'IFCELEMENT',a:{}},
  IFCELEMENTCOMPONENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCELEMENTQUANTITY:{p:'IFCPROPERTYSETDEFINITION',a:{MethodOfMeasurement:'string'}},
  IFCELEMENTTYPE:{p:'IFCTYPEPRODUCT',a:{ElementType:'string'}},
  IFCELEMENTARYSURFACE:{p:'IFCSURFACE',a:{}},
  IFCELLIPSE:{p:'IFCCONIC',a:{SemiAxis1:'real',SemiAxis2:'real'}},
  IFCELLIPSEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{SemiAxis1:'real',SemiAxis2:'real'}},
  IFCENERGYCONVERSIONDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCENERGYCONVERSIONDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCENERGYPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{EnergySequence:'enum',UserDefinedEnergySequence:'string'}},
  IFCENVIRONMENTALIMPACTVALUE:{p:'IFCAPPLIEDVALUE',a:{Category:'enum',ImpactType:'string',UserDefinedCategory:'string'}},
  IFCEQUIPMENTELEMENT:{p:'IFCELEMENT',a:{}},
  IFCEQUIPMENTSTANDARD:{p:'IFCCONTROL',a:{}},
  IFCEVAPORATIVECOOLERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEVAPORATORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEXTENDEDMATERIALPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{Description:'string',Name:'string'}},
  IFCEXTERNALREFERENCE:{p:null,a:{ItemReference:'string',Location:'string',Name:'string'}},
  IFCEXTERNALLYDEFINEDHATCHSTYLE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTERNALLYDEFINEDSURFACESTYLE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTERNALLYDEFINEDSYMBOL:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTERNALLYDEFINEDTEXTFONT:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTRUDEDAREASOLID:{p:'IFCSWEPTAREASOLID',a:{Depth:'real'}},
  IFCFACE:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCFACEBASEDSURFACEMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCFACEBOUND:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCFACEOUTERBOUND:{p:'IFCFACEBOUND',a:{}},
  IFCFACESURFACE:{p:'IFCFACE',a:{}},
  IFCFACETEDBREP:{p:'IFCMANIFOLDSOLIDBREP',a:{}},
  IFCFACETEDBREPWITHVOIDS:{p:'IFCMANIFOLDSOLIDBREP',a:{}},
  IFCFAILURECONNECTIONCONDITION:{p:'IFCSTRUCTURALCONNECTIONCONDITION',a:{CompressionFailureX:'real',CompressionFailureY:'real',CompressionFailureZ:'real',TensionFailureX:'real',TensionFailureY:'real',TensionFailureZ:'real'}},
  IFCFANTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCFASTENER:{p:'IFCELEMENTCOMPONENT',a:{}},
  IFCFASTENERTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{}},
  IFCFEATUREELEMENT:{p:'IFCELEMENT',a:{}},
  IFCFEATUREELEMENTADDITION:{p:'IFCFEATUREELEMENT',a:{}},
  IFCFEATUREELEMENTSUBTRACTION:{p:'IFCFEATUREELEMENT',a:{}},
  IFCFILLAREASTYLE:{p:'IFCPRESENTATIONSTYLE',a:{}},
  IFCFILLAREASTYLEHATCHING:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{HatchLineAngle:'real'}},
  IFCFILLAREASTYLETILESYMBOLWITHSTYLE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCFILLAREASTYLETILES:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{TilingScale:'real'}},
  IFCFILTERTYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCFIRESUPPRESSIONTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCFLOWCONTROLLER:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWCONTROLLERTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWFITTING:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWFITTINGTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWINSTRUMENTTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCFLOWMETERTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCFLOWMOVINGDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWMOVINGDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWSEGMENT:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWSEGMENTTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWSTORAGEDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWSTORAGEDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWTERMINAL:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWTERMINALTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWTREATMENTDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWTREATMENTDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLUIDFLOWPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{FlowConditionSingleValue:'real',PressureSingleValue:'real',PropertySource:'enum',TemperatureSingleValue:'real',UserDefinedPropertySource:'string',VelocitySingleValue:'real',WetBulbTemperatureSingleValue:'real'}},
  IFCFOOTING:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCFUELPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{CarbonContent:'real',CombustionTemperature:'real',HigherHeatingValue:'real',LowerHeatingValue:'real'}},
  IFCFURNISHINGELEMENT:{p:'IFCELEMENT',a:{}},
  IFCFURNISHINGELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCFURNITURESTANDARD:{p:'IFCCONTROL',a:{}},
  IFCFURNITURETYPE:{p:'IFCFURNISHINGELEMENTTYPE',a:{AssemblyPlace:'enum'}},
  IFCGASTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCGENERALMATERIALPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{MassDensity:'real',MolecularWeight:'real',Porosity:'real'}},
  IFCGENERALPROFILEPROPERTIES:{p:'IFCPROFILEPROPERTIES',a:{CrossSectionArea:'real',MaximumPlateThickness:'real',MinimumPlateThickness:'real',Perimeter:'real',PhysicalWeight:'real'}},
  IFCGEOMETRICCURVESET:{p:'IFCGEOMETRICSET',a:{}},
  IFCGEOMETRICREPRESENTATIONCONTEXT:{p:'IFCREPRESENTATIONCONTEXT',a:{CoordinateSpaceDimension:'integer'}},
  IFCGEOMETRICREPRESENTATIONITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCGEOMETRICREPRESENTATIONSUBCONTEXT:{p:'IFCGEOMETRICREPRESENTATIONCONTEXT',a:{TargetScale:'real',TargetView:'enum',UserDefinedTargetView:'string'}},
  IFCGEOMETRICSET:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCGRID:{p:'IFCPRODUCT',a:{}},
  IFCGRIDAXIS:{p:null,a:{AxisTag:'string',SameSense:'boolean'}},
  IFCGRIDPLACEMENT:{p:'IFCOBJECTPLACEMENT',a:{}},
  IFCGROUP:{p:'IFCOBJECT',a:{}},
  IFCHALFSPACESOLID:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCHEATEXCHANGERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCHUMIDIFIERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCHYGROSCOPICMATERIALPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{IsothermalMoistureCapacity:'real',LowerVaporResistanceFactor:'real',MoistureDiffusivity:'real',UpperVaporResistanceFactor:'real',VaporPermeability:'real'}},
  IFCISHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{FilletRadius:'real',FlangeThickness:'real',OverallDepth:'real',OverallWidth:'real',WebThickness:'real'}},
  IFCIMAGETEXTURE:{p:'IFCSURFACETEXTURE',a:{UrlReference:'string'}},
  IFCINVENTORY:{p:'IFCGROUP',a:{InventoryType:'enum'}},
  IFCIRREGULARTIMESERIES:{p:'IFCTIMESERIES',a:{}},
  IFCJUNCTIONBOXTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCLSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{CentreOfGravityInX:'real',CentreOfGravityInY:'real',Depth:'real',EdgeRadius:'real',FilletRadius:'real',LegSlope:'real',Thickness:'real',Width:'real'}},
  IFCLABORRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{SkillSet:'string'}},
  IFCLAMPTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCLIBRARYINFORMATION:{p:null,a:{Name:'string',Version:'string'}},
  IFCLIBRARYREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCLIGHTDISTRIBUTIONDATA:{p:null,a:{MainPlaneAngle:'real'}},
  IFCLIGHTFIXTURETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCLIGHTINTENSITYDISTRIBUTION:{p:null,a:{LightDistributionCurve:'enum'}},
  IFCLIGHTSOURCE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{AmbientIntensity:'real',Intensity:'real',Name:'string'}},
  IFCLIGHTSOURCEAMBIENT:{p:'IFCLIGHTSOURCE',a:{}},
  IFCLIGHTSOURCEDIRECTIONAL:{p:'IFCLIGHTSOURCE',a:{}},
  IFCLIGHTSOURCEGONIOMETRIC:{p:'IFCLIGHTSOURCE',a:{ColourTemperature:'real',LightEmissionSource:'enum',LuminousFlux:'real'}},
  IFCLIGHTSOURCEPOSITIONAL:{p:'IFCLIGHTSOURCE',a:{ConstantAttenuation:'real',DistanceAttenuation:'real',QuadricAttenuation:'real',Radius:'real'}},
  IFCLIGHTSOURCESPOT:{p:'IFCLIGHTSOURCEPOSITIONAL',a:{BeamWidthAngle:'real',ConcentrationExponent:'real',SpreadAngle:'real'}},
  IFCLINE:{p:'IFCCURVE',a:{}},
  IFCLINEARDIMENSION:{p:'IFCDIMENSIONCURVEDIRECTEDCALLOUT',a:{}},
  IFCLOCALPLACEMENT:{p:'IFCOBJECTPLACEMENT',a:{}},
  IFCLOCALTIME:{p:null,a:{DaylightSavingOffset:'integer',HourComponent:'integer',MinuteComponent:'integer',SecondComponent:'real'}},
  IFCLOOP:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCMANIFOLDSOLIDBREP:{p:'IFCSOLIDMODEL',a:{}},
  IFCMAPPEDITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCMATERIAL:{p:null,a:{Name:'string'}},
  IFCMATERIALDEFINITIONREPRESENTATION:{p:'IFCPRODUCTREPRESENTATION',a:{}},
  IFCMATERIALLAYER:{p:null,a:{IsVentilated:'logical',LayerThickness:'real'}},
  IFCMATERIALLAYERSET:{p:null,a:{LayerSetName:'string'}},
  IFCMATERIALLAYERSETUSAGE:{p:null,a:{DirectionSense:'enum',LayerSetDirection:'enum',OffsetFromReferenceLine:'real'}},
  IFCMECHANICALCONCRETEMATERIALPROPERTIES:{p:'IFCMECHANICALMATERIALPROPERTIES',a:{AdmixturesDescription:'string',CompressiveStrength:'real',MaxAggregateSize:'real',ProtectivePoreRatio:'real',WaterImpermeability:'string',Workability:'string'}},
  IFCMECHANICALFASTENER:{p:'IFCFASTENER',a:{NominalDiameter:'real',NominalLength:'real'}},
  IFCMECHANICALFASTENERTYPE:{p:'IFCFASTENERTYPE',a:{}},
  IFCMECHANICALMATERIALPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{DynamicViscosity:'real',PoissonRatio:'real',ShearModulus:'real',ThermalExpansionCoefficient:'real',YoungModulus:'real'}},
  IFCMECHANICALSTEELMATERIALPROPERTIES:{p:'IFCMECHANICALMATERIALPROPERTIES',a:{HardeningModule:'real',PlasticStrain:'real',ProportionalStress:'real',UltimateStrain:'real',UltimateStress:'real',YieldStress:'real'}},
  IFCMEMBER:{p:'IFCBUILDINGELEMENT',a:{}},
  IFCMEMBERTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCMETRIC:{p:'IFCCONSTRAINT',a:{Benchmark:'enum',ValueSource:'string'}},
  IFCMONETARYUNIT:{p:null,a:{Currency:'enum'}},
  IFCMOTORCONNECTIONTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCMOVE:{p:'IFCTASK',a:{}},
  IFCNAMEDUNIT:{p:null,a:{UnitType:'enum'}},
  IFCOBJECT:{p:'IFCOBJECTDEFINITION',a:{ObjectType:'string'}},
  IFCOBJECTDEFINITION:{p:'IFCROOT',a:{}},
  IFCOBJECTIVE:{p:'IFCCONSTRAINT',a:{ObjectiveQualifier:'enum',UserDefinedQualifier:'string'}},
  IFCOCCUPANT:{p:'IFCACTOR',a:{PredefinedType:'enum'}},
  IFCOFFSETCURVE2D:{p:'IFCCURVE',a:{Distance:'real'}},
  IFCOFFSETCURVE3D:{p:'IFCCURVE',a:{Distance:'real'}},
  IFCONEDIRECTIONREPEATFACTOR:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCOPENSHELL:{p:'IFCCONNECTEDFACESET',a:{}},
  IFCOPENINGELEMENT:{p:'IFCFEATUREELEMENTSUBTRACTION',a:{}},
  IFCOPTICALMATERIALPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{SolarReflectanceBack:'real',SolarReflectanceFront:'real',SolarTransmittance:'real',ThermalIrEmissivityBack:'real',ThermalIrEmissivityFront:'real',ThermalIrTransmittance:'real',VisibleReflectanceBack:'real',VisibleReflectanceFront:'real',VisibleTransmittance:'real'}},
  IFCORDERACTION:{p:'IFCTASK',a:{ActionID:'string'}},
  IFCORGANIZATION:{p:null,a:{Description:'string',Id:'string',Name:'string'}},
  IFCORGANIZATIONRELATIONSHIP:{p:null,a:{Description:'string',Name:'string'}},
  IFCORIENTEDEDGE:{p:'IFCEDGE',a:{}},
  IFCOUTLETTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCOWNERHISTORY:{p:null,a:{ChangeAction:'enum',CreationDate:'integer',LastModifiedDate:'integer',State:'enum'}},
  IFCPARAMETERIZEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCPATH:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCPERFORMANCEHISTORY:{p:'IFCCONTROL',a:{LifeCyclePhase:'string'}},
  IFCPERMEABLECOVERINGPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{FrameDepth:'real',FrameThickness:'real',OperationType:'enum',PanelPosition:'enum'}},
  IFCPERMIT:{p:'IFCCONTROL',a:{PermitID:'string'}},
  IFCPERSON:{p:null,a:{FamilyName:'string',GivenName:'string',Id:'string'}},
  IFCPHYSICALCOMPLEXQUANTITY:{p:'IFCPHYSICALQUANTITY',a:{Discrimination:'string',Quality:'string',Usage:'string'}},
  IFCPHYSICALQUANTITY:{p:null,a:{Description:'string',Name:'string'}},
  IFCPHYSICALSIMPLEQUANTITY:{p:'IFCPHYSICALQUANTITY',a:{}},
  IFCPILE:{p:'IFCBUILDINGELEMENT',a:{ConstructionType:'enum',PredefinedType:'enum'}},
  IFCPIPEFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCPIPESEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPIXELTEXTURE:{p:'IFCSURFACETEXTURE',a:{ColourComponents:'integer',Height:'integer',Width:'integer'}},
  IFCPLACEMENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCPLANARBOX:{p:'IFCPLANAREXTENT',a:{}},
  IFCPLANAREXTENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{SizeInX:'real',SizeInY:'real'}},
  IFCPLANE:{p:'IFCELEMENTARYSURFACE',a:{}},
  IFCPLATE:{p:'IFCBUILDINGELEMENT',a:{}},
  IFCPLATETYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPOINT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCPOINTONCURVE:{p:'IFCPOINT',a:{PointParameter:'real'}},
  IFCPOINTONSURFACE:{p:'IFCPOINT',a:{PointParameterU:'real',PointParameterV:'real'}},
  IFCPOLYLOOP:{p:'IFCLOOP',a:{}},
  IFCPOLYGONALBOUNDEDHALFSPACE:{p:'IFCHALFSPACESOLID',a:{}},
  IFCPOLYLINE:{p:'IFCBOUNDEDCURVE',a:{}},
  IFCPORT:{p:'IFCPRODUCT',a:{}},
  IFCPOSTALADDRESS:{p:'IFCADDRESS',a:{Country:'string',InternalLocation:'string',PostalBox:'string',PostalCode:'string',Region:'string',Town:'string'}},
  IFCPREDEFINEDCOLOUR:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPREDEFINEDCURVEFONT:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPREDEFINEDDIMENSIONSYMBOL:{p:'IFCPREDEFINEDSYMBOL',a:{}},
  IFCPREDEFINEDITEM:{p:null,a:{Name:'string'}},
  IFCPREDEFINEDPOINTMARKERSYMBOL:{p:'IFCPREDEFINEDSYMBOL',a:{}},
  IFCPREDEFINEDSYMBOL:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPREDEFINEDTERMINATORSYMBOL:{p:'IFCPREDEFINEDSYMBOL',a:{}},
  IFCPREDEFINEDTEXTFONT:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPRESENTATIONLAYERASSIGNMENT:{p:null,a:{Description:'string',Identifier:'string',Name:'string'}},
  IFCPRESENTATIONLAYERWITHSTYLE:{p:'IFCPRESENTATIONLAYERASSIGNMENT',a:{}},
  IFCPRESENTATIONSTYLE:{p:null,a:{Name:'string'}},
  IFCPROCEDURE:{p:'IFCPROCESS',a:{ProcedureID:'string',ProcedureType:'enum',UserDefinedProcedureType:'string'}},
  IFCPROCESS:{p:'IFCOBJECT',a:{}},
  IFCPRODUCT:{p:'IFCOBJECT',a:{}},
  IFCPRODUCTDEFINITIONSHAPE:{p:'IFCPRODUCTREPRESENTATION',a:{}},
  IFCPRODUCTREPRESENTATION:{p:null,a:{Description:'string',Name:'string'}},
  IFCPRODUCTSOFCOMBUSTIONPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{CO2Content:'real',COContent:'real',N20Content:'real',SpecificHeatCapacity:'real'}},
  IFCPROFILEDEF:{p:null,a:{ProfileName:'string',ProfileType:'enum'}},
  IFCPROFILEPROPERTIES:{p:null,a:{ProfileName:'string'}},
  IFCPROJECT:{p:'IFCOBJECT',a:{LongName:'string',Phase:'string'}},
  IFCPROJECTORDER:{p:'IFCCONTROL',a:{ID:'string',PredefinedType:'enum',Status:'string'}},
  IFCPROJECTORDERRECORD:{p:'IFCCONTROL',a:{PredefinedType:'enum'}},
  IFCPROJECTIONCURVE:{p:'IFCANNOTATIONCURVEOCCURRENCE',a:{}},
  IFCPROJECTIONELEMENT:{p:'IFCFEATUREELEMENTADDITION',a:{}},
  IFCPROPERTY:{p:null,a:{Description:'string',Name:'string'}},
  IFCPROPERTYBOUNDEDVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYCONSTRAINTRELATIONSHIP:{p:null,a:{Description:'string',Name:'string'}},
  IFCPROPERTYDEFINITION:{p:'IFCROOT',a:{}},
  IFCPROPERTYDEPENDENCYRELATIONSHIP:{p:null,a:{Description:'string',Expression:'string',Name:'string'}},
  IFCPROPERTYENUMERATEDVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYENUMERATION:{p:null,a:{Name:'string'}},
  IFCPROPERTYLISTVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYREFERENCEVALUE:{p:'IFCSIMPLEPROPERTY',a:{UsageName:'string'}},
  IFCPROPERTYSET:{p:'IFCPROPERTYSETDEFINITION',a:{}},
  IFCPROPERTYSETDEFINITION:{p:'IFCPROPERTYDEFINITION',a:{}},
  IFCPROPERTYSINGLEVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYTABLEVALUE:{p:'IFCSIMPLEPROPERTY',a:{Expression:'string'}},
  IFCPROTECTIVEDEVICETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCPROXY:{p:'IFCPRODUCT',a:{ProxyType:'enum',Tag:'string'}},
  IFCPUMPTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCQUANTITYAREA:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{AreaValue:'real'}},
  IFCQUANTITYCOUNT:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{CountValue:'real'}},
  IFCQUANTITYLENGTH:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{LengthValue:'real'}},
  IFCQUANTITYTIME:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{TimeValue:'real'}},
  IFCQUANTITYVOLUME:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{VolumeValue:'real'}},
  IFCQUANTITYWEIGHT:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{WeightValue:'real'}},
  IFCRADIUSDIMENSION:{p:'IFCDIMENSIONCURVEDIRECTEDCALLOUT',a:{}},
  IFCRAILING:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCRAILINGTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRAMP:{p:'IFCBUILDINGELEMENT',a:{ShapeType:'enum'}},
  IFCRAMPFLIGHT:{p:'IFCBUILDINGELEMENT',a:{}},
  IFCRAMPFLIGHTTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRATIONALBEZIERCURVE:{p:'IFCBEZIERCURVE',a:{}},
  IFCRECTANGLEHOLLOWPROFILEDEF:{p:'IFCRECTANGLEPROFILEDEF',a:{InnerFilletRadius:'real',OuterFilletRadius:'real',WallThickness:'real'}},
  IFCRECTANGLEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{XDim:'real',YDim:'real'}},
  IFCRECTANGULARPYRAMID:{p:'IFCCSGPRIMITIVE3D',a:{Height:'real',XLength:'real',YLength:'real'}},
  IFCRECTANGULARTRIMMEDSURFACE:{p:'IFCBOUNDEDSURFACE',a:{U1:'real',U2:'real',V1:'real',V2:'real'}},
  IFCREFERENCESVALUEDOCUMENT:{p:null,a:{Description:'string',Name:'string'}},
  IFCREGULARTIMESERIES:{p:'IFCTIMESERIES',a:{TimeStep:'real'}},
  IFCREINFORCEMENTBARPROPERTIES:{p:null,a:{BarCount:'real',BarSurface:'enum',EffectiveDepth:'real',NominalBarDiameter:'real',SteelGrade:'string',TotalCrossSectionArea:'real'}},
  IFCREINFORCEMENTDEFINITIONPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{DefinitionType:'string'}},
  IFCREINFORCINGBAR:{p:'IFCREINFORCINGELEMENT',a:{BarLength:'real',BarRole:'enum',BarSurface:'enum',CrossSectionArea:'real',NominalDiameter:'real'}},
  IFCREINFORCINGELEMENT:{p:'IFCBUILDINGELEMENTCOMPONENT',a:{SteelGrade:'string'}},
  IFCREINFORCINGMESH:{p:'IFCREINFORCINGELEMENT',a:{LongitudinalBarCrossSectionArea:'real',LongitudinalBarNominalDiameter:'real',LongitudinalBarSpacing:'real',MeshLength:'real',MeshWidth:'real',TransverseBarCrossSectionArea:'real',TransverseBarNominalDiameter:'real',TransverseBarSpacing:'real'}},
  IFCRELAGGREGATES:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELASSIGNS:{p:'IFCRELATIONSHIP',a:{RelatedObjectsType:'enum'}},
  IFCRELASSIGNSTASKS:{p:'IFCRELASSIGNSTOCONTROL',a:{}},
  IFCRELASSIGNSTOACTOR:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOCONTROL:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOGROUP:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOPROCESS:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOPRODUCT:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOPROJECTORDER:{p:'IFCRELASSIGNSTOCONTROL',a:{}},
  IFCRELASSIGNSTORESOURCE:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSOCIATES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELASSOCIATESAPPLIEDVALUE:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESAPPROVAL:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESCLASSIFICATION:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESCONSTRAINT:{p:'IFCRELASSOCIATES',a:{Intent:'string'}},
  IFCRELASSOCIATESDOCUMENT:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESLIBRARY:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESMATERIAL:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESPROFILEPROPERTIES:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELCONNECTS:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELCONNECTSELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSPATHELEMENTS:{p:'IFCRELCONNECTSELEMENTS',a:{RelatedConnectionType:'enum',RelatingConnectionType:'enum'}},
  IFCRELCONNECTSPORTTOELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSPORTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSSTRUCTURALACTIVITY:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSSTRUCTURALELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSSTRUCTURALMEMBER:{p:'IFCRELCONNECTS',a:{SupportedLength:'real'}},
  IFCRELCONNECTSWITHECCENTRICITY:{p:'IFCRELCONNECTSSTRUCTURALMEMBER',a:{}},
  IFCRELCONNECTSWITHREALIZINGELEMENTS:{p:'IFCRELCONNECTSELEMENTS',a:{ConnectionType:'string'}},
  IFCRELCONTAINEDINSPATIALSTRUCTURE:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCOVERSBLDGELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCOVERSSPACES:{p:'IFCRELCONNECTS',a:{}},
  IFCRELDECOMPOSES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELDEFINES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELDEFINESBYPROPERTIES:{p:'IFCRELDEFINES',a:{}},
  IFCRELDEFINESBYTYPE:{p:'IFCRELDEFINES',a:{}},
  IFCRELFILLSELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELFLOWCONTROLELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELINTERACTIONREQUIREMENTS:{p:'IFCRELCONNECTS',a:{DailyInteraction:'real',ImportanceRating:'real'}},
  IFCRELNESTS:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELOCCUPIESSPACES:{p:'IFCRELASSIGNSTOACTOR',a:{}},
  IFCRELOVERRIDESPROPERTIES:{p:'IFCRELDEFINESBYPROPERTIES',a:{}},
  IFCRELPROJECTSELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELREFERENCEDINSPATIALSTRUCTURE:{p:'IFCRELCONNECTS',a:{}},
  IFCRELSCHEDULESCOSTITEMS:{p:'IFCRELASSIGNSTOCONTROL',a:{}},
  IFCRELSEQUENCE:{p:'IFCRELCONNECTS',a:{SequenceType:'enum',TimeLag:'real'}},
  IFCRELSERVICESBUILDINGS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELSPACEBOUNDARY:{p:'IFCRELCONNECTS',a:{InternalOrExternalBoundary:'enum',PhysicalOrVirtualBoundary:'enum'}},
  IFCRELVOIDSELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELATIONSHIP:{p:'IFCROOT',a:{}},
  IFCRELAXATION:{p:null,a:{InitialStress:'real',RelaxationValue:'real'}},
  IFCREPRESENTATION:{p:null,a:{RepresentationIdentifier:'string',RepresentationType:'string'}},
  IFCREPRESENTATIONCONTEXT:{p:null,a:{ContextIdentifier:'string',ContextType:'string'}},
  IFCRESOURCE:{p:'IFCOBJECT',a:{}},
  IFCREVOLVEDAREASOLID:{p:'IFCSWEPTAREASOLID',a:{Angle:'real'}},
  IFCRIBPLATEPROFILEPROPERTIES:{p:'IFCPROFILEPROPERTIES',a:{Direction:'enum',RibHeight:'real',RibSpacing:'real',RibWidth:'real',Thickness:'real'}},
  IFCRIGHTCIRCULARCONE:{p:'IFCCSGPRIMITIVE3D',a:{BottomRadius:'real',Height:'real'}},
  IFCRIGHTCIRCULARCYLINDER:{p:'IFCCSGPRIMITIVE3D',a:{Height:'real',Radius:'real'}},
  IFCROOF:{p:'IFCBUILDINGELEMENT',a:{ShapeType:'enum'}},
  IFCROOT:{p:null,a:{Description:'string',GlobalId:'string',Name:'string'}},
  IFCROUNDEDEDGEFEATURE:{p:'IFCEDGEFEATURE',a:{Radius:'real'}},
  IFCROUNDEDRECTANGLEPROFILEDEF:{p:'IFCRECTANGLEPROFILEDEF',a:{RoundingRadius:'real'}},
  IFCSIUNIT:{p:'IFCNAMEDUNIT',a:{Name:'enum',Prefix:'enum'}},
  IFCSANITARYTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSCHEDULETIMECONTROL:{p:'IFCCONTROL',a:{ActualDuration:'real',Completion:'real',FinishFloat:'real',FreeFloat:'real',RemainingTime:'real',ScheduleDuration:'real',StartFloat:'real',TotalFloat:'real'}},
  IFCSECTIONPROPERTIES:{p:null,a:{SectionType:'enum'}},
  IFCSECTIONREINFORCEMENTPROPERTIES:{p:null,a:{LongitudinalEndPosition:'real',LongitudinalStartPosition:'real',ReinforcementRole:'enum',TransversePosition:'real'}},
  IFCSECTIONEDSPINE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSENSORTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSERVICELIFE:{p:'IFCCONTROL',a:{ServiceLifeDuration:'real',ServiceLifeType:'enum'}},
  IFCSERVICELIFEFACTOR:{p:'IFCPROPERTYSETDEFINITION',a:{PredefinedType:'enum'}},
  IFCSHAPEASPECT:{p:null,a:{Description:'string',Name:'string'}},
  IFCSHAPEMODEL:{p:'IFCREPRESENTATION',a:{}},
  IFCSHAPEREPRESENTATION:{p:'IFCSHAPEMODEL',a:{}},
  IFCSHELLBASEDSURFACEMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSIMPLEPROPERTY:{p:'IFCPROPERTY',a:{}},
  IFCSITE:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{LandTitleNumber:'string',RefElevation:'real'}},
  IFCSLAB:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCSLABTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSLIPPAGECONNECTIONCONDITION:{p:'IFCSTRUCTURALCONNECTIONCONDITION',a:{SlippageX:'real',SlippageY:'real',SlippageZ:'real'}},
  IFCSOLIDMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSOUNDPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{IsAttenuating:'boolean',SoundScale:'enum'}},
  IFCSOUNDVALUE:{p:'IFCPROPERTYSETDEFINITION',a:{Frequency:'real'}},
  IFCSPACE:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{ElevationWithFlooring:'real',InteriorOrExteriorSpace:'enum'}},
  IFCSPACEHEATERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCSPACEPROGRAM:{p:'IFCCONTROL',a:{MaxRequiredArea:'real',MinRequiredArea:'real',SpaceProgramIdentifier:'string',StandardRequiredArea:'real'}},
  IFCSPACETHERMALLOADPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{ApplicableValueRatio:'real',MaximumValue:'real',MinimumValue:'real',PropertySource:'enum',SourceDescription:'string',ThermalLoadSource:'enum',ThermalLoadType:'enum',UserDefinedPropertySource:'string',UserDefinedThermalLoadSource:'string'}},
  IFCSPACETYPE:{p:'IFCSPATIALSTRUCTUREELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSPATIALSTRUCTUREELEMENT:{p:'IFCPRODUCT',a:{CompositionType:'enum',LongName:'string'}},
  IFCSPATIALSTRUCTUREELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCSPHERE:{p:'IFCCSGPRIMITIVE3D',a:{Radius:'real'}},
  IFCSTACKTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSTAIR:{p:'IFCBUILDINGELEMENT',a:{ShapeType:'enum'}},
  IFCSTAIRFLIGHT:{p:'IFCBUILDINGELEMENT',a:{RiserHeight:'real',TreadLength:'real'}},
  IFCSTAIRFLIGHTTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALACTION:{p:'IFCSTRUCTURALACTIVITY',a:{}},
  IFCSTRUCTURALACTIVITY:{p:'IFCPRODUCT',a:{GlobalOrLocal:'enum'}},
  IFCSTRUCTURALANALYSISMODEL:{p:'IFCSYSTEM',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALCONNECTION:{p:'IFCSTRUCTURALITEM',a:{}},
  IFCSTRUCTURALCONNECTIONCONDITION:{p:null,a:{Name:'string'}},
  IFCSTRUCTURALCURVECONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALCURVEMEMBER:{p:'IFCSTRUCTURALMEMBER',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALCURVEMEMBERVARYING:{p:'IFCSTRUCTURALCURVEMEMBER',a:{}},
  IFCSTRUCTURALITEM:{p:'IFCPRODUCT',a:{}},
  IFCSTRUCTURALLINEARACTION:{p:'IFCSTRUCTURALACTION',a:{ProjectedOrTrue:'enum'}},
  IFCSTRUCTURALLINEARACTIONVARYING:{p:'IFCSTRUCTURALLINEARACTION',a:{}},
  IFCSTRUCTURALLOAD:{p:null,a:{Name:'string'}},
  IFCSTRUCTURALLOADGROUP:{p:'IFCGROUP',a:{ActionSource:'enum',ActionType:'enum',Coefficient:'real',PredefinedType:'enum',Purpose:'string'}},
  IFCSTRUCTURALLOADLINEARFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{LinearForceX:'real',LinearForceY:'real',LinearForceZ:'real',LinearMomentX:'real',LinearMomentY:'real',LinearMomentZ:'real'}},
  IFCSTRUCTURALLOADPLANARFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{PlanarForceX:'real',PlanarForceY:'real',PlanarForceZ:'real'}},
  IFCSTRUCTURALLOADSINGLEDISPLACEMENT:{p:'IFCSTRUCTURALLOADSTATIC',a:{DisplacementX:'real',DisplacementY:'real',DisplacementZ:'real',RotationalDisplacementRX:'real',RotationalDisplacementRY:'real',RotationalDisplacementRZ:'real'}},
  IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION:{p:'IFCSTRUCTURALLOADSINGLEDISPLACEMENT',a:{Distortion:'real'}},
  IFCSTRUCTURALLOADSINGLEFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{ForceX:'real',ForceY:'real',ForceZ:'real',MomentX:'real',MomentY:'real',MomentZ:'real'}},
  IFCSTRUCTURALLOADSINGLEFORCEWARPING:{p:'IFCSTRUCTURALLOADSINGLEFORCE',a:{WarpingMoment:'real'}},
  IFCSTRUCTURALLOADSTATIC:{p:'IFCSTRUCTURALLOAD',a:{}},
  IFCSTRUCTURALLOADTEMPERATURE:{p:'IFCSTRUCTURALLOADSTATIC',a:{}},
  IFCSTRUCTURALMEMBER:{p:'IFCSTRUCTURALITEM',a:{}},
  IFCSTRUCTURALPLANARACTION:{p:'IFCSTRUCTURALACTION',a:{ProjectedOrTrue:'enum'}},
  IFCSTRUCTURALPLANARACTIONVARYING:{p:'IFCSTRUCTURALPLANARACTION',a:{}},
  IFCSTRUCTURALPOINTACTION:{p:'IFCSTRUCTURALACTION',a:{}},
  IFCSTRUCTURALPOINTCONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALPOINTREACTION:{p:'IFCSTRUCTURALREACTION',a:{}},
  IFCSTRUCTURALPROFILEPROPERTIES:{p:'IFCGENERALPROFILEPROPERTIES',a:{CentreOfGravityInX:'real',CentreOfGravityInY:'real',MaximumSectionModulusY:'real',MaximumSectionModulusZ:'real',MinimumSectionModulusY:'real',MinimumSectionModulusZ:'real',MomentOfInertiaY:'real',MomentOfInertiaYZ:'real',MomentOfInertiaZ:'real',ShearCentreY:'real',ShearCentreZ:'real',ShearDeformationAreaY:'real',ShearDeformationAreaZ:'real',TorsionalConstantX:'real',TorsionalSectionModulus:'real',WarpingConstant:'real'}},
  IFCSTRUCTURALREACTION:{p:'IFCSTRUCTURALACTIVITY',a:{}},
  IFCSTRUCTURALRESULTGROUP:{p:'IFCGROUP',a:{TheoryType:'enum'}},
  IFCSTRUCTURALSTEELPROFILEPROPERTIES:{p:'IFCSTRUCTURALPROFILEPROPERTIES',a:{PlasticShapeFactorY:'real',PlasticShapeFactorZ:'real',ShearAreaY:'real',ShearAreaZ:'real'}},
  IFCSTRUCTURALSURFACECONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALSURFACEMEMBER:{p:'IFCSTRUCTURALMEMBER',a:{PredefinedType:'enum',Thickness:'real'}},
  IFCSTRUCTURALSURFACEMEMBERVARYING:{p:'IFCSTRUCTURALSURFACEMEMBER',a:{}},
  IFCSTRUCTUREDDIMENSIONCALLOUT:{p:'IFCDRAUGHTINGCALLOUT',a:{}},
  IFCSTYLEMODEL:{p:'IFCREPRESENTATION',a:{}},
  IFCSTYLEDITEM:{p:'IFCREPRESENTATIONITEM',a:{Name:'string'}},
  IFCSTYLEDREPRESENTATION:{p:'IFCSTYLEMODEL',a:{}},
  IFCSUBCONTRACTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{JobDescription:'string'}},
  IFCSUBEDGE:{p:'IFCEDGE',a:{}},
  IFCSURFACE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSURFACECURVESWEPTAREASOLID:{p:'IFCSWEPTAREASOLID',a:{EndParam:'real',StartParam:'real'}},
  IFCSURFACEOFLINEAREXTRUSION:{p:'IFCSWEPTSURFACE',a:{Depth:'real'}},
  IFCSURFACEOFREVOLUTION:{p:'IFCSWEPTSURFACE',a:{}},
  IFCSURFACESTYLE:{p:'IFCPRESENTATIONSTYLE',a:{Side:'enum'}},
  IFCSURFACESTYLEREFRACTION:{p:null,a:{DispersionFactor:'real',RefractionIndex:'real'}},
  IFCSURFACESTYLERENDERING:{p:'IFCSURFACESTYLESHADING',a:{ReflectanceMethod:'enum',Transparency:'real'}},
  IFCSURFACETEXTURE:{p:null,a:{TextureType:'enum'}},
  IFCSWEPTAREASOLID:{p:'IFCSOLIDMODEL',a:{}},
  IFCSWEPTDISKSOLID:{p:'IFCSOLIDMODEL',a:{EndParam:'real',InnerRadius:'real',Radius:'real',StartParam:'real'}},
  IFCSWEPTSURFACE:{p:'IFCSURFACE',a:{}},
  IFCSWITCHINGDEVICETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCSYMBOLSTYLE:{p:'IFCPRESENTATIONSTYLE',a:{}},
  IFCSYSTEM:{p:'IFCGROUP',a:{}},
  IFCSYSTEMFURNITUREELEMENTTYPE:{p:'IFCFURNISHINGELEMENTTYPE',a:{}},
  IFCTSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{CentreOfGravityInY:'real',Depth:'real',FilletRadius:'real',FlangeEdgeRadius:'real',FlangeSlope:'real',FlangeThickness:'real',FlangeWidth:'real',WebEdgeRadius:'real',WebSlope:'real',WebThickness:'real'}},
  IFCTANKTYPE:{p:'IFCFLOWSTORAGEDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTASK:{p:'IFCPROCESS',a:{Status:'string',TaskId:'string',WorkMethod:'string'}},
  IFCTELECOMADDRESS:{p:'IFCADDRESS',a:{PagerNumber:'string',WWWHomePageURL:'string'}},
  IFCTENDON:{p:'IFCREINFORCINGELEMENT',a:{AnchorageSlip:'real',CrossSectionArea:'real',FrictionCoefficient:'real',MinCurvatureRadius:'real',NominalDiameter:'real',PreStress:'real',PredefinedType:'enum',TensionForce:'real'}},
  IFCTENDONANCHOR:{p:'IFCREINFORCINGELEMENT',a:{}},
  IFCTERMINATORSYMBOL:{p:'IFCANNOTATIONSYMBOLOCCURRENCE',a:{}},
  IFCTEXTLITERAL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Literal:'string',Path:'enum'}},
  IFCTEXTLITERALWITHEXTENT:{p:'IFCTEXTLITERAL',a:{BoxAlignment:'string'}},
  IFCTEXTSTYLE:{p:'IFCPRESENTATIONSTYLE',a:{}},
  IFCTEXTSTYLEFONTMODEL:{p:'IFCPREDEFINEDTEXTFONT',a:{FontStyle:'string',FontVariant:'string',FontWeight:'string'}},
  IFCTEXTSTYLETEXTMODEL:{p:null,a:{TextAlign:'string',TextDecoration:'string',TextTransform:'string'}},
  IFCTEXTSTYLEWITHBOXCHARACTERISTICS:{p:null,a:{BoxHeight:'real',BoxRotateAngle:'real',BoxSlantAngle:'real',BoxWidth:'real'}},
  IFCTEXTURECOORDINATEGENERATOR:{p:'IFCTEXTURECOORDINATE',a:{Mode:'string'}},
  IFCTEXTUREMAP:{p:'IFCTEXTURECOORDINATE',a:{}},
  IFCTHERMALMATERIALPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{BoilingPoint:'real',FreezingPoint:'real',SpecificHeatCapacity:'real',ThermalConductivity:'real'}},
  IFCTIMESERIES:{p:null,a:{DataOrigin:'enum',Description:'string',Name:'string',TimeSeriesDataType:'enum',UserDefinedDataOrigin:'string'}},
  IFCTIMESERIESSCHEDULE:{p:'IFCCONTROL',a:{TimeSeriesScheduleType:'enum'}},
  IFCTOPOLOGICALREPRESENTATIONITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCTOPOLOGYREPRESENTATION:{p:'IFCSHAPEMODEL',a:{}},
  IFCTRANSFORMERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTRANSPORTELEMENT:{p:'IFCELEMENT',a:{CapacityByNumber:'real',CapacityByWeight:'real',OperationType:'enum'}},
  IFCTRANSPORTELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCTRAPEZIUMPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{BottomXDim:'real',TopXDim:'real',TopXOffset:'real',YDim:'real'}},
  IFCTRIMMEDCURVE:{p:'IFCBOUNDEDCURVE',a:{MasterRepresentation:'enum'}},
  IFCTUBEBUNDLETYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTWODIRECTIONREPEATFACTOR:{p:'IFCONEDIRECTIONREPEATFACTOR',a:{}},
  IFCTYPEOBJECT:{p:'IFCOBJECTDEFINITION',a:{ApplicableOccurrence:'string'}},
  IFCTYPEPRODUCT:{p:'IFCTYPEOBJECT',a:{Tag:'string'}},
  IFCUSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{CentreOfGravityInX:'real',Depth:'real',EdgeRadius:'real',FilletRadius:'real',FlangeSlope:'real',FlangeThickness:'real',FlangeWidth:'real',WebThickness:'real'}},
  IFCUNITARYEQUIPMENTTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCVALVETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCVECTOR:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Magnitude:'real'}},
  IFCVERTEX:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCVERTEXLOOP:{p:'IFCLOOP',a:{}},
  IFCVERTEXPOINT:{p:'IFCVERTEX',a:{}},
  IFCVIBRATIONISOLATORTYPE:{p:'IFCDISCRETEACCESSORYTYPE',a:{PredefinedType:'enum'}},
  IFCVIRTUALELEMENT:{p:'IFCELEMENT',a:{}},
  IFCWALL:{p:'IFCBUILDINGELEMENT',a:{}},
  IFCWALLSTANDARDCASE:{p:'IFCWALL',a:{}},
  IFCWALLTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCWASTETERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCWATERPROPERTIES:{p:'IFCMATERIALPROPERTIES',a:{AcidityConcentration:'real',AlkalinityConcentration:'real',DissolvedSolidsContent:'real',Hardness:'real',ImpuritiesContent:'real',PHLevel:'real'}},
  IFCWINDOW:{p:'IFCBUILDINGELEMENT',a:{OverallHeight:'real',OverallWidth:'real'}},
  IFCWINDOWLININGPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{FirstMullionOffset:'real',FirstTransomOffset:'real',LiningDepth:'real',LiningThickness:'real',MullionThickness:'real',SecondMullionOffset:'real',SecondTransomOffset:'real',TransomThickness:'real'}},
  IFCWINDOWPANELPROPERTIES:{p:'IFCPROPERTYSETDEFINITION',a:{FrameDepth:'real',FrameThickness:'real',OperationType:'enum',PanelPosition:'enum'}},
  IFCWINDOWSTYLE:{p:'IFCTYPEPRODUCT',a:{ConstructionType:'enum',OperationType:'enum'}},
  IFCWORKCONTROL:{p:'IFCCONTROL',a:{Duration:'real',Identifier:'string',Purpose:'string',TotalFloat:'real',UserDefinedControlType:'string',WorkControlType:'enum'}},
  IFCWORKPLAN:{p:'IFCWORKCONTROL',a:{}},
  IFCWORKSCHEDULE:{p:'IFCWORKCONTROL',a:{}},
  IFCZSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',EdgeRadius:'real',FilletRadius:'real',FlangeThickness:'real',FlangeWidth:'real',WebThickness:'real'}},
  IFCZONE:{p:'IFCGROUP',a:{}},
}

const T4: Table = {
  IFCACTIONREQUEST:{p:'IFCCONTROL',a:{LongDescription:'string',PredefinedType:'enum',Status:'string'}},
  IFCACTOR:{p:'IFCOBJECT',a:{}},
  IFCACTORROLE:{p:null,a:{Description:'string',Role:'enum',UserDefinedRole:'string'}},
  IFCACTUATOR:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCACTUATORTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCADDRESS:{p:null,a:{Description:'string',Purpose:'enum',UserDefinedPurpose:'string'}},
  IFCADVANCEDBREP:{p:'IFCMANIFOLDSOLIDBREP',a:{}},
  IFCADVANCEDBREPWITHVOIDS:{p:'IFCADVANCEDBREP',a:{}},
  IFCADVANCEDFACE:{p:'IFCFACESURFACE',a:{}},
  IFCAIRTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCAIRTERMINALBOX:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCAIRTERMINALBOXTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCAIRTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCAIRTOAIRHEATRECOVERY:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCAIRTOAIRHEATRECOVERYTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCALARM:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCALARMTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCANNOTATION:{p:'IFCPRODUCT',a:{}},
  IFCANNOTATIONFILLAREA:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCAPPLICATION:{p:null,a:{ApplicationFullName:'string',ApplicationIdentifier:'string',Version:'string'}},
  IFCAPPLIEDVALUE:{p:null,a:{ApplicableDate:'string',ArithmeticOperator:'enum',Category:'string',Condition:'string',Description:'string',FixedUntilDate:'string',Name:'string'}},
  IFCAPPROVAL:{p:null,a:{Description:'string',Identifier:'string',Level:'string',Name:'string',Qualifier:'string',Status:'string',TimeOfApproval:'string'}},
  IFCAPPROVALRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCARBITRARYCLOSEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCARBITRARYOPENPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCARBITRARYPROFILEDEFWITHVOIDS:{p:'IFCARBITRARYCLOSEDPROFILEDEF',a:{}},
  IFCASSET:{p:'IFCGROUP',a:{Identification:'string',IncorporationDate:'string'}},
  IFCASYMMETRICISHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{BottomFlangeEdgeRadius:'real',BottomFlangeFilletRadius:'real',BottomFlangeSlope:'real',BottomFlangeThickness:'real',BottomFlangeWidth:'real',OverallDepth:'real',TopFlangeEdgeRadius:'real',TopFlangeFilletRadius:'real',TopFlangeSlope:'real',TopFlangeThickness:'real',TopFlangeWidth:'real',WebThickness:'real'}},
  IFCAUDIOVISUALAPPLIANCE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCAUDIOVISUALAPPLIANCETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCAXIS1PLACEMENT:{p:'IFCPLACEMENT',a:{}},
  IFCAXIS2PLACEMENT2D:{p:'IFCPLACEMENT',a:{}},
  IFCAXIS2PLACEMENT3D:{p:'IFCPLACEMENT',a:{}},
  IFCBSPLINECURVE:{p:'IFCBOUNDEDCURVE',a:{ClosedCurve:'logical',CurveForm:'enum',Degree:'integer',SelfIntersect:'logical'}},
  IFCBSPLINECURVEWITHKNOTS:{p:'IFCBSPLINECURVE',a:{KnotSpec:'enum'}},
  IFCBSPLINESURFACE:{p:'IFCBOUNDEDSURFACE',a:{SelfIntersect:'logical',SurfaceForm:'enum',UClosed:'logical',UDegree:'integer',VClosed:'logical',VDegree:'integer'}},
  IFCBSPLINESURFACEWITHKNOTS:{p:'IFCBSPLINESURFACE',a:{KnotSpec:'enum'}},
  IFCBEAM:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCBEAMSTANDARDCASE:{p:'IFCBEAM',a:{}},
  IFCBEAMTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCBLOBTEXTURE:{p:'IFCSURFACETEXTURE',a:{RasterCode:'real',RasterFormat:'string'}},
  IFCBLOCK:{p:'IFCCSGPRIMITIVE3D',a:{XLength:'real',YLength:'real',ZLength:'real'}},
  IFCBOILER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCBOILERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCBOOLEANCLIPPINGRESULT:{p:'IFCBOOLEANRESULT',a:{}},
  IFCBOOLEANRESULT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Operator:'enum'}},
  IFCBOUNDARYCONDITION:{p:null,a:{Name:'string'}},
  IFCBOUNDARYCURVE:{p:'IFCCOMPOSITECURVEONSURFACE',a:{}},
  IFCBOUNDARYEDGECONDITION:{p:'IFCBOUNDARYCONDITION',a:{}},
  IFCBOUNDARYFACECONDITION:{p:'IFCBOUNDARYCONDITION',a:{}},
  IFCBOUNDARYNODECONDITION:{p:'IFCBOUNDARYCONDITION',a:{}},
  IFCBOUNDARYNODECONDITIONWARPING:{p:'IFCBOUNDARYNODECONDITION',a:{}},
  IFCBOUNDEDCURVE:{p:'IFCCURVE',a:{}},
  IFCBOUNDEDSURFACE:{p:'IFCSURFACE',a:{}},
  IFCBOUNDINGBOX:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{XDim:'real',YDim:'real',ZDim:'real'}},
  IFCBOXEDHALFSPACE:{p:'IFCHALFSPACESOLID',a:{}},
  IFCBUILDING:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{ElevationOfRefHeight:'real',ElevationOfTerrain:'real'}},
  IFCBUILDINGELEMENT:{p:'IFCELEMENT',a:{}},
  IFCBUILDINGELEMENTPART:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCBUILDINGELEMENTPARTTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCBUILDINGELEMENTPROXY:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCBUILDINGELEMENTPROXYTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCBUILDINGELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCBUILDINGSTOREY:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{Elevation:'real'}},
  IFCBUILDINGSYSTEM:{p:'IFCSYSTEM',a:{LongName:'string',PredefinedType:'enum'}},
  IFCBURNER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCBURNERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',Girth:'real',InternalFilletRadius:'real',WallThickness:'real',Width:'real'}},
  IFCCABLECARRIERFITTING:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCCABLECARRIERFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCCABLECARRIERSEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCCABLECARRIERSEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCABLEFITTING:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCCABLEFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCCABLESEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCCABLESEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCARTESIANPOINT:{p:'IFCPOINT',a:{}},
  IFCCARTESIANPOINTLIST:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCARTESIANPOINTLIST2D:{p:'IFCCARTESIANPOINTLIST',a:{}},
  IFCCARTESIANPOINTLIST3D:{p:'IFCCARTESIANPOINTLIST',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Scale:'real'}},
  IFCCARTESIANTRANSFORMATIONOPERATOR2D:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR2D',a:{Scale2:'real'}},
  IFCCARTESIANTRANSFORMATIONOPERATOR3D:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR3D',a:{Scale2:'real',Scale3:'real'}},
  IFCCENTERLINEPROFILEDEF:{p:'IFCARBITRARYOPENPROFILEDEF',a:{Thickness:'real'}},
  IFCCHILLER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCHILLERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCHIMNEY:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCCHIMNEYTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCIRCLE:{p:'IFCCONIC',a:{Radius:'real'}},
  IFCCIRCLEHOLLOWPROFILEDEF:{p:'IFCCIRCLEPROFILEDEF',a:{WallThickness:'real'}},
  IFCCIRCLEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Radius:'real'}},
  IFCCIVILELEMENT:{p:'IFCELEMENT',a:{}},
  IFCCIVILELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCCLASSIFICATION:{p:'IFCEXTERNALINFORMATION',a:{Description:'string',Edition:'string',EditionDate:'string',Location:'string',Name:'string',Source:'string'}},
  IFCCLASSIFICATIONREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{Description:'string',Sort:'string'}},
  IFCCLOSEDSHELL:{p:'IFCCONNECTEDFACESET',a:{}},
  IFCCOIL:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCOILTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOLOURRGB:{p:'IFCCOLOURSPECIFICATION',a:{Blue:'real',Green:'real',Red:'real'}},
  IFCCOLOURRGBLIST:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCCOLOURSPECIFICATION:{p:'IFCPRESENTATIONITEM',a:{Name:'string'}},
  IFCCOLUMN:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCCOLUMNSTANDARDCASE:{p:'IFCCOLUMN',a:{}},
  IFCCOLUMNTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCOMMUNICATIONSAPPLIANCE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCCOMMUNICATIONSAPPLIANCETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCCOMPLEXPROPERTY:{p:'IFCPROPERTY',a:{UsageName:'string'}},
  IFCCOMPLEXPROPERTYTEMPLATE:{p:'IFCPROPERTYTEMPLATE',a:{TemplateType:'enum',UsageName:'string'}},
  IFCCOMPOSITECURVE:{p:'IFCBOUNDEDCURVE',a:{SelfIntersect:'logical'}},
  IFCCOMPOSITECURVEONSURFACE:{p:'IFCCOMPOSITECURVE',a:{}},
  IFCCOMPOSITECURVESEGMENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{SameSense:'boolean',Transition:'enum'}},
  IFCCOMPOSITEPROFILEDEF:{p:'IFCPROFILEDEF',a:{Label:'string'}},
  IFCCOMPRESSOR:{p:'IFCFLOWMOVINGDEVICE',a:{PredefinedType:'enum'}},
  IFCCOMPRESSORTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCONDENSER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCONDENSERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCONIC:{p:'IFCCURVE',a:{}},
  IFCCONNECTEDFACESET:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCCONNECTIONCURVEGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONPOINTECCENTRICITY:{p:'IFCCONNECTIONPOINTGEOMETRY',a:{EccentricityInX:'real',EccentricityInY:'real',EccentricityInZ:'real'}},
  IFCCONNECTIONPOINTGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONSURFACEGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONVOLUMEGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONSTRAINT:{p:null,a:{ConstraintGrade:'enum',ConstraintSource:'string',CreationTime:'string',Description:'string',Name:'string',UserDefinedGrade:'string'}},
  IFCCONSTRUCTIONEQUIPMENTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONMATERIALRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONMATERIALRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONPRODUCTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONPRODUCTRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONRESOURCE:{p:'IFCRESOURCE',a:{}},
  IFCCONSTRUCTIONRESOURCETYPE:{p:'IFCTYPERESOURCE',a:{}},
  IFCCONTEXT:{p:'IFCOBJECTDEFINITION',a:{LongName:'string',ObjectType:'string',Phase:'string'}},
  IFCCONTEXTDEPENDENTUNIT:{p:'IFCNAMEDUNIT',a:{Name:'string'}},
  IFCCONTROL:{p:'IFCOBJECT',a:{Identification:'string'}},
  IFCCONTROLLER:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCCONTROLLERTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCONVERSIONBASEDUNIT:{p:'IFCNAMEDUNIT',a:{Name:'string'}},
  IFCCONVERSIONBASEDUNITWITHOFFSET:{p:'IFCCONVERSIONBASEDUNIT',a:{ConversionOffset:'real'}},
  IFCCOOLEDBEAM:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCOOLEDBEAMTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOOLINGTOWER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCOOLINGTOWERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOORDINATEREFERENCESYSTEM:{p:null,a:{Description:'string',GeodeticDatum:'string',Name:'string',VerticalDatum:'string'}},
  IFCCOSTITEM:{p:'IFCCONTROL',a:{PredefinedType:'enum'}},
  IFCCOSTSCHEDULE:{p:'IFCCONTROL',a:{PredefinedType:'enum',Status:'string',SubmittedOn:'string',UpdateDate:'string'}},
  IFCCOSTVALUE:{p:'IFCAPPLIEDVALUE',a:{}},
  IFCCOVERING:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCCOVERINGTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCREWRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCCREWRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCCSGPRIMITIVE3D:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCSGSOLID:{p:'IFCSOLIDMODEL',a:{}},
  IFCCURRENCYRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{ExchangeRate:'real',RateDateTime:'string'}},
  IFCCURTAINWALL:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCCURTAINWALLTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCURVE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCURVEBOUNDEDPLANE:{p:'IFCBOUNDEDSURFACE',a:{}},
  IFCCURVEBOUNDEDSURFACE:{p:'IFCBOUNDEDSURFACE',a:{ImplicitOuter:'boolean'}},
  IFCCURVESTYLE:{p:'IFCPRESENTATIONSTYLE',a:{ModelOrDraughting:'boolean'}},
  IFCCURVESTYLEFONT:{p:'IFCPRESENTATIONITEM',a:{Name:'string'}},
  IFCCURVESTYLEFONTANDSCALING:{p:'IFCPRESENTATIONITEM',a:{CurveFontScaling:'real',Name:'string'}},
  IFCCURVESTYLEFONTPATTERN:{p:'IFCPRESENTATIONITEM',a:{InvisibleSegmentLength:'real',VisibleSegmentLength:'real'}},
  IFCCYLINDRICALSURFACE:{p:'IFCELEMENTARYSURFACE',a:{Radius:'real'}},
  IFCDAMPER:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCDAMPERTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCDERIVEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{Label:'string'}},
  IFCDERIVEDUNIT:{p:null,a:{UnitType:'enum',UserDefinedType:'string'}},
  IFCDIRECTION:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCDISCRETEACCESSORY:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCDISCRETEACCESSORYTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONCHAMBERELEMENT:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONCHAMBERELEMENTTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONCIRCUIT:{p:'IFCDISTRIBUTIONSYSTEM',a:{}},
  IFCDISTRIBUTIONCONTROLELEMENT:{p:'IFCDISTRIBUTIONELEMENT',a:{}},
  IFCDISTRIBUTIONCONTROLELEMENTTYPE:{p:'IFCDISTRIBUTIONELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONELEMENT:{p:'IFCELEMENT',a:{}},
  IFCDISTRIBUTIONELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONFLOWELEMENT:{p:'IFCDISTRIBUTIONELEMENT',a:{}},
  IFCDISTRIBUTIONFLOWELEMENTTYPE:{p:'IFCDISTRIBUTIONELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONPORT:{p:'IFCPORT',a:{FlowDirection:'enum',PredefinedType:'enum',SystemType:'enum'}},
  IFCDISTRIBUTIONSYSTEM:{p:'IFCSYSTEM',a:{LongName:'string',PredefinedType:'enum'}},
  IFCDOCUMENTINFORMATION:{p:'IFCEXTERNALINFORMATION',a:{Confidentiality:'enum',CreationTime:'string',Description:'string',ElectronicFormat:'string',Identification:'string',IntendedUse:'string',LastRevisionTime:'string',Location:'string',Name:'string',Purpose:'string',Revision:'string',Scope:'string',Status:'enum',ValidFrom:'string',ValidUntil:'string'}},
  IFCDOCUMENTINFORMATIONRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{RelationshipType:'string'}},
  IFCDOCUMENTREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{Description:'string'}},
  IFCDOOR:{p:'IFCBUILDINGELEMENT',a:{OperationType:'enum',OverallHeight:'real',OverallWidth:'real',PredefinedType:'enum',UserDefinedOperationType:'string'}},
  IFCDOORLININGPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{CasingDepth:'real',CasingThickness:'real',LiningDepth:'real',LiningOffset:'real',LiningThickness:'real',LiningToPanelOffsetX:'real',LiningToPanelOffsetY:'real',ThresholdDepth:'real',ThresholdOffset:'real',ThresholdThickness:'real',TransomOffset:'real',TransomThickness:'real'}},
  IFCDOORPANELPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{PanelDepth:'real',PanelOperation:'enum',PanelPosition:'enum',PanelWidth:'real'}},
  IFCDOORSTANDARDCASE:{p:'IFCDOOR',a:{}},
  IFCDOORSTYLE:{p:'IFCTYPEPRODUCT',a:{ConstructionType:'enum',OperationType:'enum',ParameterTakesPrecedence:'boolean',Sizeable:'boolean'}},
  IFCDOORTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{OperationType:'enum',ParameterTakesPrecedence:'boolean',PredefinedType:'enum',UserDefinedOperationType:'string'}},
  IFCDRAUGHTINGPREDEFINEDCOLOUR:{p:'IFCPREDEFINEDCOLOUR',a:{}},
  IFCDRAUGHTINGPREDEFINEDCURVEFONT:{p:'IFCPREDEFINEDCURVEFONT',a:{}},
  IFCDUCTFITTING:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCDUCTFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCDUCTSEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCDUCTSEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCDUCTSILENCER:{p:'IFCFLOWTREATMENTDEVICE',a:{PredefinedType:'enum'}},
  IFCDUCTSILENCERTYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEDGE:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCEDGECURVE:{p:'IFCEDGE',a:{SameSense:'boolean'}},
  IFCEDGELOOP:{p:'IFCLOOP',a:{}},
  IFCELECTRICAPPLIANCE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCELECTRICAPPLIANCETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICDISTRIBUTIONBOARD:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCELECTRICDISTRIBUTIONBOARDTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICFLOWSTORAGEDEVICE:{p:'IFCFLOWSTORAGEDEVICE',a:{PredefinedType:'enum'}},
  IFCELECTRICFLOWSTORAGEDEVICETYPE:{p:'IFCFLOWSTORAGEDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICGENERATOR:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCELECTRICGENERATORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICMOTOR:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCELECTRICMOTORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICTIMECONTROL:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCELECTRICTIMECONTROLTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCELEMENT:{p:'IFCPRODUCT',a:{Tag:'string'}},
  IFCELEMENTASSEMBLY:{p:'IFCELEMENT',a:{AssemblyPlace:'enum',PredefinedType:'enum'}},
  IFCELEMENTASSEMBLYTYPE:{p:'IFCELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCELEMENTCOMPONENT:{p:'IFCELEMENT',a:{}},
  IFCELEMENTCOMPONENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCELEMENTQUANTITY:{p:'IFCQUANTITYSET',a:{MethodOfMeasurement:'string'}},
  IFCELEMENTTYPE:{p:'IFCTYPEPRODUCT',a:{ElementType:'string'}},
  IFCELEMENTARYSURFACE:{p:'IFCSURFACE',a:{}},
  IFCELLIPSE:{p:'IFCCONIC',a:{SemiAxis1:'real',SemiAxis2:'real'}},
  IFCELLIPSEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{SemiAxis1:'real',SemiAxis2:'real'}},
  IFCENERGYCONVERSIONDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCENERGYCONVERSIONDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCENGINE:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCENGINETYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEVAPORATIVECOOLER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCEVAPORATIVECOOLERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEVAPORATOR:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCEVAPORATORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEVENT:{p:'IFCPROCESS',a:{EventTriggerType:'enum',PredefinedType:'enum',UserDefinedEventTriggerType:'string'}},
  IFCEVENTTIME:{p:'IFCSCHEDULINGTIME',a:{ActualDate:'string',EarlyDate:'string',LateDate:'string',ScheduleDate:'string'}},
  IFCEVENTTYPE:{p:'IFCTYPEPROCESS',a:{EventTriggerType:'enum',PredefinedType:'enum',UserDefinedEventTriggerType:'string'}},
  IFCEXTENDEDPROPERTIES:{p:'IFCPROPERTYABSTRACTION',a:{Description:'string',Name:'string'}},
  IFCEXTERNALREFERENCE:{p:null,a:{Identification:'string',Location:'string',Name:'string'}},
  IFCEXTERNALREFERENCERELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCEXTERNALSPATIALELEMENT:{p:'IFCEXTERNALSPATIALSTRUCTUREELEMENT',a:{PredefinedType:'enum'}},
  IFCEXTERNALSPATIALSTRUCTUREELEMENT:{p:'IFCSPATIALELEMENT',a:{}},
  IFCEXTERNALLYDEFINEDHATCHSTYLE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTERNALLYDEFINEDSURFACESTYLE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTERNALLYDEFINEDTEXTFONT:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTRUDEDAREASOLID:{p:'IFCSWEPTAREASOLID',a:{Depth:'real'}},
  IFCEXTRUDEDAREASOLIDTAPERED:{p:'IFCEXTRUDEDAREASOLID',a:{}},
  IFCFACE:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCFACEBASEDSURFACEMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCFACEBOUND:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{Orientation:'boolean'}},
  IFCFACEOUTERBOUND:{p:'IFCFACEBOUND',a:{}},
  IFCFACESURFACE:{p:'IFCFACE',a:{SameSense:'boolean'}},
  IFCFACETEDBREP:{p:'IFCMANIFOLDSOLIDBREP',a:{}},
  IFCFACETEDBREPWITHVOIDS:{p:'IFCFACETEDBREP',a:{}},
  IFCFAILURECONNECTIONCONDITION:{p:'IFCSTRUCTURALCONNECTIONCONDITION',a:{CompressionFailureX:'real',CompressionFailureY:'real',CompressionFailureZ:'real',TensionFailureX:'real',TensionFailureY:'real',TensionFailureZ:'real'}},
  IFCFAN:{p:'IFCFLOWMOVINGDEVICE',a:{PredefinedType:'enum'}},
  IFCFANTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCFASTENER:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCFASTENERTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCFEATUREELEMENT:{p:'IFCELEMENT',a:{}},
  IFCFEATUREELEMENTADDITION:{p:'IFCFEATUREELEMENT',a:{}},
  IFCFEATUREELEMENTSUBTRACTION:{p:'IFCFEATUREELEMENT',a:{}},
  IFCFILLAREASTYLE:{p:'IFCPRESENTATIONSTYLE',a:{ModelorDraughting:'boolean'}},
  IFCFILLAREASTYLEHATCHING:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{HatchLineAngle:'real'}},
  IFCFILLAREASTYLETILES:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{TilingScale:'real'}},
  IFCFILTER:{p:'IFCFLOWTREATMENTDEVICE',a:{PredefinedType:'enum'}},
  IFCFILTERTYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCFIRESUPPRESSIONTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCFIRESUPPRESSIONTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCFIXEDREFERENCESWEPTAREASOLID:{p:'IFCSWEPTAREASOLID',a:{EndParam:'real',StartParam:'real'}},
  IFCFLOWCONTROLLER:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWCONTROLLERTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWFITTING:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWFITTINGTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWINSTRUMENT:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCFLOWINSTRUMENTTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCFLOWMETER:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCFLOWMETERTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCFLOWMOVINGDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWMOVINGDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWSEGMENT:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWSEGMENTTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWSTORAGEDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWSTORAGEDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWTERMINAL:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWTERMINALTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWTREATMENTDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWTREATMENTDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFOOTING:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCFOOTINGTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCFURNISHINGELEMENT:{p:'IFCELEMENT',a:{}},
  IFCFURNISHINGELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCFURNITURE:{p:'IFCFURNISHINGELEMENT',a:{PredefinedType:'enum'}},
  IFCFURNITURETYPE:{p:'IFCFURNISHINGELEMENTTYPE',a:{AssemblyPlace:'enum',PredefinedType:'enum'}},
  IFCGEOGRAPHICELEMENT:{p:'IFCELEMENT',a:{PredefinedType:'enum'}},
  IFCGEOGRAPHICELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCGEOMETRICCURVESET:{p:'IFCGEOMETRICSET',a:{}},
  IFCGEOMETRICREPRESENTATIONCONTEXT:{p:'IFCREPRESENTATIONCONTEXT',a:{CoordinateSpaceDimension:'integer',Precision:'real'}},
  IFCGEOMETRICREPRESENTATIONITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCGEOMETRICREPRESENTATIONSUBCONTEXT:{p:'IFCGEOMETRICREPRESENTATIONCONTEXT',a:{TargetScale:'real',TargetView:'enum',UserDefinedTargetView:'string'}},
  IFCGEOMETRICSET:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCGRID:{p:'IFCPRODUCT',a:{PredefinedType:'enum'}},
  IFCGRIDAXIS:{p:null,a:{AxisTag:'string',SameSense:'boolean'}},
  IFCGRIDPLACEMENT:{p:'IFCOBJECTPLACEMENT',a:{}},
  IFCGROUP:{p:'IFCOBJECT',a:{}},
  IFCHALFSPACESOLID:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{AgreementFlag:'boolean'}},
  IFCHEATEXCHANGER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCHEATEXCHANGERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCHUMIDIFIER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCHUMIDIFIERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCISHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{FilletRadius:'real',FlangeEdgeRadius:'real',FlangeSlope:'real',FlangeThickness:'real',OverallDepth:'real',OverallWidth:'real',WebThickness:'real'}},
  IFCIMAGETEXTURE:{p:'IFCSURFACETEXTURE',a:{URLReference:'string'}},
  IFCINDEXEDCOLOURMAP:{p:'IFCPRESENTATIONITEM',a:{Opacity:'real'}},
  IFCINDEXEDPOLYCURVE:{p:'IFCBOUNDEDCURVE',a:{SelfIntersect:'boolean'}},
  IFCINDEXEDPOLYGONALFACE:{p:'IFCTESSELLATEDITEM',a:{}},
  IFCINDEXEDPOLYGONALFACEWITHVOIDS:{p:'IFCINDEXEDPOLYGONALFACE',a:{}},
  IFCINDEXEDTEXTUREMAP:{p:'IFCTEXTURECOORDINATE',a:{}},
  IFCINDEXEDTRIANGLETEXTUREMAP:{p:'IFCINDEXEDTEXTUREMAP',a:{}},
  IFCINTERCEPTOR:{p:'IFCFLOWTREATMENTDEVICE',a:{PredefinedType:'enum'}},
  IFCINTERCEPTORTYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCINTERSECTIONCURVE:{p:'IFCSURFACECURVE',a:{}},
  IFCINVENTORY:{p:'IFCGROUP',a:{LastUpdateDate:'string',PredefinedType:'enum'}},
  IFCIRREGULARTIMESERIES:{p:'IFCTIMESERIES',a:{}},
  IFCIRREGULARTIMESERIESVALUE:{p:null,a:{TimeStamp:'string'}},
  IFCJUNCTIONBOX:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCJUNCTIONBOXTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCLSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',EdgeRadius:'real',FilletRadius:'real',LegSlope:'real',Thickness:'real',Width:'real'}},
  IFCLABORRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCLABORRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCLAGTIME:{p:'IFCSCHEDULINGTIME',a:{DurationType:'enum'}},
  IFCLAMP:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCLAMPTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCLIBRARYINFORMATION:{p:'IFCEXTERNALINFORMATION',a:{Description:'string',Location:'string',Name:'string',Version:'string',VersionDate:'string'}},
  IFCLIBRARYREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{Description:'string',Language:'string'}},
  IFCLIGHTDISTRIBUTIONDATA:{p:null,a:{MainPlaneAngle:'real'}},
  IFCLIGHTFIXTURE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCLIGHTFIXTURETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCLIGHTINTENSITYDISTRIBUTION:{p:null,a:{LightDistributionCurve:'enum'}},
  IFCLIGHTSOURCE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{AmbientIntensity:'real',Intensity:'real',Name:'string'}},
  IFCLIGHTSOURCEAMBIENT:{p:'IFCLIGHTSOURCE',a:{}},
  IFCLIGHTSOURCEDIRECTIONAL:{p:'IFCLIGHTSOURCE',a:{}},
  IFCLIGHTSOURCEGONIOMETRIC:{p:'IFCLIGHTSOURCE',a:{ColourTemperature:'real',LightEmissionSource:'enum',LuminousFlux:'real'}},
  IFCLIGHTSOURCEPOSITIONAL:{p:'IFCLIGHTSOURCE',a:{ConstantAttenuation:'real',DistanceAttenuation:'real',QuadricAttenuation:'real',Radius:'real'}},
  IFCLIGHTSOURCESPOT:{p:'IFCLIGHTSOURCEPOSITIONAL',a:{BeamWidthAngle:'real',ConcentrationExponent:'real',SpreadAngle:'real'}},
  IFCLINE:{p:'IFCCURVE',a:{}},
  IFCLOCALPLACEMENT:{p:'IFCOBJECTPLACEMENT',a:{}},
  IFCLOOP:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCMANIFOLDSOLIDBREP:{p:'IFCSOLIDMODEL',a:{}},
  IFCMAPCONVERSION:{p:'IFCCOORDINATEOPERATION',a:{Eastings:'real',Northings:'real',OrthogonalHeight:'real',Scale:'real',XAxisAbscissa:'real',XAxisOrdinate:'real'}},
  IFCMAPPEDITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCMATERIAL:{p:'IFCMATERIALDEFINITION',a:{Category:'string',Description:'string',Name:'string'}},
  IFCMATERIALCONSTITUENT:{p:'IFCMATERIALDEFINITION',a:{Category:'string',Description:'string',Fraction:'real',Name:'string'}},
  IFCMATERIALCONSTITUENTSET:{p:'IFCMATERIALDEFINITION',a:{Description:'string',Name:'string'}},
  IFCMATERIALDEFINITIONREPRESENTATION:{p:'IFCPRODUCTREPRESENTATION',a:{}},
  IFCMATERIALLAYER:{p:'IFCMATERIALDEFINITION',a:{Category:'string',Description:'string',IsVentilated:'logical',LayerThickness:'real',Name:'string',Priority:'integer'}},
  IFCMATERIALLAYERSET:{p:'IFCMATERIALDEFINITION',a:{Description:'string',LayerSetName:'string'}},
  IFCMATERIALLAYERSETUSAGE:{p:'IFCMATERIALUSAGEDEFINITION',a:{DirectionSense:'enum',LayerSetDirection:'enum',OffsetFromReferenceLine:'real',ReferenceExtent:'real'}},
  IFCMATERIALLAYERWITHOFFSETS:{p:'IFCMATERIALLAYER',a:{OffsetDirection:'enum',OffsetValues:'real'}},
  IFCMATERIALPROFILE:{p:'IFCMATERIALDEFINITION',a:{Category:'string',Description:'string',Name:'string',Priority:'integer'}},
  IFCMATERIALPROFILESET:{p:'IFCMATERIALDEFINITION',a:{Description:'string',Name:'string'}},
  IFCMATERIALPROFILESETUSAGE:{p:'IFCMATERIALUSAGEDEFINITION',a:{CardinalPoint:'integer',ReferenceExtent:'real'}},
  IFCMATERIALPROFILESETUSAGETAPERING:{p:'IFCMATERIALPROFILESETUSAGE',a:{CardinalEndPoint:'integer'}},
  IFCMATERIALPROFILEWITHOFFSETS:{p:'IFCMATERIALPROFILE',a:{OffsetValues:'real'}},
  IFCMATERIALPROPERTIES:{p:'IFCEXTENDEDPROPERTIES',a:{}},
  IFCMATERIALRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{Expression:'string'}},
  IFCMECHANICALFASTENER:{p:'IFCELEMENTCOMPONENT',a:{NominalDiameter:'real',NominalLength:'real',PredefinedType:'enum'}},
  IFCMECHANICALFASTENERTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{NominalDiameter:'real',NominalLength:'real',PredefinedType:'enum'}},
  IFCMEDICALDEVICE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCMEDICALDEVICETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCMEMBER:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCMEMBERSTANDARDCASE:{p:'IFCMEMBER',a:{}},
  IFCMEMBERTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCMETRIC:{p:'IFCCONSTRAINT',a:{Benchmark:'enum',ValueSource:'string'}},
  IFCMIRROREDPROFILEDEF:{p:'IFCDERIVEDPROFILEDEF',a:{}},
  IFCMONETARYUNIT:{p:null,a:{Currency:'string'}},
  IFCMOTORCONNECTION:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCMOTORCONNECTIONTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCNAMEDUNIT:{p:null,a:{UnitType:'enum'}},
  IFCOBJECT:{p:'IFCOBJECTDEFINITION',a:{ObjectType:'string'}},
  IFCOBJECTDEFINITION:{p:'IFCROOT',a:{}},
  IFCOBJECTIVE:{p:'IFCCONSTRAINT',a:{LogicalAggregator:'enum',ObjectiveQualifier:'enum',UserDefinedQualifier:'string'}},
  IFCOCCUPANT:{p:'IFCACTOR',a:{PredefinedType:'enum'}},
  IFCOFFSETCURVE2D:{p:'IFCCURVE',a:{Distance:'real',SelfIntersect:'logical'}},
  IFCOFFSETCURVE3D:{p:'IFCCURVE',a:{Distance:'real',SelfIntersect:'logical'}},
  IFCOPENSHELL:{p:'IFCCONNECTEDFACESET',a:{}},
  IFCOPENINGELEMENT:{p:'IFCFEATUREELEMENTSUBTRACTION',a:{PredefinedType:'enum'}},
  IFCOPENINGSTANDARDCASE:{p:'IFCOPENINGELEMENT',a:{}},
  IFCORGANIZATION:{p:null,a:{Description:'string',Identification:'string',Name:'string'}},
  IFCORGANIZATIONRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCORIENTEDEDGE:{p:'IFCEDGE',a:{Orientation:'boolean'}},
  IFCOUTERBOUNDARYCURVE:{p:'IFCBOUNDARYCURVE',a:{}},
  IFCOUTLET:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCOUTLETTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCOWNERHISTORY:{p:null,a:{ChangeAction:'enum',CreationDate:'integer',LastModifiedDate:'integer',State:'enum'}},
  IFCPARAMETERIZEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCPATH:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCPCURVE:{p:'IFCCURVE',a:{}},
  IFCPERFORMANCEHISTORY:{p:'IFCCONTROL',a:{LifeCyclePhase:'string',PredefinedType:'enum'}},
  IFCPERMEABLECOVERINGPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{FrameDepth:'real',FrameThickness:'real',OperationType:'enum',PanelPosition:'enum'}},
  IFCPERMIT:{p:'IFCCONTROL',a:{LongDescription:'string',PredefinedType:'enum',Status:'string'}},
  IFCPERSON:{p:null,a:{FamilyName:'string',GivenName:'string',Identification:'string'}},
  IFCPHYSICALCOMPLEXQUANTITY:{p:'IFCPHYSICALQUANTITY',a:{Discrimination:'string',Quality:'string',Usage:'string'}},
  IFCPHYSICALQUANTITY:{p:null,a:{Description:'string',Name:'string'}},
  IFCPHYSICALSIMPLEQUANTITY:{p:'IFCPHYSICALQUANTITY',a:{}},
  IFCPILE:{p:'IFCBUILDINGELEMENT',a:{ConstructionType:'enum',PredefinedType:'enum'}},
  IFCPILETYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPIPEFITTING:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCPIPEFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCPIPESEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCPIPESEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPIXELTEXTURE:{p:'IFCSURFACETEXTURE',a:{ColourComponents:'integer',Height:'integer',Width:'integer'}},
  IFCPLACEMENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCPLANARBOX:{p:'IFCPLANAREXTENT',a:{}},
  IFCPLANAREXTENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{SizeInX:'real',SizeInY:'real'}},
  IFCPLANE:{p:'IFCELEMENTARYSURFACE',a:{}},
  IFCPLATE:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCPLATESTANDARDCASE:{p:'IFCPLATE',a:{}},
  IFCPLATETYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPOINT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCPOINTONCURVE:{p:'IFCPOINT',a:{PointParameter:'real'}},
  IFCPOINTONSURFACE:{p:'IFCPOINT',a:{PointParameterU:'real',PointParameterV:'real'}},
  IFCPOLYLOOP:{p:'IFCLOOP',a:{}},
  IFCPOLYGONALBOUNDEDHALFSPACE:{p:'IFCHALFSPACESOLID',a:{}},
  IFCPOLYGONALFACESET:{p:'IFCTESSELLATEDFACESET',a:{Closed:'boolean'}},
  IFCPOLYLINE:{p:'IFCBOUNDEDCURVE',a:{}},
  IFCPORT:{p:'IFCPRODUCT',a:{}},
  IFCPOSTALADDRESS:{p:'IFCADDRESS',a:{Country:'string',InternalLocation:'string',PostalBox:'string',PostalCode:'string',Region:'string',Town:'string'}},
  IFCPREDEFINEDCOLOUR:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPREDEFINEDCURVEFONT:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPREDEFINEDITEM:{p:'IFCPRESENTATIONITEM',a:{Name:'string'}},
  IFCPREDEFINEDPROPERTIES:{p:'IFCPROPERTYABSTRACTION',a:{}},
  IFCPREDEFINEDPROPERTYSET:{p:'IFCPROPERTYSETDEFINITION',a:{}},
  IFCPREDEFINEDTEXTFONT:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPRESENTATIONLAYERASSIGNMENT:{p:null,a:{Description:'string',Identifier:'string',Name:'string'}},
  IFCPRESENTATIONLAYERWITHSTYLE:{p:'IFCPRESENTATIONLAYERASSIGNMENT',a:{LayerBlocked:'logical',LayerFrozen:'logical',LayerOn:'logical'}},
  IFCPRESENTATIONSTYLE:{p:null,a:{Name:'string'}},
  IFCPROCEDURE:{p:'IFCPROCESS',a:{PredefinedType:'enum'}},
  IFCPROCEDURETYPE:{p:'IFCTYPEPROCESS',a:{PredefinedType:'enum'}},
  IFCPROCESS:{p:'IFCOBJECT',a:{Identification:'string',LongDescription:'string'}},
  IFCPRODUCT:{p:'IFCOBJECT',a:{}},
  IFCPRODUCTDEFINITIONSHAPE:{p:'IFCPRODUCTREPRESENTATION',a:{}},
  IFCPRODUCTREPRESENTATION:{p:null,a:{Description:'string',Name:'string'}},
  IFCPROFILEDEF:{p:null,a:{ProfileName:'string',ProfileType:'enum'}},
  IFCPROFILEPROPERTIES:{p:'IFCEXTENDEDPROPERTIES',a:{}},
  IFCPROJECT:{p:'IFCCONTEXT',a:{}},
  IFCPROJECTLIBRARY:{p:'IFCCONTEXT',a:{}},
  IFCPROJECTORDER:{p:'IFCCONTROL',a:{LongDescription:'string',PredefinedType:'enum',Status:'string'}},
  IFCPROJECTEDCRS:{p:'IFCCOORDINATEREFERENCESYSTEM',a:{MapProjection:'string',MapZone:'string'}},
  IFCPROJECTIONELEMENT:{p:'IFCFEATUREELEMENTADDITION',a:{PredefinedType:'enum'}},
  IFCPROPERTY:{p:'IFCPROPERTYABSTRACTION',a:{Description:'string',Name:'string'}},
  IFCPROPERTYBOUNDEDVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYDEFINITION:{p:'IFCROOT',a:{}},
  IFCPROPERTYDEPENDENCYRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{Expression:'string'}},
  IFCPROPERTYENUMERATEDVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYENUMERATION:{p:'IFCPROPERTYABSTRACTION',a:{Name:'string'}},
  IFCPROPERTYLISTVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYREFERENCEVALUE:{p:'IFCSIMPLEPROPERTY',a:{UsageName:'string'}},
  IFCPROPERTYSET:{p:'IFCPROPERTYSETDEFINITION',a:{}},
  IFCPROPERTYSETDEFINITION:{p:'IFCPROPERTYDEFINITION',a:{}},
  IFCPROPERTYSETTEMPLATE:{p:'IFCPROPERTYTEMPLATEDEFINITION',a:{ApplicableEntity:'string',TemplateType:'enum'}},
  IFCPROPERTYSINGLEVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYTABLEVALUE:{p:'IFCSIMPLEPROPERTY',a:{CurveInterpolation:'enum',Expression:'string'}},
  IFCPROPERTYTEMPLATE:{p:'IFCPROPERTYTEMPLATEDEFINITION',a:{}},
  IFCPROPERTYTEMPLATEDEFINITION:{p:'IFCPROPERTYDEFINITION',a:{}},
  IFCPROTECTIVEDEVICE:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCPROTECTIVEDEVICETRIPPINGUNIT:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCPROTECTIVEDEVICETRIPPINGUNITTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPROTECTIVEDEVICETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCPROXY:{p:'IFCPRODUCT',a:{ProxyType:'enum',Tag:'string'}},
  IFCPUMP:{p:'IFCFLOWMOVINGDEVICE',a:{PredefinedType:'enum'}},
  IFCPUMPTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCQUANTITYAREA:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{AreaValue:'real',Formula:'string'}},
  IFCQUANTITYCOUNT:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{CountValue:'real',Formula:'string'}},
  IFCQUANTITYLENGTH:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',LengthValue:'real'}},
  IFCQUANTITYSET:{p:'IFCPROPERTYSETDEFINITION',a:{}},
  IFCQUANTITYTIME:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',TimeValue:'real'}},
  IFCQUANTITYVOLUME:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',VolumeValue:'real'}},
  IFCQUANTITYWEIGHT:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',WeightValue:'real'}},
  IFCRAILING:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCRAILINGTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRAMP:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCRAMPFLIGHT:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCRAMPFLIGHTTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRAMPTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRATIONALBSPLINECURVEWITHKNOTS:{p:'IFCBSPLINECURVEWITHKNOTS',a:{}},
  IFCRATIONALBSPLINESURFACEWITHKNOTS:{p:'IFCBSPLINESURFACEWITHKNOTS',a:{}},
  IFCRECTANGLEHOLLOWPROFILEDEF:{p:'IFCRECTANGLEPROFILEDEF',a:{InnerFilletRadius:'real',OuterFilletRadius:'real',WallThickness:'real'}},
  IFCRECTANGLEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{XDim:'real',YDim:'real'}},
  IFCRECTANGULARPYRAMID:{p:'IFCCSGPRIMITIVE3D',a:{Height:'real',XLength:'real',YLength:'real'}},
  IFCRECTANGULARTRIMMEDSURFACE:{p:'IFCBOUNDEDSURFACE',a:{U1:'real',U2:'real',Usense:'boolean',V1:'real',V2:'real',Vsense:'boolean'}},
  IFCRECURRENCEPATTERN:{p:null,a:{Interval:'integer',Occurrences:'integer',Position:'integer',RecurrenceType:'enum'}},
  IFCREFERENCE:{p:null,a:{AttributeIdentifier:'string',InstanceName:'string',TypeIdentifier:'string'}},
  IFCREGULARTIMESERIES:{p:'IFCTIMESERIES',a:{TimeStep:'real'}},
  IFCREINFORCEMENTBARPROPERTIES:{p:'IFCPREDEFINEDPROPERTIES',a:{BarCount:'real',BarSurface:'enum',EffectiveDepth:'real',NominalBarDiameter:'real',SteelGrade:'string',TotalCrossSectionArea:'real'}},
  IFCREINFORCEMENTDEFINITIONPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{DefinitionType:'string'}},
  IFCREINFORCINGBAR:{p:'IFCREINFORCINGELEMENT',a:{BarLength:'real',BarSurface:'enum',CrossSectionArea:'real',NominalDiameter:'real',PredefinedType:'enum'}},
  IFCREINFORCINGBARTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{BarLength:'real',BarSurface:'enum',BendingShapeCode:'string',CrossSectionArea:'real',NominalDiameter:'real',PredefinedType:'enum'}},
  IFCREINFORCINGELEMENT:{p:'IFCELEMENTCOMPONENT',a:{SteelGrade:'string'}},
  IFCREINFORCINGELEMENTTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{}},
  IFCREINFORCINGMESH:{p:'IFCREINFORCINGELEMENT',a:{LongitudinalBarCrossSectionArea:'real',LongitudinalBarNominalDiameter:'real',LongitudinalBarSpacing:'real',MeshLength:'real',MeshWidth:'real',PredefinedType:'enum',TransverseBarCrossSectionArea:'real',TransverseBarNominalDiameter:'real',TransverseBarSpacing:'real'}},
  IFCREINFORCINGMESHTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{BendingShapeCode:'string',LongitudinalBarCrossSectionArea:'real',LongitudinalBarNominalDiameter:'real',LongitudinalBarSpacing:'real',MeshLength:'real',MeshWidth:'real',PredefinedType:'enum',TransverseBarCrossSectionArea:'real',TransverseBarNominalDiameter:'real',TransverseBarSpacing:'real'}},
  IFCRELAGGREGATES:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELASSIGNS:{p:'IFCRELATIONSHIP',a:{RelatedObjectsType:'enum'}},
  IFCRELASSIGNSTOACTOR:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOCONTROL:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOGROUP:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOGROUPBYFACTOR:{p:'IFCRELASSIGNSTOGROUP',a:{Factor:'real'}},
  IFCRELASSIGNSTOPROCESS:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOPRODUCT:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTORESOURCE:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSOCIATES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELASSOCIATESAPPROVAL:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESCLASSIFICATION:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESCONSTRAINT:{p:'IFCRELASSOCIATES',a:{Intent:'string'}},
  IFCRELASSOCIATESDOCUMENT:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESLIBRARY:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESMATERIAL:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELCONNECTS:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELCONNECTSELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSPATHELEMENTS:{p:'IFCRELCONNECTSELEMENTS',a:{RelatedConnectionType:'enum',RelatingConnectionType:'enum'}},
  IFCRELCONNECTSPORTTOELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSPORTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSSTRUCTURALACTIVITY:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSSTRUCTURALMEMBER:{p:'IFCRELCONNECTS',a:{SupportedLength:'real'}},
  IFCRELCONNECTSWITHECCENTRICITY:{p:'IFCRELCONNECTSSTRUCTURALMEMBER',a:{}},
  IFCRELCONNECTSWITHREALIZINGELEMENTS:{p:'IFCRELCONNECTSELEMENTS',a:{ConnectionType:'string'}},
  IFCRELCONTAINEDINSPATIALSTRUCTURE:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCOVERSBLDGELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCOVERSSPACES:{p:'IFCRELCONNECTS',a:{}},
  IFCRELDECLARES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELDECOMPOSES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELDEFINES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELDEFINESBYOBJECT:{p:'IFCRELDEFINES',a:{}},
  IFCRELDEFINESBYPROPERTIES:{p:'IFCRELDEFINES',a:{}},
  IFCRELDEFINESBYTEMPLATE:{p:'IFCRELDEFINES',a:{}},
  IFCRELDEFINESBYTYPE:{p:'IFCRELDEFINES',a:{}},
  IFCRELFILLSELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELFLOWCONTROLELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELINTERFERESELEMENTS:{p:'IFCRELCONNECTS',a:{InterferenceType:'string'}},
  IFCRELNESTS:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELPROJECTSELEMENT:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELREFERENCEDINSPATIALSTRUCTURE:{p:'IFCRELCONNECTS',a:{}},
  IFCRELSEQUENCE:{p:'IFCRELCONNECTS',a:{SequenceType:'enum',UserDefinedSequenceType:'string'}},
  IFCRELSERVICESBUILDINGS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELSPACEBOUNDARY:{p:'IFCRELCONNECTS',a:{InternalOrExternalBoundary:'enum',PhysicalOrVirtualBoundary:'enum'}},
  IFCRELSPACEBOUNDARY1STLEVEL:{p:'IFCRELSPACEBOUNDARY',a:{}},
  IFCRELSPACEBOUNDARY2NDLEVEL:{p:'IFCRELSPACEBOUNDARY1STLEVEL',a:{}},
  IFCRELVOIDSELEMENT:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELATIONSHIP:{p:'IFCROOT',a:{}},
  IFCREPARAMETRISEDCOMPOSITECURVESEGMENT:{p:'IFCCOMPOSITECURVESEGMENT',a:{ParamLength:'real'}},
  IFCREPRESENTATION:{p:null,a:{RepresentationIdentifier:'string',RepresentationType:'string'}},
  IFCREPRESENTATIONCONTEXT:{p:null,a:{ContextIdentifier:'string',ContextType:'string'}},
  IFCRESOURCE:{p:'IFCOBJECT',a:{Identification:'string',LongDescription:'string'}},
  IFCRESOURCEAPPROVALRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCRESOURCECONSTRAINTRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCRESOURCELEVELRELATIONSHIP:{p:null,a:{Description:'string',Name:'string'}},
  IFCRESOURCETIME:{p:'IFCSCHEDULINGTIME',a:{ActualFinish:'string',ActualStart:'string',ActualUsage:'real',ActualWork:'string',Completion:'real',IsOverAllocated:'boolean',LevelingDelay:'string',RemainingUsage:'real',RemainingWork:'string',ScheduleContour:'string',ScheduleFinish:'string',ScheduleStart:'string',ScheduleUsage:'real',ScheduleWork:'string',StatusTime:'string'}},
  IFCREVOLVEDAREASOLID:{p:'IFCSWEPTAREASOLID',a:{Angle:'real'}},
  IFCREVOLVEDAREASOLIDTAPERED:{p:'IFCREVOLVEDAREASOLID',a:{}},
  IFCRIGHTCIRCULARCONE:{p:'IFCCSGPRIMITIVE3D',a:{BottomRadius:'real',Height:'real'}},
  IFCRIGHTCIRCULARCYLINDER:{p:'IFCCSGPRIMITIVE3D',a:{Height:'real',Radius:'real'}},
  IFCROOF:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCROOFTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCROOT:{p:null,a:{Description:'string',GlobalId:'string',Name:'string'}},
  IFCROUNDEDRECTANGLEPROFILEDEF:{p:'IFCRECTANGLEPROFILEDEF',a:{RoundingRadius:'real'}},
  IFCSIUNIT:{p:'IFCNAMEDUNIT',a:{Name:'enum',Prefix:'enum'}},
  IFCSANITARYTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCSANITARYTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSCHEDULINGTIME:{p:null,a:{DataOrigin:'enum',Name:'string',UserDefinedDataOrigin:'string'}},
  IFCSEAMCURVE:{p:'IFCSURFACECURVE',a:{}},
  IFCSECTIONPROPERTIES:{p:'IFCPREDEFINEDPROPERTIES',a:{SectionType:'enum'}},
  IFCSECTIONREINFORCEMENTPROPERTIES:{p:'IFCPREDEFINEDPROPERTIES',a:{LongitudinalEndPosition:'real',LongitudinalStartPosition:'real',ReinforcementRole:'enum',TransversePosition:'real'}},
  IFCSECTIONEDSPINE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSENSOR:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCSENSORTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSHADINGDEVICE:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCSHADINGDEVICETYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSHAPEASPECT:{p:null,a:{Description:'string',Name:'string',ProductDefinitional:'logical'}},
  IFCSHAPEMODEL:{p:'IFCREPRESENTATION',a:{}},
  IFCSHAPEREPRESENTATION:{p:'IFCSHAPEMODEL',a:{}},
  IFCSHELLBASEDSURFACEMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSIMPLEPROPERTY:{p:'IFCPROPERTY',a:{}},
  IFCSIMPLEPROPERTYTEMPLATE:{p:'IFCPROPERTYTEMPLATE',a:{AccessState:'enum',Expression:'string',PrimaryMeasureType:'string',SecondaryMeasureType:'string',TemplateType:'enum'}},
  IFCSITE:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{LandTitleNumber:'string',RefElevation:'real'}},
  IFCSLAB:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCSLABELEMENTEDCASE:{p:'IFCSLAB',a:{}},
  IFCSLABSTANDARDCASE:{p:'IFCSLAB',a:{}},
  IFCSLABTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSLIPPAGECONNECTIONCONDITION:{p:'IFCSTRUCTURALCONNECTIONCONDITION',a:{SlippageX:'real',SlippageY:'real',SlippageZ:'real'}},
  IFCSOLARDEVICE:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCSOLARDEVICETYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCSOLIDMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSPACE:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{ElevationWithFlooring:'real',PredefinedType:'enum'}},
  IFCSPACEHEATER:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCSPACEHEATERTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSPACETYPE:{p:'IFCSPATIALSTRUCTUREELEMENTTYPE',a:{LongName:'string',PredefinedType:'enum'}},
  IFCSPATIALELEMENT:{p:'IFCPRODUCT',a:{LongName:'string'}},
  IFCSPATIALELEMENTTYPE:{p:'IFCTYPEPRODUCT',a:{ElementType:'string'}},
  IFCSPATIALSTRUCTUREELEMENT:{p:'IFCSPATIALELEMENT',a:{CompositionType:'enum'}},
  IFCSPATIALSTRUCTUREELEMENTTYPE:{p:'IFCSPATIALELEMENTTYPE',a:{}},
  IFCSPATIALZONE:{p:'IFCSPATIALELEMENT',a:{PredefinedType:'enum'}},
  IFCSPATIALZONETYPE:{p:'IFCSPATIALELEMENTTYPE',a:{LongName:'string',PredefinedType:'enum'}},
  IFCSPHERE:{p:'IFCCSGPRIMITIVE3D',a:{Radius:'real'}},
  IFCSPHERICALSURFACE:{p:'IFCELEMENTARYSURFACE',a:{Radius:'real'}},
  IFCSTACKTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCSTACKTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSTAIR:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCSTAIRFLIGHT:{p:'IFCBUILDINGELEMENT',a:{NumberOfRisers:'integer',NumberOfTreads:'integer',PredefinedType:'enum',RiserHeight:'real',TreadLength:'real'}},
  IFCSTAIRFLIGHTTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSTAIRTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALACTION:{p:'IFCSTRUCTURALACTIVITY',a:{DestabilizingLoad:'boolean'}},
  IFCSTRUCTURALACTIVITY:{p:'IFCPRODUCT',a:{GlobalOrLocal:'enum'}},
  IFCSTRUCTURALANALYSISMODEL:{p:'IFCSYSTEM',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALCONNECTION:{p:'IFCSTRUCTURALITEM',a:{}},
  IFCSTRUCTURALCONNECTIONCONDITION:{p:null,a:{Name:'string'}},
  IFCSTRUCTURALCURVEACTION:{p:'IFCSTRUCTURALACTION',a:{PredefinedType:'enum',ProjectedOrTrue:'enum'}},
  IFCSTRUCTURALCURVECONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALCURVEMEMBER:{p:'IFCSTRUCTURALMEMBER',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALCURVEMEMBERVARYING:{p:'IFCSTRUCTURALCURVEMEMBER',a:{}},
  IFCSTRUCTURALCURVEREACTION:{p:'IFCSTRUCTURALREACTION',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALITEM:{p:'IFCPRODUCT',a:{}},
  IFCSTRUCTURALLINEARACTION:{p:'IFCSTRUCTURALCURVEACTION',a:{}},
  IFCSTRUCTURALLOAD:{p:null,a:{Name:'string'}},
  IFCSTRUCTURALLOADCASE:{p:'IFCSTRUCTURALLOADGROUP',a:{}},
  IFCSTRUCTURALLOADCONFIGURATION:{p:'IFCSTRUCTURALLOAD',a:{}},
  IFCSTRUCTURALLOADGROUP:{p:'IFCGROUP',a:{ActionSource:'enum',ActionType:'enum',Coefficient:'real',PredefinedType:'enum',Purpose:'string'}},
  IFCSTRUCTURALLOADLINEARFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{LinearForceX:'real',LinearForceY:'real',LinearForceZ:'real',LinearMomentX:'real',LinearMomentY:'real',LinearMomentZ:'real'}},
  IFCSTRUCTURALLOADORRESULT:{p:'IFCSTRUCTURALLOAD',a:{}},
  IFCSTRUCTURALLOADPLANARFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{PlanarForceX:'real',PlanarForceY:'real',PlanarForceZ:'real'}},
  IFCSTRUCTURALLOADSINGLEDISPLACEMENT:{p:'IFCSTRUCTURALLOADSTATIC',a:{DisplacementX:'real',DisplacementY:'real',DisplacementZ:'real',RotationalDisplacementRX:'real',RotationalDisplacementRY:'real',RotationalDisplacementRZ:'real'}},
  IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION:{p:'IFCSTRUCTURALLOADSINGLEDISPLACEMENT',a:{Distortion:'real'}},
  IFCSTRUCTURALLOADSINGLEFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{ForceX:'real',ForceY:'real',ForceZ:'real',MomentX:'real',MomentY:'real',MomentZ:'real'}},
  IFCSTRUCTURALLOADSINGLEFORCEWARPING:{p:'IFCSTRUCTURALLOADSINGLEFORCE',a:{WarpingMoment:'real'}},
  IFCSTRUCTURALLOADSTATIC:{p:'IFCSTRUCTURALLOADORRESULT',a:{}},
  IFCSTRUCTURALLOADTEMPERATURE:{p:'IFCSTRUCTURALLOADSTATIC',a:{DeltaTConstant:'real',DeltaTY:'real',DeltaTZ:'real'}},
  IFCSTRUCTURALMEMBER:{p:'IFCSTRUCTURALITEM',a:{}},
  IFCSTRUCTURALPLANARACTION:{p:'IFCSTRUCTURALSURFACEACTION',a:{}},
  IFCSTRUCTURALPOINTACTION:{p:'IFCSTRUCTURALACTION',a:{}},
  IFCSTRUCTURALPOINTCONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALPOINTREACTION:{p:'IFCSTRUCTURALREACTION',a:{}},
  IFCSTRUCTURALREACTION:{p:'IFCSTRUCTURALACTIVITY',a:{}},
  IFCSTRUCTURALRESULTGROUP:{p:'IFCGROUP',a:{IsLinear:'boolean',TheoryType:'enum'}},
  IFCSTRUCTURALSURFACEACTION:{p:'IFCSTRUCTURALACTION',a:{PredefinedType:'enum',ProjectedOrTrue:'enum'}},
  IFCSTRUCTURALSURFACECONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALSURFACEMEMBER:{p:'IFCSTRUCTURALMEMBER',a:{PredefinedType:'enum',Thickness:'real'}},
  IFCSTRUCTURALSURFACEMEMBERVARYING:{p:'IFCSTRUCTURALSURFACEMEMBER',a:{}},
  IFCSTRUCTURALSURFACEREACTION:{p:'IFCSTRUCTURALREACTION',a:{PredefinedType:'enum'}},
  IFCSTYLEMODEL:{p:'IFCREPRESENTATION',a:{}},
  IFCSTYLEDITEM:{p:'IFCREPRESENTATIONITEM',a:{Name:'string'}},
  IFCSTYLEDREPRESENTATION:{p:'IFCSTYLEMODEL',a:{}},
  IFCSUBCONTRACTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCSUBCONTRACTRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCSUBEDGE:{p:'IFCEDGE',a:{}},
  IFCSURFACE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSURFACECURVE:{p:'IFCCURVE',a:{MasterRepresentation:'enum'}},
  IFCSURFACECURVESWEPTAREASOLID:{p:'IFCSWEPTAREASOLID',a:{EndParam:'real',StartParam:'real'}},
  IFCSURFACEFEATURE:{p:'IFCFEATUREELEMENT',a:{PredefinedType:'enum'}},
  IFCSURFACEOFLINEAREXTRUSION:{p:'IFCSWEPTSURFACE',a:{Depth:'real'}},
  IFCSURFACEOFREVOLUTION:{p:'IFCSWEPTSURFACE',a:{}},
  IFCSURFACEREINFORCEMENTAREA:{p:'IFCSTRUCTURALLOADORRESULT',a:{ShearReinforcement:'real'}},
  IFCSURFACESTYLE:{p:'IFCPRESENTATIONSTYLE',a:{Side:'enum'}},
  IFCSURFACESTYLELIGHTING:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCSURFACESTYLEREFRACTION:{p:'IFCPRESENTATIONITEM',a:{DispersionFactor:'real',RefractionIndex:'real'}},
  IFCSURFACESTYLERENDERING:{p:'IFCSURFACESTYLESHADING',a:{ReflectanceMethod:'enum'}},
  IFCSURFACESTYLESHADING:{p:'IFCPRESENTATIONITEM',a:{Transparency:'real'}},
  IFCSURFACESTYLEWITHTEXTURES:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCSURFACETEXTURE:{p:'IFCPRESENTATIONITEM',a:{Mode:'string',RepeatS:'boolean',RepeatT:'boolean'}},
  IFCSWEPTAREASOLID:{p:'IFCSOLIDMODEL',a:{}},
  IFCSWEPTDISKSOLID:{p:'IFCSOLIDMODEL',a:{EndParam:'real',InnerRadius:'real',Radius:'real',StartParam:'real'}},
  IFCSWEPTDISKSOLIDPOLYGONAL:{p:'IFCSWEPTDISKSOLID',a:{FilletRadius:'real'}},
  IFCSWEPTSURFACE:{p:'IFCSURFACE',a:{}},
  IFCSWITCHINGDEVICE:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCSWITCHINGDEVICETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCSYSTEM:{p:'IFCGROUP',a:{}},
  IFCSYSTEMFURNITUREELEMENT:{p:'IFCFURNISHINGELEMENT',a:{PredefinedType:'enum'}},
  IFCSYSTEMFURNITUREELEMENTTYPE:{p:'IFCFURNISHINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCTSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',FilletRadius:'real',FlangeEdgeRadius:'real',FlangeSlope:'real',FlangeThickness:'real',FlangeWidth:'real',WebEdgeRadius:'real',WebSlope:'real',WebThickness:'real'}},
  IFCTABLE:{p:null,a:{Name:'string'}},
  IFCTABLECOLUMN:{p:null,a:{Description:'string',Identifier:'string',Name:'string'}},
  IFCTABLEROW:{p:null,a:{IsHeading:'boolean'}},
  IFCTANK:{p:'IFCFLOWSTORAGEDEVICE',a:{PredefinedType:'enum'}},
  IFCTANKTYPE:{p:'IFCFLOWSTORAGEDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTASK:{p:'IFCPROCESS',a:{IsMilestone:'boolean',PredefinedType:'enum',Priority:'integer',Status:'string',WorkMethod:'string'}},
  IFCTASKTIME:{p:'IFCSCHEDULINGTIME',a:{ActualDuration:'string',ActualFinish:'string',ActualStart:'string',Completion:'real',DurationType:'enum',EarlyFinish:'string',EarlyStart:'string',FreeFloat:'string',IsCritical:'boolean',LateFinish:'string',LateStart:'string',RemainingTime:'string',ScheduleDuration:'string',ScheduleFinish:'string',ScheduleStart:'string',StatusTime:'string',TotalFloat:'string'}},
  IFCTASKTIMERECURRING:{p:'IFCTASKTIME',a:{}},
  IFCTASKTYPE:{p:'IFCTYPEPROCESS',a:{PredefinedType:'enum',WorkMethod:'string'}},
  IFCTELECOMADDRESS:{p:'IFCADDRESS',a:{PagerNumber:'string',WWWHomePageURL:'string'}},
  IFCTENDON:{p:'IFCREINFORCINGELEMENT',a:{AnchorageSlip:'real',CrossSectionArea:'real',FrictionCoefficient:'real',MinCurvatureRadius:'real',NominalDiameter:'real',PreStress:'real',PredefinedType:'enum',TensionForce:'real'}},
  IFCTENDONANCHOR:{p:'IFCREINFORCINGELEMENT',a:{PredefinedType:'enum'}},
  IFCTENDONANCHORTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCTENDONTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{CrossSectionArea:'real',NominalDiameter:'real',PredefinedType:'enum',SheathDiameter:'real'}},
  IFCTESSELLATEDFACESET:{p:'IFCTESSELLATEDITEM',a:{}},
  IFCTESSELLATEDITEM:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCTEXTLITERAL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Literal:'string',Path:'enum'}},
  IFCTEXTLITERALWITHEXTENT:{p:'IFCTEXTLITERAL',a:{BoxAlignment:'string'}},
  IFCTEXTSTYLE:{p:'IFCPRESENTATIONSTYLE',a:{ModelOrDraughting:'boolean'}},
  IFCTEXTSTYLEFONTMODEL:{p:'IFCPREDEFINEDTEXTFONT',a:{FontStyle:'string',FontVariant:'string',FontWeight:'string'}},
  IFCTEXTSTYLEFORDEFINEDFONT:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCTEXTSTYLETEXTMODEL:{p:'IFCPRESENTATIONITEM',a:{TextAlign:'string',TextDecoration:'string',TextTransform:'string'}},
  IFCTEXTURECOORDINATE:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCTEXTURECOORDINATEGENERATOR:{p:'IFCTEXTURECOORDINATE',a:{Mode:'string'}},
  IFCTEXTUREMAP:{p:'IFCTEXTURECOORDINATE',a:{}},
  IFCTEXTUREVERTEX:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCTEXTUREVERTEXLIST:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCTIMEPERIOD:{p:null,a:{EndTime:'string',StartTime:'string'}},
  IFCTIMESERIES:{p:null,a:{DataOrigin:'enum',Description:'string',EndTime:'string',Name:'string',StartTime:'string',TimeSeriesDataType:'enum',UserDefinedDataOrigin:'string'}},
  IFCTOPOLOGICALREPRESENTATIONITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCTOPOLOGYREPRESENTATION:{p:'IFCSHAPEMODEL',a:{}},
  IFCTOROIDALSURFACE:{p:'IFCELEMENTARYSURFACE',a:{MajorRadius:'real',MinorRadius:'real'}},
  IFCTRANSFORMER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCTRANSFORMERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTRANSPORTELEMENT:{p:'IFCELEMENT',a:{PredefinedType:'enum'}},
  IFCTRANSPORTELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCTRAPEZIUMPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{BottomXDim:'real',TopXDim:'real',TopXOffset:'real',YDim:'real'}},
  IFCTRIANGULATEDFACESET:{p:'IFCTESSELLATEDFACESET',a:{Closed:'boolean'}},
  IFCTRIMMEDCURVE:{p:'IFCBOUNDEDCURVE',a:{MasterRepresentation:'enum',SenseAgreement:'boolean'}},
  IFCTUBEBUNDLE:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCTUBEBUNDLETYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTYPEOBJECT:{p:'IFCOBJECTDEFINITION',a:{ApplicableOccurrence:'string'}},
  IFCTYPEPROCESS:{p:'IFCTYPEOBJECT',a:{Identification:'string',LongDescription:'string',ProcessType:'string'}},
  IFCTYPEPRODUCT:{p:'IFCTYPEOBJECT',a:{Tag:'string'}},
  IFCTYPERESOURCE:{p:'IFCTYPEOBJECT',a:{Identification:'string',LongDescription:'string',ResourceType:'string'}},
  IFCUSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',EdgeRadius:'real',FilletRadius:'real',FlangeSlope:'real',FlangeThickness:'real',FlangeWidth:'real',WebThickness:'real'}},
  IFCUNITARYCONTROLELEMENT:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCUNITARYCONTROLELEMENTTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCUNITARYEQUIPMENT:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCUNITARYEQUIPMENTTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCVALVE:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCVALVETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCVECTOR:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Magnitude:'real'}},
  IFCVERTEX:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCVERTEXLOOP:{p:'IFCLOOP',a:{}},
  IFCVERTEXPOINT:{p:'IFCVERTEX',a:{}},
  IFCVIBRATIONISOLATOR:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCVIBRATIONISOLATORTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCVIRTUALELEMENT:{p:'IFCELEMENT',a:{}},
  IFCVOIDINGFEATURE:{p:'IFCFEATUREELEMENTSUBTRACTION',a:{PredefinedType:'enum'}},
  IFCWALL:{p:'IFCBUILDINGELEMENT',a:{PredefinedType:'enum'}},
  IFCWALLELEMENTEDCASE:{p:'IFCWALL',a:{}},
  IFCWALLSTANDARDCASE:{p:'IFCWALL',a:{}},
  IFCWALLTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCWASTETERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCWASTETERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCWINDOW:{p:'IFCBUILDINGELEMENT',a:{OverallHeight:'real',OverallWidth:'real',PartitioningType:'enum',PredefinedType:'enum',UserDefinedPartitioningType:'string'}},
  IFCWINDOWLININGPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{FirstMullionOffset:'real',FirstTransomOffset:'real',LiningDepth:'real',LiningOffset:'real',LiningThickness:'real',LiningToPanelOffsetX:'real',LiningToPanelOffsetY:'real',MullionThickness:'real',SecondMullionOffset:'real',SecondTransomOffset:'real',TransomThickness:'real'}},
  IFCWINDOWPANELPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{FrameDepth:'real',FrameThickness:'real',OperationType:'enum',PanelPosition:'enum'}},
  IFCWINDOWSTANDARDCASE:{p:'IFCWINDOW',a:{}},
  IFCWINDOWSTYLE:{p:'IFCTYPEPRODUCT',a:{ConstructionType:'enum',OperationType:'enum',ParameterTakesPrecedence:'boolean',Sizeable:'boolean'}},
  IFCWINDOWTYPE:{p:'IFCBUILDINGELEMENTTYPE',a:{ParameterTakesPrecedence:'boolean',PartitioningType:'enum',PredefinedType:'enum',UserDefinedPartitioningType:'string'}},
  IFCWORKCALENDAR:{p:'IFCCONTROL',a:{PredefinedType:'enum'}},
  IFCWORKCONTROL:{p:'IFCCONTROL',a:{CreationDate:'string',Duration:'string',FinishTime:'string',Purpose:'string',StartTime:'string',TotalFloat:'string'}},
  IFCWORKPLAN:{p:'IFCWORKCONTROL',a:{PredefinedType:'enum'}},
  IFCWORKSCHEDULE:{p:'IFCWORKCONTROL',a:{PredefinedType:'enum'}},
  IFCWORKTIME:{p:'IFCSCHEDULINGTIME',a:{Finish:'string',Start:'string'}},
  IFCZSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',EdgeRadius:'real',FilletRadius:'real',FlangeThickness:'real',FlangeWidth:'real',WebThickness:'real'}},
  IFCZONE:{p:'IFCSYSTEM',a:{LongName:'string'}},
}

const T4X3: Table = {
  IFCACTIONREQUEST:{p:'IFCCONTROL',a:{LongDescription:'string',PredefinedType:'enum',Status:'string'}},
  IFCACTOR:{p:'IFCOBJECT',a:{}},
  IFCACTORROLE:{p:null,a:{Description:'string',Role:'enum',UserDefinedRole:'string'}},
  IFCACTUATOR:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCACTUATORTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCADDRESS:{p:null,a:{Description:'string',Purpose:'enum',UserDefinedPurpose:'string'}},
  IFCADVANCEDBREP:{p:'IFCMANIFOLDSOLIDBREP',a:{}},
  IFCADVANCEDBREPWITHVOIDS:{p:'IFCADVANCEDBREP',a:{}},
  IFCADVANCEDFACE:{p:'IFCFACESURFACE',a:{}},
  IFCAIRTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCAIRTERMINALBOX:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCAIRTERMINALBOXTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCAIRTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCAIRTOAIRHEATRECOVERY:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCAIRTOAIRHEATRECOVERYTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCALARM:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCALARMTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCALIGNMENT:{p:'IFCLINEARPOSITIONINGELEMENT',a:{PredefinedType:'enum'}},
  IFCALIGNMENTCANT:{p:'IFCLINEARELEMENT',a:{RailHeadDistance:'real'}},
  IFCALIGNMENTCANTSEGMENT:{p:'IFCALIGNMENTPARAMETERSEGMENT',a:{EndCantLeft:'real',EndCantRight:'real',HorizontalLength:'real',PredefinedType:'enum',StartCantLeft:'real',StartCantRight:'real',StartDistAlong:'real'}},
  IFCALIGNMENTHORIZONTAL:{p:'IFCLINEARELEMENT',a:{}},
  IFCALIGNMENTHORIZONTALSEGMENT:{p:'IFCALIGNMENTPARAMETERSEGMENT',a:{EndRadiusOfCurvature:'real',GravityCenterLineHeight:'real',PredefinedType:'enum',SegmentLength:'real',StartDirection:'real',StartRadiusOfCurvature:'real'}},
  IFCALIGNMENTPARAMETERSEGMENT:{p:null,a:{EndTag:'string',StartTag:'string'}},
  IFCALIGNMENTSEGMENT:{p:'IFCLINEARELEMENT',a:{}},
  IFCALIGNMENTVERTICAL:{p:'IFCLINEARELEMENT',a:{}},
  IFCALIGNMENTVERTICALSEGMENT:{p:'IFCALIGNMENTPARAMETERSEGMENT',a:{EndGradient:'real',HorizontalLength:'real',PredefinedType:'enum',RadiusOfCurvature:'real',StartDistAlong:'real',StartGradient:'real',StartHeight:'real'}},
  IFCANNOTATION:{p:'IFCPRODUCT',a:{PredefinedType:'enum'}},
  IFCANNOTATIONFILLAREA:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCAPPLICATION:{p:null,a:{ApplicationFullName:'string',ApplicationIdentifier:'string',Version:'string'}},
  IFCAPPLIEDVALUE:{p:null,a:{ApplicableDate:'string',ArithmeticOperator:'enum',Category:'string',Condition:'string',Description:'string',FixedUntilDate:'string',Name:'string'}},
  IFCAPPROVAL:{p:null,a:{Description:'string',Identifier:'string',Level:'string',Name:'string',Qualifier:'string',Status:'string',TimeOfApproval:'string'}},
  IFCAPPROVALRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCARBITRARYCLOSEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCARBITRARYOPENPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCARBITRARYPROFILEDEFWITHVOIDS:{p:'IFCARBITRARYCLOSEDPROFILEDEF',a:{}},
  IFCASSET:{p:'IFCGROUP',a:{Identification:'string',IncorporationDate:'string'}},
  IFCASYMMETRICISHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{BottomFlangeEdgeRadius:'real',BottomFlangeFilletRadius:'real',BottomFlangeSlope:'real',BottomFlangeThickness:'real',BottomFlangeWidth:'real',OverallDepth:'real',TopFlangeEdgeRadius:'real',TopFlangeFilletRadius:'real',TopFlangeSlope:'real',TopFlangeThickness:'real',TopFlangeWidth:'real',WebThickness:'real'}},
  IFCAUDIOVISUALAPPLIANCE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCAUDIOVISUALAPPLIANCETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCAXIS1PLACEMENT:{p:'IFCPLACEMENT',a:{}},
  IFCAXIS2PLACEMENT2D:{p:'IFCPLACEMENT',a:{}},
  IFCAXIS2PLACEMENT3D:{p:'IFCPLACEMENT',a:{}},
  IFCAXIS2PLACEMENTLINEAR:{p:'IFCPLACEMENT',a:{}},
  IFCBSPLINECURVE:{p:'IFCBOUNDEDCURVE',a:{ClosedCurve:'logical',CurveForm:'enum',Degree:'integer',SelfIntersect:'logical'}},
  IFCBSPLINECURVEWITHKNOTS:{p:'IFCBSPLINECURVE',a:{KnotSpec:'enum'}},
  IFCBSPLINESURFACE:{p:'IFCBOUNDEDSURFACE',a:{SelfIntersect:'logical',SurfaceForm:'enum',UClosed:'logical',UDegree:'integer',VClosed:'logical',VDegree:'integer'}},
  IFCBSPLINESURFACEWITHKNOTS:{p:'IFCBSPLINESURFACE',a:{KnotSpec:'enum'}},
  IFCBEAM:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCBEAMTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCBEARING:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCBEARINGTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCBLOBTEXTURE:{p:'IFCSURFACETEXTURE',a:{RasterCode:'real',RasterFormat:'string'}},
  IFCBLOCK:{p:'IFCCSGPRIMITIVE3D',a:{XLength:'real',YLength:'real',ZLength:'real'}},
  IFCBOILER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCBOILERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCBOOLEANCLIPPINGRESULT:{p:'IFCBOOLEANRESULT',a:{}},
  IFCBOOLEANRESULT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Operator:'enum'}},
  IFCBOREHOLE:{p:'IFCGEOTECHNICALASSEMBLY',a:{}},
  IFCBOUNDARYCONDITION:{p:null,a:{Name:'string'}},
  IFCBOUNDARYCURVE:{p:'IFCCOMPOSITECURVEONSURFACE',a:{}},
  IFCBOUNDARYEDGECONDITION:{p:'IFCBOUNDARYCONDITION',a:{}},
  IFCBOUNDARYFACECONDITION:{p:'IFCBOUNDARYCONDITION',a:{}},
  IFCBOUNDARYNODECONDITION:{p:'IFCBOUNDARYCONDITION',a:{}},
  IFCBOUNDARYNODECONDITIONWARPING:{p:'IFCBOUNDARYNODECONDITION',a:{}},
  IFCBOUNDEDCURVE:{p:'IFCCURVE',a:{}},
  IFCBOUNDEDSURFACE:{p:'IFCSURFACE',a:{}},
  IFCBOUNDINGBOX:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{XDim:'real',YDim:'real',ZDim:'real'}},
  IFCBOXEDHALFSPACE:{p:'IFCHALFSPACESOLID',a:{}},
  IFCBRIDGE:{p:'IFCFACILITY',a:{PredefinedType:'enum'}},
  IFCBRIDGEPART:{p:'IFCFACILITYPART',a:{PredefinedType:'enum'}},
  IFCBUILDING:{p:'IFCFACILITY',a:{ElevationOfRefHeight:'real',ElevationOfTerrain:'real'}},
  IFCBUILDINGELEMENTPART:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCBUILDINGELEMENTPARTTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCBUILDINGELEMENTPROXY:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCBUILDINGELEMENTPROXYTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCBUILDINGSTOREY:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{Elevation:'real'}},
  IFCBUILDINGSYSTEM:{p:'IFCSYSTEM',a:{LongName:'string',PredefinedType:'enum'}},
  IFCBUILTELEMENT:{p:'IFCELEMENT',a:{}},
  IFCBUILTELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCBUILTSYSTEM:{p:'IFCSYSTEM',a:{LongName:'string',PredefinedType:'enum'}},
  IFCBURNER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCBURNERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',Girth:'real',InternalFilletRadius:'real',WallThickness:'real',Width:'real'}},
  IFCCABLECARRIERFITTING:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCCABLECARRIERFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCCABLECARRIERSEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCCABLECARRIERSEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCABLEFITTING:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCCABLEFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCCABLESEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCCABLESEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCAISSONFOUNDATION:{p:'IFCDEEPFOUNDATION',a:{PredefinedType:'enum'}},
  IFCCAISSONFOUNDATIONTYPE:{p:'IFCDEEPFOUNDATIONTYPE',a:{PredefinedType:'enum'}},
  IFCCARTESIANPOINT:{p:'IFCPOINT',a:{}},
  IFCCARTESIANPOINTLIST:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCARTESIANPOINTLIST2D:{p:'IFCCARTESIANPOINTLIST',a:{}},
  IFCCARTESIANPOINTLIST3D:{p:'IFCCARTESIANPOINTLIST',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Scale:'real'}},
  IFCCARTESIANTRANSFORMATIONOPERATOR2D:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR2D',a:{Scale2:'real'}},
  IFCCARTESIANTRANSFORMATIONOPERATOR3D:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR',a:{}},
  IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM:{p:'IFCCARTESIANTRANSFORMATIONOPERATOR3D',a:{Scale2:'real',Scale3:'real'}},
  IFCCENTERLINEPROFILEDEF:{p:'IFCARBITRARYOPENPROFILEDEF',a:{Thickness:'real'}},
  IFCCHILLER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCHILLERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCHIMNEY:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCCHIMNEYTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCIRCLE:{p:'IFCCONIC',a:{Radius:'real'}},
  IFCCIRCLEHOLLOWPROFILEDEF:{p:'IFCCIRCLEPROFILEDEF',a:{WallThickness:'real'}},
  IFCCIRCLEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Radius:'real'}},
  IFCCIVILELEMENT:{p:'IFCELEMENT',a:{}},
  IFCCIVILELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCCLASSIFICATION:{p:'IFCEXTERNALINFORMATION',a:{Description:'string',Edition:'string',EditionDate:'string',Name:'string',Source:'string',Specification:'string'}},
  IFCCLASSIFICATIONREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{Description:'string',Sort:'string'}},
  IFCCLOSEDSHELL:{p:'IFCCONNECTEDFACESET',a:{}},
  IFCCLOTHOID:{p:'IFCSPIRAL',a:{ClothoidConstant:'real'}},
  IFCCOIL:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCOILTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOLOURRGB:{p:'IFCCOLOURSPECIFICATION',a:{Blue:'real',Green:'real',Red:'real'}},
  IFCCOLOURRGBLIST:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCCOLOURSPECIFICATION:{p:'IFCPRESENTATIONITEM',a:{Name:'string'}},
  IFCCOLUMN:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCCOLUMNTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCOMMUNICATIONSAPPLIANCE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCCOMMUNICATIONSAPPLIANCETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCCOMPLEXPROPERTY:{p:'IFCPROPERTY',a:{UsageName:'string'}},
  IFCCOMPLEXPROPERTYTEMPLATE:{p:'IFCPROPERTYTEMPLATE',a:{TemplateType:'enum',UsageName:'string'}},
  IFCCOMPOSITECURVE:{p:'IFCBOUNDEDCURVE',a:{SelfIntersect:'logical'}},
  IFCCOMPOSITECURVEONSURFACE:{p:'IFCCOMPOSITECURVE',a:{}},
  IFCCOMPOSITECURVESEGMENT:{p:'IFCSEGMENT',a:{SameSense:'boolean'}},
  IFCCOMPOSITEPROFILEDEF:{p:'IFCPROFILEDEF',a:{Label:'string'}},
  IFCCOMPRESSOR:{p:'IFCFLOWMOVINGDEVICE',a:{PredefinedType:'enum'}},
  IFCCOMPRESSORTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCONDENSER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCONDENSERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCONIC:{p:'IFCCURVE',a:{}},
  IFCCONNECTEDFACESET:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCCONNECTIONCURVEGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONPOINTECCENTRICITY:{p:'IFCCONNECTIONPOINTGEOMETRY',a:{EccentricityInX:'real',EccentricityInY:'real',EccentricityInZ:'real'}},
  IFCCONNECTIONPOINTGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONSURFACEGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONNECTIONVOLUMEGEOMETRY:{p:'IFCCONNECTIONGEOMETRY',a:{}},
  IFCCONSTRAINT:{p:null,a:{ConstraintGrade:'enum',ConstraintSource:'string',CreationTime:'string',Description:'string',Name:'string',UserDefinedGrade:'string'}},
  IFCCONSTRUCTIONEQUIPMENTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONMATERIALRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONMATERIALRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONPRODUCTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONPRODUCTRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCCONSTRUCTIONRESOURCE:{p:'IFCRESOURCE',a:{}},
  IFCCONSTRUCTIONRESOURCETYPE:{p:'IFCTYPERESOURCE',a:{}},
  IFCCONTEXT:{p:'IFCOBJECTDEFINITION',a:{LongName:'string',ObjectType:'string',Phase:'string'}},
  IFCCONTEXTDEPENDENTUNIT:{p:'IFCNAMEDUNIT',a:{Name:'string'}},
  IFCCONTROL:{p:'IFCOBJECT',a:{Identification:'string'}},
  IFCCONTROLLER:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCCONTROLLERTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCONVERSIONBASEDUNIT:{p:'IFCNAMEDUNIT',a:{Name:'string'}},
  IFCCONVERSIONBASEDUNITWITHOFFSET:{p:'IFCCONVERSIONBASEDUNIT',a:{ConversionOffset:'real'}},
  IFCCONVEYORSEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCCONVEYORSEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCOOLEDBEAM:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCOOLEDBEAMTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOOLINGTOWER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCCOOLINGTOWERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCCOORDINATEREFERENCESYSTEM:{p:null,a:{Description:'string',GeodeticDatum:'string',Name:'string'}},
  IFCCOSINESPIRAL:{p:'IFCSPIRAL',a:{ConstantTerm:'real',CosineTerm:'real'}},
  IFCCOSTITEM:{p:'IFCCONTROL',a:{PredefinedType:'enum'}},
  IFCCOSTSCHEDULE:{p:'IFCCONTROL',a:{PredefinedType:'enum',Status:'string',SubmittedOn:'string',UpdateDate:'string'}},
  IFCCOSTVALUE:{p:'IFCAPPLIEDVALUE',a:{}},
  IFCCOURSE:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCCOURSETYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCOVERING:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCCOVERINGTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCREWRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCCREWRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCCSGPRIMITIVE3D:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCSGSOLID:{p:'IFCSOLIDMODEL',a:{}},
  IFCCURRENCYRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{ExchangeRate:'real',RateDateTime:'string'}},
  IFCCURTAINWALL:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCCURTAINWALLTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCCURVE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCCURVEBOUNDEDPLANE:{p:'IFCBOUNDEDSURFACE',a:{}},
  IFCCURVEBOUNDEDSURFACE:{p:'IFCBOUNDEDSURFACE',a:{ImplicitOuter:'boolean'}},
  IFCCURVESEGMENT:{p:'IFCSEGMENT',a:{}},
  IFCCURVESTYLE:{p:'IFCPRESENTATIONSTYLE',a:{ModelOrDraughting:'boolean'}},
  IFCCURVESTYLEFONT:{p:'IFCPRESENTATIONITEM',a:{Name:'string'}},
  IFCCURVESTYLEFONTANDSCALING:{p:'IFCPRESENTATIONITEM',a:{CurveFontScaling:'real',Name:'string'}},
  IFCCURVESTYLEFONTPATTERN:{p:'IFCPRESENTATIONITEM',a:{InvisibleSegmentLength:'real',VisibleSegmentLength:'real'}},
  IFCCYLINDRICALSURFACE:{p:'IFCELEMENTARYSURFACE',a:{Radius:'real'}},
  IFCDAMPER:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCDAMPERTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCDEEPFOUNDATION:{p:'IFCBUILTELEMENT',a:{}},
  IFCDEEPFOUNDATIONTYPE:{p:'IFCBUILTELEMENTTYPE',a:{}},
  IFCDERIVEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{Label:'string'}},
  IFCDERIVEDUNIT:{p:null,a:{Name:'string',UnitType:'enum',UserDefinedType:'string'}},
  IFCDIRECTION:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCDIRECTRIXCURVESWEPTAREASOLID:{p:'IFCSWEPTAREASOLID',a:{}},
  IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID:{p:'IFCFIXEDREFERENCESWEPTAREASOLID',a:{}},
  IFCDISCRETEACCESSORY:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCDISCRETEACCESSORYTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONBOARD:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONBOARDTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONCHAMBERELEMENT:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONCHAMBERELEMENTTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCDISTRIBUTIONCIRCUIT:{p:'IFCDISTRIBUTIONSYSTEM',a:{}},
  IFCDISTRIBUTIONCONTROLELEMENT:{p:'IFCDISTRIBUTIONELEMENT',a:{}},
  IFCDISTRIBUTIONCONTROLELEMENTTYPE:{p:'IFCDISTRIBUTIONELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONELEMENT:{p:'IFCELEMENT',a:{}},
  IFCDISTRIBUTIONELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONFLOWELEMENT:{p:'IFCDISTRIBUTIONELEMENT',a:{}},
  IFCDISTRIBUTIONFLOWELEMENTTYPE:{p:'IFCDISTRIBUTIONELEMENTTYPE',a:{}},
  IFCDISTRIBUTIONPORT:{p:'IFCPORT',a:{FlowDirection:'enum',PredefinedType:'enum',SystemType:'enum'}},
  IFCDISTRIBUTIONSYSTEM:{p:'IFCSYSTEM',a:{LongName:'string',PredefinedType:'enum'}},
  IFCDOCUMENTINFORMATION:{p:'IFCEXTERNALINFORMATION',a:{Confidentiality:'enum',CreationTime:'string',Description:'string',ElectronicFormat:'string',Identification:'string',IntendedUse:'string',LastRevisionTime:'string',Location:'string',Name:'string',Purpose:'string',Revision:'string',Scope:'string',Status:'enum',ValidFrom:'string',ValidUntil:'string'}},
  IFCDOCUMENTINFORMATIONRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{RelationshipType:'string'}},
  IFCDOCUMENTREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{Description:'string'}},
  IFCDOOR:{p:'IFCBUILTELEMENT',a:{OperationType:'enum',OverallHeight:'real',OverallWidth:'real',PredefinedType:'enum',UserDefinedOperationType:'string'}},
  IFCDOORLININGPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{CasingDepth:'real',CasingThickness:'real',LiningDepth:'real',LiningOffset:'real',LiningThickness:'real',LiningToPanelOffsetX:'real',LiningToPanelOffsetY:'real',ThresholdDepth:'real',ThresholdOffset:'real',ThresholdThickness:'real',TransomOffset:'real',TransomThickness:'real'}},
  IFCDOORPANELPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{PanelDepth:'real',PanelOperation:'enum',PanelPosition:'enum',PanelWidth:'real'}},
  IFCDOORTYPE:{p:'IFCBUILTELEMENTTYPE',a:{OperationType:'enum',ParameterTakesPrecedence:'boolean',PredefinedType:'enum',UserDefinedOperationType:'string'}},
  IFCDRAUGHTINGPREDEFINEDCOLOUR:{p:'IFCPREDEFINEDCOLOUR',a:{}},
  IFCDRAUGHTINGPREDEFINEDCURVEFONT:{p:'IFCPREDEFINEDCURVEFONT',a:{}},
  IFCDUCTFITTING:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCDUCTFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCDUCTSEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCDUCTSEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCDUCTSILENCER:{p:'IFCFLOWTREATMENTDEVICE',a:{PredefinedType:'enum'}},
  IFCDUCTSILENCERTYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEARTHWORKSCUT:{p:'IFCFEATUREELEMENTSUBTRACTION',a:{PredefinedType:'enum'}},
  IFCEARTHWORKSELEMENT:{p:'IFCBUILTELEMENT',a:{}},
  IFCEARTHWORKSFILL:{p:'IFCEARTHWORKSELEMENT',a:{PredefinedType:'enum'}},
  IFCEDGE:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCEDGECURVE:{p:'IFCEDGE',a:{SameSense:'boolean'}},
  IFCEDGELOOP:{p:'IFCLOOP',a:{}},
  IFCELECTRICAPPLIANCE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCELECTRICAPPLIANCETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICDISTRIBUTIONBOARD:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCELECTRICDISTRIBUTIONBOARDTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICFLOWSTORAGEDEVICE:{p:'IFCFLOWSTORAGEDEVICE',a:{PredefinedType:'enum'}},
  IFCELECTRICFLOWSTORAGEDEVICETYPE:{p:'IFCFLOWSTORAGEDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICFLOWTREATMENTDEVICE:{p:'IFCFLOWTREATMENTDEVICE',a:{PredefinedType:'enum'}},
  IFCELECTRICFLOWTREATMENTDEVICETYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICGENERATOR:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCELECTRICGENERATORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICMOTOR:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCELECTRICMOTORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCELECTRICTIMECONTROL:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCELECTRICTIMECONTROLTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCELEMENT:{p:'IFCPRODUCT',a:{Tag:'string'}},
  IFCELEMENTASSEMBLY:{p:'IFCELEMENT',a:{AssemblyPlace:'enum',PredefinedType:'enum'}},
  IFCELEMENTASSEMBLYTYPE:{p:'IFCELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCELEMENTCOMPONENT:{p:'IFCELEMENT',a:{}},
  IFCELEMENTCOMPONENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCELEMENTQUANTITY:{p:'IFCQUANTITYSET',a:{MethodOfMeasurement:'string'}},
  IFCELEMENTTYPE:{p:'IFCTYPEPRODUCT',a:{ElementType:'string'}},
  IFCELEMENTARYSURFACE:{p:'IFCSURFACE',a:{}},
  IFCELLIPSE:{p:'IFCCONIC',a:{SemiAxis1:'real',SemiAxis2:'real'}},
  IFCELLIPSEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{SemiAxis1:'real',SemiAxis2:'real'}},
  IFCENERGYCONVERSIONDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCENERGYCONVERSIONDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCENGINE:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCENGINETYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEVAPORATIVECOOLER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCEVAPORATIVECOOLERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEVAPORATOR:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCEVAPORATORTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCEVENT:{p:'IFCPROCESS',a:{EventTriggerType:'enum',PredefinedType:'enum',UserDefinedEventTriggerType:'string'}},
  IFCEVENTTIME:{p:'IFCSCHEDULINGTIME',a:{ActualDate:'string',EarlyDate:'string',LateDate:'string',ScheduleDate:'string'}},
  IFCEVENTTYPE:{p:'IFCTYPEPROCESS',a:{EventTriggerType:'enum',PredefinedType:'enum',UserDefinedEventTriggerType:'string'}},
  IFCEXTENDEDPROPERTIES:{p:'IFCPROPERTYABSTRACTION',a:{Description:'string',Name:'string'}},
  IFCEXTERNALREFERENCE:{p:null,a:{Identification:'string',Location:'string',Name:'string'}},
  IFCEXTERNALREFERENCERELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCEXTERNALSPATIALELEMENT:{p:'IFCEXTERNALSPATIALSTRUCTUREELEMENT',a:{PredefinedType:'enum'}},
  IFCEXTERNALSPATIALSTRUCTUREELEMENT:{p:'IFCSPATIALELEMENT',a:{}},
  IFCEXTERNALLYDEFINEDHATCHSTYLE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTERNALLYDEFINEDSURFACESTYLE:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTERNALLYDEFINEDTEXTFONT:{p:'IFCEXTERNALREFERENCE',a:{}},
  IFCEXTRUDEDAREASOLID:{p:'IFCSWEPTAREASOLID',a:{Depth:'real'}},
  IFCEXTRUDEDAREASOLIDTAPERED:{p:'IFCEXTRUDEDAREASOLID',a:{}},
  IFCFACE:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCFACEBASEDSURFACEMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCFACEBOUND:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{Orientation:'boolean'}},
  IFCFACEOUTERBOUND:{p:'IFCFACEBOUND',a:{}},
  IFCFACESURFACE:{p:'IFCFACE',a:{SameSense:'boolean'}},
  IFCFACETEDBREP:{p:'IFCMANIFOLDSOLIDBREP',a:{}},
  IFCFACETEDBREPWITHVOIDS:{p:'IFCFACETEDBREP',a:{}},
  IFCFACILITY:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{}},
  IFCFACILITYPART:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{UsageType:'enum'}},
  IFCFACILITYPARTCOMMON:{p:'IFCFACILITYPART',a:{PredefinedType:'enum'}},
  IFCFAILURECONNECTIONCONDITION:{p:'IFCSTRUCTURALCONNECTIONCONDITION',a:{CompressionFailureX:'real',CompressionFailureY:'real',CompressionFailureZ:'real',TensionFailureX:'real',TensionFailureY:'real',TensionFailureZ:'real'}},
  IFCFAN:{p:'IFCFLOWMOVINGDEVICE',a:{PredefinedType:'enum'}},
  IFCFANTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCFASTENER:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCFASTENERTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCFEATUREELEMENT:{p:'IFCELEMENT',a:{}},
  IFCFEATUREELEMENTADDITION:{p:'IFCFEATUREELEMENT',a:{}},
  IFCFEATUREELEMENTSUBTRACTION:{p:'IFCFEATUREELEMENT',a:{}},
  IFCFILLAREASTYLE:{p:'IFCPRESENTATIONSTYLE',a:{ModelOrDraughting:'boolean'}},
  IFCFILLAREASTYLEHATCHING:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{HatchLineAngle:'real'}},
  IFCFILLAREASTYLETILES:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{TilingScale:'real'}},
  IFCFILTER:{p:'IFCFLOWTREATMENTDEVICE',a:{PredefinedType:'enum'}},
  IFCFILTERTYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCFIRESUPPRESSIONTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCFIRESUPPRESSIONTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCFIXEDREFERENCESWEPTAREASOLID:{p:'IFCDIRECTRIXCURVESWEPTAREASOLID',a:{}},
  IFCFLOWCONTROLLER:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWCONTROLLERTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWFITTING:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWFITTINGTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWINSTRUMENT:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCFLOWINSTRUMENTTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCFLOWMETER:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCFLOWMETERTYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCFLOWMOVINGDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWMOVINGDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWSEGMENT:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWSEGMENTTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWSTORAGEDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWSTORAGEDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWTERMINAL:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWTERMINALTYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFLOWTREATMENTDEVICE:{p:'IFCDISTRIBUTIONFLOWELEMENT',a:{}},
  IFCFLOWTREATMENTDEVICETYPE:{p:'IFCDISTRIBUTIONFLOWELEMENTTYPE',a:{}},
  IFCFOOTING:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCFOOTINGTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCFURNISHINGELEMENT:{p:'IFCELEMENT',a:{}},
  IFCFURNISHINGELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCFURNITURE:{p:'IFCFURNISHINGELEMENT',a:{PredefinedType:'enum'}},
  IFCFURNITURETYPE:{p:'IFCFURNISHINGELEMENTTYPE',a:{AssemblyPlace:'enum',PredefinedType:'enum'}},
  IFCGEOGRAPHICCRS:{p:'IFCCOORDINATEREFERENCESYSTEM',a:{PrimeMeridian:'string'}},
  IFCGEOGRAPHICELEMENT:{p:'IFCELEMENT',a:{PredefinedType:'enum'}},
  IFCGEOGRAPHICELEMENTTYPE:{p:'IFCELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCGEOMETRICCURVESET:{p:'IFCGEOMETRICSET',a:{}},
  IFCGEOMETRICREPRESENTATIONCONTEXT:{p:'IFCREPRESENTATIONCONTEXT',a:{CoordinateSpaceDimension:'integer',Precision:'real'}},
  IFCGEOMETRICREPRESENTATIONITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCGEOMETRICREPRESENTATIONSUBCONTEXT:{p:'IFCGEOMETRICREPRESENTATIONCONTEXT',a:{TargetScale:'real',TargetView:'enum',UserDefinedTargetView:'string'}},
  IFCGEOMETRICSET:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCGEOMODEL:{p:'IFCGEOTECHNICALASSEMBLY',a:{}},
  IFCGEOSLICE:{p:'IFCGEOTECHNICALASSEMBLY',a:{}},
  IFCGEOTECHNICALASSEMBLY:{p:'IFCGEOTECHNICALELEMENT',a:{}},
  IFCGEOTECHNICALELEMENT:{p:'IFCELEMENT',a:{}},
  IFCGEOTECHNICALSTRATUM:{p:'IFCGEOTECHNICALELEMENT',a:{PredefinedType:'enum'}},
  IFCGRADIENTCURVE:{p:'IFCCOMPOSITECURVE',a:{}},
  IFCGRID:{p:'IFCPOSITIONINGELEMENT',a:{PredefinedType:'enum'}},
  IFCGRIDAXIS:{p:null,a:{AxisTag:'string',SameSense:'boolean'}},
  IFCGRIDPLACEMENT:{p:'IFCOBJECTPLACEMENT',a:{}},
  IFCGROUP:{p:'IFCOBJECT',a:{}},
  IFCHALFSPACESOLID:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{AgreementFlag:'boolean'}},
  IFCHEATEXCHANGER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCHEATEXCHANGERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCHUMIDIFIER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCHUMIDIFIERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCISHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{FilletRadius:'real',FlangeEdgeRadius:'real',FlangeSlope:'real',FlangeThickness:'real',OverallDepth:'real',OverallWidth:'real',WebThickness:'real'}},
  IFCIMAGETEXTURE:{p:'IFCSURFACETEXTURE',a:{URLReference:'string'}},
  IFCIMPACTPROTECTIONDEVICE:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCIMPACTPROTECTIONDEVICETYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCINDEXEDCOLOURMAP:{p:'IFCPRESENTATIONITEM',a:{Opacity:'real'}},
  IFCINDEXEDPOLYCURVE:{p:'IFCBOUNDEDCURVE',a:{SelfIntersect:'boolean'}},
  IFCINDEXEDPOLYGONALFACE:{p:'IFCTESSELLATEDITEM',a:{}},
  IFCINDEXEDPOLYGONALFACEWITHVOIDS:{p:'IFCINDEXEDPOLYGONALFACE',a:{}},
  IFCINDEXEDPOLYGONALTEXTUREMAP:{p:'IFCINDEXEDTEXTUREMAP',a:{}},
  IFCINDEXEDTEXTUREMAP:{p:'IFCTEXTURECOORDINATE',a:{}},
  IFCINDEXEDTRIANGLETEXTUREMAP:{p:'IFCINDEXEDTEXTUREMAP',a:{}},
  IFCINTERCEPTOR:{p:'IFCFLOWTREATMENTDEVICE',a:{PredefinedType:'enum'}},
  IFCINTERCEPTORTYPE:{p:'IFCFLOWTREATMENTDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCINTERSECTIONCURVE:{p:'IFCSURFACECURVE',a:{}},
  IFCINVENTORY:{p:'IFCGROUP',a:{LastUpdateDate:'string',PredefinedType:'enum'}},
  IFCIRREGULARTIMESERIES:{p:'IFCTIMESERIES',a:{}},
  IFCIRREGULARTIMESERIESVALUE:{p:null,a:{TimeStamp:'string'}},
  IFCJUNCTIONBOX:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCJUNCTIONBOXTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCKERB:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCKERBTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCLSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',EdgeRadius:'real',FilletRadius:'real',LegSlope:'real',Thickness:'real',Width:'real'}},
  IFCLABORRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCLABORRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCLAGTIME:{p:'IFCSCHEDULINGTIME',a:{DurationType:'enum'}},
  IFCLAMP:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCLAMPTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCLIBRARYINFORMATION:{p:'IFCEXTERNALINFORMATION',a:{Description:'string',Location:'string',Name:'string',Version:'string',VersionDate:'string'}},
  IFCLIBRARYREFERENCE:{p:'IFCEXTERNALREFERENCE',a:{Description:'string',Language:'string'}},
  IFCLIGHTDISTRIBUTIONDATA:{p:null,a:{MainPlaneAngle:'real'}},
  IFCLIGHTFIXTURE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCLIGHTFIXTURETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCLIGHTINTENSITYDISTRIBUTION:{p:null,a:{LightDistributionCurve:'enum'}},
  IFCLIGHTSOURCE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{AmbientIntensity:'real',Intensity:'real',Name:'string'}},
  IFCLIGHTSOURCEAMBIENT:{p:'IFCLIGHTSOURCE',a:{}},
  IFCLIGHTSOURCEDIRECTIONAL:{p:'IFCLIGHTSOURCE',a:{}},
  IFCLIGHTSOURCEGONIOMETRIC:{p:'IFCLIGHTSOURCE',a:{ColourTemperature:'real',LightEmissionSource:'enum',LuminousFlux:'real'}},
  IFCLIGHTSOURCEPOSITIONAL:{p:'IFCLIGHTSOURCE',a:{ConstantAttenuation:'real',DistanceAttenuation:'real',QuadricAttenuation:'real',Radius:'real'}},
  IFCLIGHTSOURCESPOT:{p:'IFCLIGHTSOURCEPOSITIONAL',a:{BeamWidthAngle:'real',ConcentrationExponent:'real',SpreadAngle:'real'}},
  IFCLINE:{p:'IFCCURVE',a:{}},
  IFCLINEARELEMENT:{p:'IFCPRODUCT',a:{}},
  IFCLINEARPLACEMENT:{p:'IFCOBJECTPLACEMENT',a:{}},
  IFCLINEARPOSITIONINGELEMENT:{p:'IFCPOSITIONINGELEMENT',a:{}},
  IFCLIQUIDTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCLIQUIDTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCLOCALPLACEMENT:{p:'IFCOBJECTPLACEMENT',a:{}},
  IFCLOOP:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCMANIFOLDSOLIDBREP:{p:'IFCSOLIDMODEL',a:{}},
  IFCMAPCONVERSION:{p:'IFCCOORDINATEOPERATION',a:{Eastings:'real',Northings:'real',OrthogonalHeight:'real',Scale:'real',XAxisAbscissa:'real',XAxisOrdinate:'real'}},
  IFCMAPCONVERSIONSCALED:{p:'IFCMAPCONVERSION',a:{FactorX:'real',FactorY:'real',FactorZ:'real'}},
  IFCMAPPEDITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCMARINEFACILITY:{p:'IFCFACILITY',a:{PredefinedType:'enum'}},
  IFCMARINEPART:{p:'IFCFACILITYPART',a:{PredefinedType:'enum'}},
  IFCMATERIAL:{p:'IFCMATERIALDEFINITION',a:{Category:'string',Description:'string',Name:'string'}},
  IFCMATERIALCONSTITUENT:{p:'IFCMATERIALDEFINITION',a:{Category:'string',Description:'string',Fraction:'real',Name:'string'}},
  IFCMATERIALCONSTITUENTSET:{p:'IFCMATERIALDEFINITION',a:{Description:'string',Name:'string'}},
  IFCMATERIALDEFINITIONREPRESENTATION:{p:'IFCPRODUCTREPRESENTATION',a:{}},
  IFCMATERIALLAYER:{p:'IFCMATERIALDEFINITION',a:{Category:'string',Description:'string',IsVentilated:'logical',LayerThickness:'real',Name:'string',Priority:'integer'}},
  IFCMATERIALLAYERSET:{p:'IFCMATERIALDEFINITION',a:{Description:'string',LayerSetName:'string'}},
  IFCMATERIALLAYERSETUSAGE:{p:'IFCMATERIALUSAGEDEFINITION',a:{DirectionSense:'enum',LayerSetDirection:'enum',OffsetFromReferenceLine:'real',ReferenceExtent:'real'}},
  IFCMATERIALLAYERWITHOFFSETS:{p:'IFCMATERIALLAYER',a:{OffsetDirection:'enum',OffsetValues:'real'}},
  IFCMATERIALPROFILE:{p:'IFCMATERIALDEFINITION',a:{Category:'string',Description:'string',Name:'string',Priority:'integer'}},
  IFCMATERIALPROFILESET:{p:'IFCMATERIALDEFINITION',a:{Description:'string',Name:'string'}},
  IFCMATERIALPROFILESETUSAGE:{p:'IFCMATERIALUSAGEDEFINITION',a:{CardinalPoint:'integer',ReferenceExtent:'real'}},
  IFCMATERIALPROFILESETUSAGETAPERING:{p:'IFCMATERIALPROFILESETUSAGE',a:{CardinalEndPoint:'integer'}},
  IFCMATERIALPROFILEWITHOFFSETS:{p:'IFCMATERIALPROFILE',a:{OffsetValues:'real'}},
  IFCMATERIALPROPERTIES:{p:'IFCEXTENDEDPROPERTIES',a:{}},
  IFCMATERIALRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{MaterialExpression:'string'}},
  IFCMECHANICALFASTENER:{p:'IFCELEMENTCOMPONENT',a:{NominalDiameter:'real',NominalLength:'real',PredefinedType:'enum'}},
  IFCMECHANICALFASTENERTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{NominalDiameter:'real',NominalLength:'real',PredefinedType:'enum'}},
  IFCMEDICALDEVICE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCMEDICALDEVICETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCMEMBER:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCMEMBERTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCMETRIC:{p:'IFCCONSTRAINT',a:{Benchmark:'enum',ValueSource:'string'}},
  IFCMIRROREDPROFILEDEF:{p:'IFCDERIVEDPROFILEDEF',a:{}},
  IFCMOBILETELECOMMUNICATIONSAPPLIANCE:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCMONETARYUNIT:{p:null,a:{Currency:'string'}},
  IFCMOORINGDEVICE:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCMOORINGDEVICETYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCMOTORCONNECTION:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCMOTORCONNECTIONTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCNAMEDUNIT:{p:null,a:{UnitType:'enum'}},
  IFCNAVIGATIONELEMENT:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCNAVIGATIONELEMENTTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCOBJECT:{p:'IFCOBJECTDEFINITION',a:{ObjectType:'string'}},
  IFCOBJECTDEFINITION:{p:'IFCROOT',a:{}},
  IFCOBJECTIVE:{p:'IFCCONSTRAINT',a:{LogicalAggregator:'enum',ObjectiveQualifier:'enum',UserDefinedQualifier:'string'}},
  IFCOCCUPANT:{p:'IFCACTOR',a:{PredefinedType:'enum'}},
  IFCOFFSETCURVE:{p:'IFCCURVE',a:{}},
  IFCOFFSETCURVE2D:{p:'IFCOFFSETCURVE',a:{Distance:'real',SelfIntersect:'logical'}},
  IFCOFFSETCURVE3D:{p:'IFCOFFSETCURVE',a:{Distance:'real',SelfIntersect:'logical'}},
  IFCOFFSETCURVEBYDISTANCES:{p:'IFCOFFSETCURVE',a:{Tag:'string'}},
  IFCOPENCROSSPROFILEDEF:{p:'IFCPROFILEDEF',a:{HorizontalWidths:'boolean'}},
  IFCOPENSHELL:{p:'IFCCONNECTEDFACESET',a:{}},
  IFCOPENINGELEMENT:{p:'IFCFEATUREELEMENTSUBTRACTION',a:{PredefinedType:'enum'}},
  IFCORGANIZATION:{p:null,a:{Description:'string',Identification:'string',Name:'string'}},
  IFCORGANIZATIONRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCORIENTEDEDGE:{p:'IFCEDGE',a:{Orientation:'boolean'}},
  IFCOUTERBOUNDARYCURVE:{p:'IFCBOUNDARYCURVE',a:{}},
  IFCOUTLET:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCOUTLETTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCOWNERHISTORY:{p:null,a:{ChangeAction:'enum',CreationDate:'integer',LastModifiedDate:'integer',State:'enum'}},
  IFCPARAMETERIZEDPROFILEDEF:{p:'IFCPROFILEDEF',a:{}},
  IFCPATH:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCPAVEMENT:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCPAVEMENTTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPCURVE:{p:'IFCCURVE',a:{}},
  IFCPERFORMANCEHISTORY:{p:'IFCCONTROL',a:{LifeCyclePhase:'string',PredefinedType:'enum'}},
  IFCPERMEABLECOVERINGPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{FrameDepth:'real',FrameThickness:'real',OperationType:'enum',PanelPosition:'enum'}},
  IFCPERMIT:{p:'IFCCONTROL',a:{LongDescription:'string',PredefinedType:'enum',Status:'string'}},
  IFCPERSON:{p:null,a:{FamilyName:'string',GivenName:'string',Identification:'string'}},
  IFCPHYSICALCOMPLEXQUANTITY:{p:'IFCPHYSICALQUANTITY',a:{Discrimination:'string',Quality:'string',Usage:'string'}},
  IFCPHYSICALQUANTITY:{p:null,a:{Description:'string',Name:'string'}},
  IFCPHYSICALSIMPLEQUANTITY:{p:'IFCPHYSICALQUANTITY',a:{}},
  IFCPILE:{p:'IFCDEEPFOUNDATION',a:{ConstructionType:'enum',PredefinedType:'enum'}},
  IFCPILETYPE:{p:'IFCDEEPFOUNDATIONTYPE',a:{PredefinedType:'enum'}},
  IFCPIPEFITTING:{p:'IFCFLOWFITTING',a:{PredefinedType:'enum'}},
  IFCPIPEFITTINGTYPE:{p:'IFCFLOWFITTINGTYPE',a:{PredefinedType:'enum'}},
  IFCPIPESEGMENT:{p:'IFCFLOWSEGMENT',a:{PredefinedType:'enum'}},
  IFCPIPESEGMENTTYPE:{p:'IFCFLOWSEGMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPIXELTEXTURE:{p:'IFCSURFACETEXTURE',a:{ColourComponents:'integer',Height:'integer',Width:'integer'}},
  IFCPLACEMENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCPLANARBOX:{p:'IFCPLANAREXTENT',a:{}},
  IFCPLANAREXTENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{SizeInX:'real',SizeInY:'real'}},
  IFCPLANE:{p:'IFCELEMENTARYSURFACE',a:{}},
  IFCPLATE:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCPLATETYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPOINT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCPOINTBYDISTANCEEXPRESSION:{p:'IFCPOINT',a:{OffsetLateral:'real',OffsetLongitudinal:'real',OffsetVertical:'real'}},
  IFCPOINTONCURVE:{p:'IFCPOINT',a:{PointParameter:'real'}},
  IFCPOINTONSURFACE:{p:'IFCPOINT',a:{PointParameterU:'real',PointParameterV:'real'}},
  IFCPOLYLOOP:{p:'IFCLOOP',a:{}},
  IFCPOLYGONALBOUNDEDHALFSPACE:{p:'IFCHALFSPACESOLID',a:{}},
  IFCPOLYGONALFACESET:{p:'IFCTESSELLATEDFACESET',a:{Closed:'boolean'}},
  IFCPOLYLINE:{p:'IFCBOUNDEDCURVE',a:{}},
  IFCPOLYNOMIALCURVE:{p:'IFCCURVE',a:{}},
  IFCPORT:{p:'IFCPRODUCT',a:{}},
  IFCPOSITIONINGELEMENT:{p:'IFCPRODUCT',a:{}},
  IFCPOSTALADDRESS:{p:'IFCADDRESS',a:{Country:'string',InternalLocation:'string',PostalBox:'string',PostalCode:'string',Region:'string',Town:'string'}},
  IFCPREDEFINEDCOLOUR:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPREDEFINEDCURVEFONT:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPREDEFINEDITEM:{p:'IFCPRESENTATIONITEM',a:{Name:'string'}},
  IFCPREDEFINEDPROPERTIES:{p:'IFCPROPERTYABSTRACTION',a:{}},
  IFCPREDEFINEDPROPERTYSET:{p:'IFCPROPERTYSETDEFINITION',a:{}},
  IFCPREDEFINEDTEXTFONT:{p:'IFCPREDEFINEDITEM',a:{}},
  IFCPRESENTATIONLAYERASSIGNMENT:{p:null,a:{Description:'string',Identifier:'string',Name:'string'}},
  IFCPRESENTATIONLAYERWITHSTYLE:{p:'IFCPRESENTATIONLAYERASSIGNMENT',a:{LayerBlocked:'logical',LayerFrozen:'logical',LayerOn:'logical'}},
  IFCPRESENTATIONSTYLE:{p:null,a:{Name:'string'}},
  IFCPROCEDURE:{p:'IFCPROCESS',a:{PredefinedType:'enum'}},
  IFCPROCEDURETYPE:{p:'IFCTYPEPROCESS',a:{PredefinedType:'enum'}},
  IFCPROCESS:{p:'IFCOBJECT',a:{Identification:'string',LongDescription:'string'}},
  IFCPRODUCT:{p:'IFCOBJECT',a:{}},
  IFCPRODUCTDEFINITIONSHAPE:{p:'IFCPRODUCTREPRESENTATION',a:{}},
  IFCPRODUCTREPRESENTATION:{p:null,a:{Description:'string',Name:'string'}},
  IFCPROFILEDEF:{p:null,a:{ProfileName:'string',ProfileType:'enum'}},
  IFCPROFILEPROPERTIES:{p:'IFCEXTENDEDPROPERTIES',a:{}},
  IFCPROJECT:{p:'IFCCONTEXT',a:{}},
  IFCPROJECTLIBRARY:{p:'IFCCONTEXT',a:{}},
  IFCPROJECTORDER:{p:'IFCCONTROL',a:{LongDescription:'string',PredefinedType:'enum',Status:'string'}},
  IFCPROJECTEDCRS:{p:'IFCCOORDINATEREFERENCESYSTEM',a:{MapProjection:'string',MapZone:'string',VerticalDatum:'string'}},
  IFCPROJECTIONELEMENT:{p:'IFCFEATUREELEMENTADDITION',a:{PredefinedType:'enum'}},
  IFCPROPERTY:{p:'IFCPROPERTYABSTRACTION',a:{Name:'string',Specification:'string'}},
  IFCPROPERTYBOUNDEDVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYDEFINITION:{p:'IFCROOT',a:{}},
  IFCPROPERTYDEPENDENCYRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{Expression:'string'}},
  IFCPROPERTYENUMERATEDVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYENUMERATION:{p:'IFCPROPERTYABSTRACTION',a:{Name:'string'}},
  IFCPROPERTYLISTVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYREFERENCEVALUE:{p:'IFCSIMPLEPROPERTY',a:{UsageName:'string'}},
  IFCPROPERTYSET:{p:'IFCPROPERTYSETDEFINITION',a:{}},
  IFCPROPERTYSETDEFINITION:{p:'IFCPROPERTYDEFINITION',a:{}},
  IFCPROPERTYSETTEMPLATE:{p:'IFCPROPERTYTEMPLATEDEFINITION',a:{ApplicableEntity:'string',TemplateType:'enum'}},
  IFCPROPERTYSINGLEVALUE:{p:'IFCSIMPLEPROPERTY',a:{}},
  IFCPROPERTYTABLEVALUE:{p:'IFCSIMPLEPROPERTY',a:{CurveInterpolation:'enum',Expression:'string'}},
  IFCPROPERTYTEMPLATE:{p:'IFCPROPERTYTEMPLATEDEFINITION',a:{}},
  IFCPROPERTYTEMPLATEDEFINITION:{p:'IFCPROPERTYDEFINITION',a:{}},
  IFCPROTECTIVEDEVICE:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCPROTECTIVEDEVICETRIPPINGUNIT:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCPROTECTIVEDEVICETRIPPINGUNITTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCPROTECTIVEDEVICETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCPUMP:{p:'IFCFLOWMOVINGDEVICE',a:{PredefinedType:'enum'}},
  IFCPUMPTYPE:{p:'IFCFLOWMOVINGDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCQUANTITYAREA:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{AreaValue:'real',Formula:'string'}},
  IFCQUANTITYCOUNT:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{CountValue:'integer',Formula:'string'}},
  IFCQUANTITYLENGTH:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',LengthValue:'real'}},
  IFCQUANTITYNUMBER:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',NumberValue:'real'}},
  IFCQUANTITYSET:{p:'IFCPROPERTYSETDEFINITION',a:{}},
  IFCQUANTITYTIME:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',TimeValue:'real'}},
  IFCQUANTITYVOLUME:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',VolumeValue:'real'}},
  IFCQUANTITYWEIGHT:{p:'IFCPHYSICALSIMPLEQUANTITY',a:{Formula:'string',WeightValue:'real'}},
  IFCRAIL:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCRAILTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRAILING:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCRAILINGTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRAILWAY:{p:'IFCFACILITY',a:{PredefinedType:'enum'}},
  IFCRAILWAYPART:{p:'IFCFACILITYPART',a:{PredefinedType:'enum'}},
  IFCRAMP:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCRAMPFLIGHT:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCRAMPFLIGHTTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRAMPTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCRATIONALBSPLINECURVEWITHKNOTS:{p:'IFCBSPLINECURVEWITHKNOTS',a:{}},
  IFCRATIONALBSPLINESURFACEWITHKNOTS:{p:'IFCBSPLINESURFACEWITHKNOTS',a:{}},
  IFCRECTANGLEHOLLOWPROFILEDEF:{p:'IFCRECTANGLEPROFILEDEF',a:{InnerFilletRadius:'real',OuterFilletRadius:'real',WallThickness:'real'}},
  IFCRECTANGLEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{XDim:'real',YDim:'real'}},
  IFCRECTANGULARPYRAMID:{p:'IFCCSGPRIMITIVE3D',a:{Height:'real',XLength:'real',YLength:'real'}},
  IFCRECTANGULARTRIMMEDSURFACE:{p:'IFCBOUNDEDSURFACE',a:{U1:'real',U2:'real',Usense:'boolean',V1:'real',V2:'real',Vsense:'boolean'}},
  IFCRECURRENCEPATTERN:{p:null,a:{Interval:'integer',Occurrences:'integer',Position:'integer',RecurrenceType:'enum'}},
  IFCREFERENCE:{p:null,a:{AttributeIdentifier:'string',InstanceName:'string',TypeIdentifier:'string'}},
  IFCREFERENT:{p:'IFCPOSITIONINGELEMENT',a:{PredefinedType:'enum'}},
  IFCREGULARTIMESERIES:{p:'IFCTIMESERIES',a:{TimeStep:'real'}},
  IFCREINFORCEDSOIL:{p:'IFCEARTHWORKSELEMENT',a:{PredefinedType:'enum'}},
  IFCREINFORCEMENTBARPROPERTIES:{p:'IFCPREDEFINEDPROPERTIES',a:{BarCount:'integer',BarSurface:'enum',EffectiveDepth:'real',NominalBarDiameter:'real',SteelGrade:'string',TotalCrossSectionArea:'real'}},
  IFCREINFORCEMENTDEFINITIONPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{DefinitionType:'string'}},
  IFCREINFORCINGBAR:{p:'IFCREINFORCINGELEMENT',a:{BarLength:'real',BarSurface:'enum',CrossSectionArea:'real',NominalDiameter:'real',PredefinedType:'enum'}},
  IFCREINFORCINGBARTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{BarLength:'real',BarSurface:'enum',BendingShapeCode:'string',CrossSectionArea:'real',NominalDiameter:'real',PredefinedType:'enum'}},
  IFCREINFORCINGELEMENT:{p:'IFCELEMENTCOMPONENT',a:{SteelGrade:'string'}},
  IFCREINFORCINGELEMENTTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{}},
  IFCREINFORCINGMESH:{p:'IFCREINFORCINGELEMENT',a:{LongitudinalBarCrossSectionArea:'real',LongitudinalBarNominalDiameter:'real',LongitudinalBarSpacing:'real',MeshLength:'real',MeshWidth:'real',PredefinedType:'enum',TransverseBarCrossSectionArea:'real',TransverseBarNominalDiameter:'real',TransverseBarSpacing:'real'}},
  IFCREINFORCINGMESHTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{BendingShapeCode:'string',LongitudinalBarCrossSectionArea:'real',LongitudinalBarNominalDiameter:'real',LongitudinalBarSpacing:'real',MeshLength:'real',MeshWidth:'real',PredefinedType:'enum',TransverseBarCrossSectionArea:'real',TransverseBarNominalDiameter:'real',TransverseBarSpacing:'real'}},
  IFCRELADHERESTOELEMENT:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELAGGREGATES:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELASSIGNS:{p:'IFCRELATIONSHIP',a:{RelatedObjectsType:'boolean'}},
  IFCRELASSIGNSTOACTOR:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOCONTROL:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOGROUP:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOGROUPBYFACTOR:{p:'IFCRELASSIGNSTOGROUP',a:{Factor:'real'}},
  IFCRELASSIGNSTOPROCESS:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTOPRODUCT:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSIGNSTORESOURCE:{p:'IFCRELASSIGNS',a:{}},
  IFCRELASSOCIATES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELASSOCIATESAPPROVAL:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESCLASSIFICATION:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESCONSTRAINT:{p:'IFCRELASSOCIATES',a:{Intent:'string'}},
  IFCRELASSOCIATESDOCUMENT:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESLIBRARY:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESMATERIAL:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELASSOCIATESPROFILEDEF:{p:'IFCRELASSOCIATES',a:{}},
  IFCRELCONNECTS:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELCONNECTSELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSPATHELEMENTS:{p:'IFCRELCONNECTSELEMENTS',a:{RelatedConnectionType:'enum',RelatingConnectionType:'enum'}},
  IFCRELCONNECTSPORTTOELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSPORTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSSTRUCTURALACTIVITY:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCONNECTSSTRUCTURALMEMBER:{p:'IFCRELCONNECTS',a:{SupportedLength:'real'}},
  IFCRELCONNECTSWITHECCENTRICITY:{p:'IFCRELCONNECTSSTRUCTURALMEMBER',a:{}},
  IFCRELCONNECTSWITHREALIZINGELEMENTS:{p:'IFCRELCONNECTSELEMENTS',a:{ConnectionType:'string'}},
  IFCRELCONTAINEDINSPATIALSTRUCTURE:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCOVERSBLDGELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELCOVERSSPACES:{p:'IFCRELCONNECTS',a:{}},
  IFCRELDECLARES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELDECOMPOSES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELDEFINES:{p:'IFCRELATIONSHIP',a:{}},
  IFCRELDEFINESBYOBJECT:{p:'IFCRELDEFINES',a:{}},
  IFCRELDEFINESBYPROPERTIES:{p:'IFCRELDEFINES',a:{}},
  IFCRELDEFINESBYTEMPLATE:{p:'IFCRELDEFINES',a:{}},
  IFCRELDEFINESBYTYPE:{p:'IFCRELDEFINES',a:{}},
  IFCRELFILLSELEMENT:{p:'IFCRELCONNECTS',a:{}},
  IFCRELFLOWCONTROLELEMENTS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELINTERFERESELEMENTS:{p:'IFCRELCONNECTS',a:{ImpliedOrder:'logical',InterferenceType:'string'}},
  IFCRELNESTS:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELPOSITIONS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELPROJECTSELEMENT:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELREFERENCEDINSPATIALSTRUCTURE:{p:'IFCRELCONNECTS',a:{}},
  IFCRELSEQUENCE:{p:'IFCRELCONNECTS',a:{SequenceType:'enum',UserDefinedSequenceType:'string'}},
  IFCRELSERVICESBUILDINGS:{p:'IFCRELCONNECTS',a:{}},
  IFCRELSPACEBOUNDARY:{p:'IFCRELCONNECTS',a:{InternalOrExternalBoundary:'enum',PhysicalOrVirtualBoundary:'enum'}},
  IFCRELSPACEBOUNDARY1STLEVEL:{p:'IFCRELSPACEBOUNDARY',a:{}},
  IFCRELSPACEBOUNDARY2NDLEVEL:{p:'IFCRELSPACEBOUNDARY1STLEVEL',a:{}},
  IFCRELVOIDSELEMENT:{p:'IFCRELDECOMPOSES',a:{}},
  IFCRELATIONSHIP:{p:'IFCROOT',a:{}},
  IFCREPARAMETRISEDCOMPOSITECURVESEGMENT:{p:'IFCCOMPOSITECURVESEGMENT',a:{ParamLength:'real'}},
  IFCREPRESENTATION:{p:null,a:{RepresentationIdentifier:'string',RepresentationType:'string'}},
  IFCREPRESENTATIONCONTEXT:{p:null,a:{ContextIdentifier:'string',ContextType:'string'}},
  IFCRESOURCE:{p:'IFCOBJECT',a:{Identification:'string',LongDescription:'string'}},
  IFCRESOURCEAPPROVALRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCRESOURCECONSTRAINTRELATIONSHIP:{p:'IFCRESOURCELEVELRELATIONSHIP',a:{}},
  IFCRESOURCELEVELRELATIONSHIP:{p:null,a:{Description:'string',Name:'string'}},
  IFCRESOURCETIME:{p:'IFCSCHEDULINGTIME',a:{ActualFinish:'string',ActualStart:'string',ActualUsage:'real',ActualWork:'string',Completion:'real',IsOverAllocated:'boolean',LevelingDelay:'string',RemainingUsage:'real',RemainingWork:'string',ScheduleContour:'string',ScheduleFinish:'string',ScheduleStart:'string',ScheduleUsage:'real',ScheduleWork:'string',StatusTime:'string'}},
  IFCREVOLVEDAREASOLID:{p:'IFCSWEPTAREASOLID',a:{Angle:'real'}},
  IFCREVOLVEDAREASOLIDTAPERED:{p:'IFCREVOLVEDAREASOLID',a:{}},
  IFCRIGHTCIRCULARCONE:{p:'IFCCSGPRIMITIVE3D',a:{BottomRadius:'real',Height:'real'}},
  IFCRIGHTCIRCULARCYLINDER:{p:'IFCCSGPRIMITIVE3D',a:{Height:'real',Radius:'real'}},
  IFCRIGIDOPERATION:{p:'IFCCOORDINATEOPERATION',a:{Height:'real'}},
  IFCROAD:{p:'IFCFACILITY',a:{PredefinedType:'enum'}},
  IFCROADPART:{p:'IFCFACILITYPART',a:{PredefinedType:'enum'}},
  IFCROOF:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCROOFTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCROOT:{p:null,a:{Description:'string',GlobalId:'string',Name:'string'}},
  IFCROUNDEDRECTANGLEPROFILEDEF:{p:'IFCRECTANGLEPROFILEDEF',a:{RoundingRadius:'real'}},
  IFCSIUNIT:{p:'IFCNAMEDUNIT',a:{Name:'enum',Prefix:'enum'}},
  IFCSANITARYTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCSANITARYTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSCHEDULINGTIME:{p:null,a:{DataOrigin:'enum',Name:'string',UserDefinedDataOrigin:'string'}},
  IFCSEAMCURVE:{p:'IFCSURFACECURVE',a:{}},
  IFCSECONDORDERPOLYNOMIALSPIRAL:{p:'IFCSPIRAL',a:{ConstantTerm:'real',LinearTerm:'real',QuadraticTerm:'real'}},
  IFCSECTIONPROPERTIES:{p:'IFCPREDEFINEDPROPERTIES',a:{SectionType:'enum'}},
  IFCSECTIONREINFORCEMENTPROPERTIES:{p:'IFCPREDEFINEDPROPERTIES',a:{LongitudinalEndPosition:'real',LongitudinalStartPosition:'real',ReinforcementRole:'enum',TransversePosition:'real'}},
  IFCSECTIONEDSOLID:{p:'IFCSOLIDMODEL',a:{}},
  IFCSECTIONEDSOLIDHORIZONTAL:{p:'IFCSECTIONEDSOLID',a:{}},
  IFCSECTIONEDSPINE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSECTIONEDSURFACE:{p:'IFCSURFACE',a:{}},
  IFCSEGMENT:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Transition:'enum'}},
  IFCSEGMENTEDREFERENCECURVE:{p:'IFCCOMPOSITECURVE',a:{}},
  IFCSENSOR:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCSENSORTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSEVENTHORDERPOLYNOMIALSPIRAL:{p:'IFCSPIRAL',a:{ConstantTerm:'real',CubicTerm:'real',LinearTerm:'real',QuadraticTerm:'real',QuarticTerm:'real',QuinticTerm:'real',SepticTerm:'real',SexticTerm:'real'}},
  IFCSHADINGDEVICE:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCSHADINGDEVICETYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSHAPEASPECT:{p:null,a:{Description:'string',Name:'string',ProductDefinitional:'logical'}},
  IFCSHAPEMODEL:{p:'IFCREPRESENTATION',a:{}},
  IFCSHAPEREPRESENTATION:{p:'IFCSHAPEMODEL',a:{}},
  IFCSHELLBASEDSURFACEMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSIGN:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCSIGNTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCSIGNAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCSIGNALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSIMPLEPROPERTY:{p:'IFCPROPERTY',a:{}},
  IFCSIMPLEPROPERTYTEMPLATE:{p:'IFCPROPERTYTEMPLATE',a:{AccessState:'enum',Expression:'string',PrimaryMeasureType:'string',SecondaryMeasureType:'string',TemplateType:'enum'}},
  IFCSINESPIRAL:{p:'IFCSPIRAL',a:{ConstantTerm:'real',LinearTerm:'real',SineTerm:'real'}},
  IFCSITE:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{LandTitleNumber:'string',RefElevation:'real'}},
  IFCSLAB:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCSLABTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSLIPPAGECONNECTIONCONDITION:{p:'IFCSTRUCTURALCONNECTIONCONDITION',a:{SlippageX:'real',SlippageY:'real',SlippageZ:'real'}},
  IFCSOLARDEVICE:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCSOLARDEVICETYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCSOLIDMODEL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSPACE:{p:'IFCSPATIALSTRUCTUREELEMENT',a:{ElevationWithFlooring:'real',PredefinedType:'enum'}},
  IFCSPACEHEATER:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCSPACEHEATERTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSPACETYPE:{p:'IFCSPATIALSTRUCTUREELEMENTTYPE',a:{LongName:'string',PredefinedType:'enum'}},
  IFCSPATIALELEMENT:{p:'IFCPRODUCT',a:{LongName:'string'}},
  IFCSPATIALELEMENTTYPE:{p:'IFCTYPEPRODUCT',a:{ElementType:'string'}},
  IFCSPATIALSTRUCTUREELEMENT:{p:'IFCSPATIALELEMENT',a:{CompositionType:'enum'}},
  IFCSPATIALSTRUCTUREELEMENTTYPE:{p:'IFCSPATIALELEMENTTYPE',a:{}},
  IFCSPATIALZONE:{p:'IFCSPATIALELEMENT',a:{PredefinedType:'enum'}},
  IFCSPATIALZONETYPE:{p:'IFCSPATIALELEMENTTYPE',a:{LongName:'string',PredefinedType:'enum'}},
  IFCSPHERE:{p:'IFCCSGPRIMITIVE3D',a:{Radius:'real'}},
  IFCSPHERICALSURFACE:{p:'IFCELEMENTARYSURFACE',a:{Radius:'real'}},
  IFCSPIRAL:{p:'IFCCURVE',a:{}},
  IFCSTACKTERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCSTACKTERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCSTAIR:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCSTAIRFLIGHT:{p:'IFCBUILTELEMENT',a:{NumberOfRisers:'integer',NumberOfTreads:'integer',PredefinedType:'enum',RiserHeight:'real',TreadLength:'real'}},
  IFCSTAIRFLIGHTTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSTAIRTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALACTION:{p:'IFCSTRUCTURALACTIVITY',a:{DestabilizingLoad:'boolean'}},
  IFCSTRUCTURALACTIVITY:{p:'IFCPRODUCT',a:{GlobalOrLocal:'enum'}},
  IFCSTRUCTURALANALYSISMODEL:{p:'IFCSYSTEM',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALCONNECTION:{p:'IFCSTRUCTURALITEM',a:{}},
  IFCSTRUCTURALCONNECTIONCONDITION:{p:null,a:{Name:'string'}},
  IFCSTRUCTURALCURVEACTION:{p:'IFCSTRUCTURALACTION',a:{PredefinedType:'enum',ProjectedOrTrue:'enum'}},
  IFCSTRUCTURALCURVECONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALCURVEMEMBER:{p:'IFCSTRUCTURALMEMBER',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALCURVEMEMBERVARYING:{p:'IFCSTRUCTURALCURVEMEMBER',a:{}},
  IFCSTRUCTURALCURVEREACTION:{p:'IFCSTRUCTURALREACTION',a:{PredefinedType:'enum'}},
  IFCSTRUCTURALITEM:{p:'IFCPRODUCT',a:{}},
  IFCSTRUCTURALLINEARACTION:{p:'IFCSTRUCTURALCURVEACTION',a:{}},
  IFCSTRUCTURALLOAD:{p:null,a:{Name:'string'}},
  IFCSTRUCTURALLOADCASE:{p:'IFCSTRUCTURALLOADGROUP',a:{}},
  IFCSTRUCTURALLOADCONFIGURATION:{p:'IFCSTRUCTURALLOAD',a:{}},
  IFCSTRUCTURALLOADGROUP:{p:'IFCGROUP',a:{ActionSource:'enum',ActionType:'enum',Coefficient:'real',PredefinedType:'enum',Purpose:'string'}},
  IFCSTRUCTURALLOADLINEARFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{LinearForceX:'real',LinearForceY:'real',LinearForceZ:'real',LinearMomentX:'real',LinearMomentY:'real',LinearMomentZ:'real'}},
  IFCSTRUCTURALLOADORRESULT:{p:'IFCSTRUCTURALLOAD',a:{}},
  IFCSTRUCTURALLOADPLANARFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{PlanarForceX:'real',PlanarForceY:'real',PlanarForceZ:'real'}},
  IFCSTRUCTURALLOADSINGLEDISPLACEMENT:{p:'IFCSTRUCTURALLOADSTATIC',a:{DisplacementX:'real',DisplacementY:'real',DisplacementZ:'real',RotationalDisplacementRX:'real',RotationalDisplacementRY:'real',RotationalDisplacementRZ:'real'}},
  IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION:{p:'IFCSTRUCTURALLOADSINGLEDISPLACEMENT',a:{Distortion:'real'}},
  IFCSTRUCTURALLOADSINGLEFORCE:{p:'IFCSTRUCTURALLOADSTATIC',a:{ForceX:'real',ForceY:'real',ForceZ:'real',MomentX:'real',MomentY:'real',MomentZ:'real'}},
  IFCSTRUCTURALLOADSINGLEFORCEWARPING:{p:'IFCSTRUCTURALLOADSINGLEFORCE',a:{WarpingMoment:'real'}},
  IFCSTRUCTURALLOADSTATIC:{p:'IFCSTRUCTURALLOADORRESULT',a:{}},
  IFCSTRUCTURALLOADTEMPERATURE:{p:'IFCSTRUCTURALLOADSTATIC',a:{DeltaTConstant:'real',DeltaTY:'real',DeltaTZ:'real'}},
  IFCSTRUCTURALMEMBER:{p:'IFCSTRUCTURALITEM',a:{}},
  IFCSTRUCTURALPLANARACTION:{p:'IFCSTRUCTURALSURFACEACTION',a:{}},
  IFCSTRUCTURALPOINTACTION:{p:'IFCSTRUCTURALACTION',a:{}},
  IFCSTRUCTURALPOINTCONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALPOINTREACTION:{p:'IFCSTRUCTURALREACTION',a:{}},
  IFCSTRUCTURALREACTION:{p:'IFCSTRUCTURALACTIVITY',a:{}},
  IFCSTRUCTURALRESULTGROUP:{p:'IFCGROUP',a:{IsLinear:'boolean',TheoryType:'enum'}},
  IFCSTRUCTURALSURFACEACTION:{p:'IFCSTRUCTURALACTION',a:{PredefinedType:'enum',ProjectedOrTrue:'enum'}},
  IFCSTRUCTURALSURFACECONNECTION:{p:'IFCSTRUCTURALCONNECTION',a:{}},
  IFCSTRUCTURALSURFACEMEMBER:{p:'IFCSTRUCTURALMEMBER',a:{PredefinedType:'enum',Thickness:'real'}},
  IFCSTRUCTURALSURFACEMEMBERVARYING:{p:'IFCSTRUCTURALSURFACEMEMBER',a:{}},
  IFCSTRUCTURALSURFACEREACTION:{p:'IFCSTRUCTURALREACTION',a:{PredefinedType:'enum'}},
  IFCSTYLEMODEL:{p:'IFCREPRESENTATION',a:{}},
  IFCSTYLEDITEM:{p:'IFCREPRESENTATIONITEM',a:{Name:'string'}},
  IFCSTYLEDREPRESENTATION:{p:'IFCSTYLEMODEL',a:{}},
  IFCSUBCONTRACTRESOURCE:{p:'IFCCONSTRUCTIONRESOURCE',a:{PredefinedType:'enum'}},
  IFCSUBCONTRACTRESOURCETYPE:{p:'IFCCONSTRUCTIONRESOURCETYPE',a:{PredefinedType:'enum'}},
  IFCSUBEDGE:{p:'IFCEDGE',a:{}},
  IFCSURFACE:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCSURFACECURVE:{p:'IFCCURVE',a:{MasterRepresentation:'enum'}},
  IFCSURFACECURVESWEPTAREASOLID:{p:'IFCDIRECTRIXCURVESWEPTAREASOLID',a:{}},
  IFCSURFACEFEATURE:{p:'IFCFEATUREELEMENT',a:{PredefinedType:'enum'}},
  IFCSURFACEOFLINEAREXTRUSION:{p:'IFCSWEPTSURFACE',a:{Depth:'real'}},
  IFCSURFACEOFREVOLUTION:{p:'IFCSWEPTSURFACE',a:{}},
  IFCSURFACEREINFORCEMENTAREA:{p:'IFCSTRUCTURALLOADORRESULT',a:{ShearReinforcement:'real'}},
  IFCSURFACESTYLE:{p:'IFCPRESENTATIONSTYLE',a:{Side:'enum'}},
  IFCSURFACESTYLELIGHTING:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCSURFACESTYLEREFRACTION:{p:'IFCPRESENTATIONITEM',a:{DispersionFactor:'real',RefractionIndex:'real'}},
  IFCSURFACESTYLERENDERING:{p:'IFCSURFACESTYLESHADING',a:{ReflectanceMethod:'enum'}},
  IFCSURFACESTYLESHADING:{p:'IFCPRESENTATIONITEM',a:{Transparency:'real'}},
  IFCSURFACESTYLEWITHTEXTURES:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCSURFACETEXTURE:{p:'IFCPRESENTATIONITEM',a:{Mode:'string',RepeatS:'boolean',RepeatT:'boolean'}},
  IFCSWEPTAREASOLID:{p:'IFCSOLIDMODEL',a:{}},
  IFCSWEPTDISKSOLID:{p:'IFCSOLIDMODEL',a:{EndParam:'real',InnerRadius:'real',Radius:'real',StartParam:'real'}},
  IFCSWEPTDISKSOLIDPOLYGONAL:{p:'IFCSWEPTDISKSOLID',a:{FilletRadius:'real'}},
  IFCSWEPTSURFACE:{p:'IFCSURFACE',a:{}},
  IFCSWITCHINGDEVICE:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCSWITCHINGDEVICETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCSYSTEM:{p:'IFCGROUP',a:{}},
  IFCSYSTEMFURNITUREELEMENT:{p:'IFCFURNISHINGELEMENT',a:{PredefinedType:'enum'}},
  IFCSYSTEMFURNITUREELEMENTTYPE:{p:'IFCFURNISHINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCTSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',FilletRadius:'real',FlangeEdgeRadius:'real',FlangeSlope:'real',FlangeThickness:'real',FlangeWidth:'real',WebEdgeRadius:'real',WebSlope:'real',WebThickness:'real'}},
  IFCTABLE:{p:null,a:{Name:'string'}},
  IFCTABLECOLUMN:{p:null,a:{Description:'string',Identifier:'string',Name:'string'}},
  IFCTABLEROW:{p:null,a:{IsHeading:'boolean'}},
  IFCTANK:{p:'IFCFLOWSTORAGEDEVICE',a:{PredefinedType:'enum'}},
  IFCTANKTYPE:{p:'IFCFLOWSTORAGEDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTASK:{p:'IFCPROCESS',a:{IsMilestone:'boolean',PredefinedType:'enum',Priority:'integer',Status:'string',WorkMethod:'string'}},
  IFCTASKTIME:{p:'IFCSCHEDULINGTIME',a:{ActualDuration:'string',ActualFinish:'string',ActualStart:'string',Completion:'real',DurationType:'enum',EarlyFinish:'string',EarlyStart:'string',FreeFloat:'string',IsCritical:'boolean',LateFinish:'string',LateStart:'string',RemainingTime:'string',ScheduleDuration:'string',ScheduleFinish:'string',ScheduleStart:'string',StatusTime:'string',TotalFloat:'string'}},
  IFCTASKTIMERECURRING:{p:'IFCTASKTIME',a:{}},
  IFCTASKTYPE:{p:'IFCTYPEPROCESS',a:{PredefinedType:'enum',WorkMethod:'string'}},
  IFCTELECOMADDRESS:{p:'IFCADDRESS',a:{PagerNumber:'string',WWWHomePageURL:'string'}},
  IFCTENDON:{p:'IFCREINFORCINGELEMENT',a:{AnchorageSlip:'real',CrossSectionArea:'real',FrictionCoefficient:'real',MinCurvatureRadius:'real',NominalDiameter:'real',PreStress:'real',PredefinedType:'enum',TensionForce:'real'}},
  IFCTENDONANCHOR:{p:'IFCREINFORCINGELEMENT',a:{PredefinedType:'enum'}},
  IFCTENDONANCHORTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCTENDONCONDUIT:{p:'IFCREINFORCINGELEMENT',a:{PredefinedType:'enum'}},
  IFCTENDONCONDUITTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCTENDONTYPE:{p:'IFCREINFORCINGELEMENTTYPE',a:{CrossSectionArea:'real',NominalDiameter:'real',PredefinedType:'enum',SheathDiameter:'real'}},
  IFCTESSELLATEDFACESET:{p:'IFCTESSELLATEDITEM',a:{}},
  IFCTESSELLATEDITEM:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{}},
  IFCTEXTLITERAL:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Literal:'string',Path:'enum'}},
  IFCTEXTLITERALWITHEXTENT:{p:'IFCTEXTLITERAL',a:{BoxAlignment:'string'}},
  IFCTEXTSTYLE:{p:'IFCPRESENTATIONSTYLE',a:{ModelOrDraughting:'boolean'}},
  IFCTEXTSTYLEFONTMODEL:{p:'IFCPREDEFINEDTEXTFONT',a:{FontStyle:'string',FontVariant:'string',FontWeight:'string'}},
  IFCTEXTSTYLEFORDEFINEDFONT:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCTEXTSTYLETEXTMODEL:{p:'IFCPRESENTATIONITEM',a:{TextAlign:'string',TextDecoration:'string',TextTransform:'string'}},
  IFCTEXTURECOORDINATE:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCTEXTURECOORDINATEGENERATOR:{p:'IFCTEXTURECOORDINATE',a:{Mode:'string'}},
  IFCTEXTURECOORDINATEINDICESWITHVOIDS:{p:'IFCTEXTURECOORDINATEINDICES',a:{}},
  IFCTEXTUREMAP:{p:'IFCTEXTURECOORDINATE',a:{}},
  IFCTEXTUREVERTEX:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCTEXTUREVERTEXLIST:{p:'IFCPRESENTATIONITEM',a:{}},
  IFCTHIRDORDERPOLYNOMIALSPIRAL:{p:'IFCSPIRAL',a:{ConstantTerm:'real',CubicTerm:'real',LinearTerm:'real',QuadraticTerm:'real'}},
  IFCTIMEPERIOD:{p:null,a:{EndTime:'string',StartTime:'string'}},
  IFCTIMESERIES:{p:null,a:{DataOrigin:'enum',Description:'string',EndTime:'string',Name:'string',StartTime:'string',TimeSeriesDataType:'enum',UserDefinedDataOrigin:'string'}},
  IFCTOPOLOGICALREPRESENTATIONITEM:{p:'IFCREPRESENTATIONITEM',a:{}},
  IFCTOPOLOGYREPRESENTATION:{p:'IFCSHAPEMODEL',a:{}},
  IFCTOROIDALSURFACE:{p:'IFCELEMENTARYSURFACE',a:{MajorRadius:'real',MinorRadius:'real'}},
  IFCTRACKELEMENT:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCTRACKELEMENTTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCTRANSFORMER:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCTRANSFORMERTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTRANSPORTELEMENT:{p:'IFCTRANSPORTATIONDEVICE',a:{PredefinedType:'enum'}},
  IFCTRANSPORTELEMENTTYPE:{p:'IFCTRANSPORTATIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTRANSPORTATIONDEVICE:{p:'IFCELEMENT',a:{}},
  IFCTRANSPORTATIONDEVICETYPE:{p:'IFCELEMENTTYPE',a:{}},
  IFCTRAPEZIUMPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{BottomXDim:'real',TopXDim:'real',TopXOffset:'real',YDim:'real'}},
  IFCTRIANGULATEDFACESET:{p:'IFCTESSELLATEDFACESET',a:{Closed:'boolean'}},
  IFCTRIANGULATEDIRREGULARNETWORK:{p:'IFCTRIANGULATEDFACESET',a:{}},
  IFCTRIMMEDCURVE:{p:'IFCBOUNDEDCURVE',a:{MasterRepresentation:'enum',SenseAgreement:'boolean'}},
  IFCTUBEBUNDLE:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCTUBEBUNDLETYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCTYPEOBJECT:{p:'IFCOBJECTDEFINITION',a:{ApplicableOccurrence:'string'}},
  IFCTYPEPROCESS:{p:'IFCTYPEOBJECT',a:{Identification:'string',LongDescription:'string',ProcessType:'string'}},
  IFCTYPEPRODUCT:{p:'IFCTYPEOBJECT',a:{Tag:'string'}},
  IFCTYPERESOURCE:{p:'IFCTYPEOBJECT',a:{Identification:'string',LongDescription:'string',ResourceType:'string'}},
  IFCUSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',EdgeRadius:'real',FilletRadius:'real',FlangeSlope:'real',FlangeThickness:'real',FlangeWidth:'real',WebThickness:'real'}},
  IFCUNITARYCONTROLELEMENT:{p:'IFCDISTRIBUTIONCONTROLELEMENT',a:{PredefinedType:'enum'}},
  IFCUNITARYCONTROLELEMENTTYPE:{p:'IFCDISTRIBUTIONCONTROLELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCUNITARYEQUIPMENT:{p:'IFCENERGYCONVERSIONDEVICE',a:{PredefinedType:'enum'}},
  IFCUNITARYEQUIPMENTTYPE:{p:'IFCENERGYCONVERSIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCVALVE:{p:'IFCFLOWCONTROLLER',a:{PredefinedType:'enum'}},
  IFCVALVETYPE:{p:'IFCFLOWCONTROLLERTYPE',a:{PredefinedType:'enum'}},
  IFCVECTOR:{p:'IFCGEOMETRICREPRESENTATIONITEM',a:{Magnitude:'real'}},
  IFCVEHICLE:{p:'IFCTRANSPORTATIONDEVICE',a:{PredefinedType:'enum'}},
  IFCVEHICLETYPE:{p:'IFCTRANSPORTATIONDEVICETYPE',a:{PredefinedType:'enum'}},
  IFCVERTEX:{p:'IFCTOPOLOGICALREPRESENTATIONITEM',a:{}},
  IFCVERTEXLOOP:{p:'IFCLOOP',a:{}},
  IFCVERTEXPOINT:{p:'IFCVERTEX',a:{}},
  IFCVIBRATIONDAMPER:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCVIBRATIONDAMPERTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCVIBRATIONISOLATOR:{p:'IFCELEMENTCOMPONENT',a:{PredefinedType:'enum'}},
  IFCVIBRATIONISOLATORTYPE:{p:'IFCELEMENTCOMPONENTTYPE',a:{PredefinedType:'enum'}},
  IFCVIRTUALELEMENT:{p:'IFCELEMENT',a:{PredefinedType:'enum'}},
  IFCVOIDINGFEATURE:{p:'IFCFEATUREELEMENTSUBTRACTION',a:{PredefinedType:'enum'}},
  IFCWALL:{p:'IFCBUILTELEMENT',a:{PredefinedType:'enum'}},
  IFCWALLSTANDARDCASE:{p:'IFCWALL',a:{}},
  IFCWALLTYPE:{p:'IFCBUILTELEMENTTYPE',a:{PredefinedType:'enum'}},
  IFCWASTETERMINAL:{p:'IFCFLOWTERMINAL',a:{PredefinedType:'enum'}},
  IFCWASTETERMINALTYPE:{p:'IFCFLOWTERMINALTYPE',a:{PredefinedType:'enum'}},
  IFCWELLKNOWNTEXT:{p:null,a:{WellKnownText:'string'}},
  IFCWINDOW:{p:'IFCBUILTELEMENT',a:{OverallHeight:'real',OverallWidth:'real',PartitioningType:'enum',PredefinedType:'enum',UserDefinedPartitioningType:'string'}},
  IFCWINDOWLININGPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{FirstMullionOffset:'real',FirstTransomOffset:'real',LiningDepth:'real',LiningOffset:'real',LiningThickness:'real',LiningToPanelOffsetX:'real',LiningToPanelOffsetY:'real',MullionThickness:'real',SecondMullionOffset:'real',SecondTransomOffset:'real',TransomThickness:'real'}},
  IFCWINDOWPANELPROPERTIES:{p:'IFCPREDEFINEDPROPERTYSET',a:{FrameDepth:'real',FrameThickness:'real',OperationType:'enum',PanelPosition:'enum'}},
  IFCWINDOWTYPE:{p:'IFCBUILTELEMENTTYPE',a:{ParameterTakesPrecedence:'boolean',PartitioningType:'enum',PredefinedType:'enum',UserDefinedPartitioningType:'string'}},
  IFCWORKCALENDAR:{p:'IFCCONTROL',a:{PredefinedType:'enum'}},
  IFCWORKCONTROL:{p:'IFCCONTROL',a:{CreationDate:'string',Duration:'string',FinishTime:'string',Purpose:'string',StartTime:'string',TotalFloat:'string'}},
  IFCWORKPLAN:{p:'IFCWORKCONTROL',a:{PredefinedType:'enum'}},
  IFCWORKSCHEDULE:{p:'IFCWORKCONTROL',a:{PredefinedType:'enum'}},
  IFCWORKTIME:{p:'IFCSCHEDULINGTIME',a:{FinishDate:'string',StartDate:'string'}},
  IFCZSHAPEPROFILEDEF:{p:'IFCPARAMETERIZEDPROFILEDEF',a:{Depth:'real',EdgeRadius:'real',FilletRadius:'real',FlangeThickness:'real',FlangeWidth:'real',WebThickness:'real'}},
  IFCZONE:{p:'IFCSYSTEM',a:{LongName:'string'}},
}

export const IFC_ATTR_TYPES: Record<IfcAttrSchema, Table> = {
  IFC2X3: T2X3,
  IFC4: T4,
  IFC4X1: T4,
  IFC4X2: T4,
  IFC4X3: T4X3,
}
